/*! jQuery v1.11.0 | (c) 2005, 2014 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k="".trim,l={},m="1.11.0",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(n.isPlainObject(c)||(b=n.isArray(c)))?(b?(b=!1,f=a&&n.isArray(a)?a:[]):f=a&&n.isPlainObject(a)?a:{},g[d]=n.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray||function(a){return"array"===n.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){return a-parseFloat(a)>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||"object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;try{if(a.constructor&&!j.call(a,"constructor")&&!j.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}if(l.ownLast)for(b in a)return j.call(a,b);for(b in a);return void 0===b||j.call(a,b)},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(b){b&&n.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:k&&!k.call("\ufeff\xa0")?function(a){return null==a?"":k.call(a)}:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(g)return g.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(f=a[b],b=a,a=f),n.isFunction(a)?(c=d.call(arguments,2),e=function(){return a.apply(b||this,c.concat(d.call(arguments)))},e.guid=a.guid=a.guid||n.guid++,e):void 0},now:function(){return+new Date},support:l}),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s="sizzle"+-new Date,t=a.document,u=0,v=0,w=eb(),x=eb(),y=eb(),z=function(a,b){return a===b&&(j=!0),0},A="undefined",B=1<<31,C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=D.indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(this[b]===a)return b;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",M=L.replace("w","w#"),N="\\["+K+"*("+L+")"+K+"*(?:([*^$|!~]?=)"+K+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+M+")|)|)"+K+"*\\]",O=":("+L+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+N.replace(3,8)+")*)|.*)\\)|)",P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(O),U=new RegExp("^"+M+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L.replace("w","w*")+")"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=/'|\\/g,ab=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),bb=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)};try{G.apply(D=H.call(t.childNodes),t.childNodes),D[t.childNodes.length].nodeType}catch(cb){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function db(a,b,d,e){var f,g,h,i,j,m,p,q,u,v;if((b?b.ownerDocument||b:t)!==l&&k(b),b=b||l,d=d||[],!a||"string"!=typeof a)return d;if(1!==(i=b.nodeType)&&9!==i)return[];if(n&&!e){if(f=Z.exec(a))if(h=f[1]){if(9===i){if(g=b.getElementById(h),!g||!g.parentNode)return d;if(g.id===h)return d.push(g),d}else if(b.ownerDocument&&(g=b.ownerDocument.getElementById(h))&&r(b,g)&&g.id===h)return d.push(g),d}else{if(f[2])return G.apply(d,b.getElementsByTagName(a)),d;if((h=f[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(h)),d}if(c.qsa&&(!o||!o.test(a))){if(q=p=s,u=b,v=9===i&&a,1===i&&"object"!==b.nodeName.toLowerCase()){m=ob(a),(p=b.getAttribute("id"))?q=p.replace(_,"\\$&"):b.setAttribute("id",q),q="[id='"+q+"'] ",j=m.length;while(j--)m[j]=q+pb(m[j]);u=$.test(a)&&mb(b.parentNode)||b,v=m.join(",")}if(v)try{return G.apply(d,u.querySelectorAll(v)),d}catch(w){}finally{p||b.removeAttribute("id")}}}return xb(a.replace(P,"$1"),b,d,e)}function eb(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function fb(a){return a[s]=!0,a}function gb(a){var b=l.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function hb(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function ib(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||B)-(~a.sourceIndex||B);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function jb(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function kb(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function lb(a){return fb(function(b){return b=+b,fb(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function mb(a){return a&&typeof a.getElementsByTagName!==A&&a}c=db.support={},f=db.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},k=db.setDocument=function(a){var b,e=a?a.ownerDocument||a:t,g=e.defaultView;return e!==l&&9===e.nodeType&&e.documentElement?(l=e,m=e.documentElement,n=!f(e),g&&g!==g.top&&(g.addEventListener?g.addEventListener("unload",function(){k()},!1):g.attachEvent&&g.attachEvent("onunload",function(){k()})),c.attributes=gb(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=gb(function(a){return a.appendChild(e.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(e.getElementsByClassName)&&gb(function(a){return a.innerHTML="<div class='a'></div><div class='a i'></div>",a.firstChild.className="i",2===a.getElementsByClassName("i").length}),c.getById=gb(function(a){return m.appendChild(a).id=s,!e.getElementsByName||!e.getElementsByName(s).length}),c.getById?(d.find.ID=function(a,b){if(typeof b.getElementById!==A&&n){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ab,bb);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ab,bb);return function(a){var c=typeof a.getAttributeNode!==A&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return typeof b.getElementsByTagName!==A?b.getElementsByTagName(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return typeof b.getElementsByClassName!==A&&n?b.getElementsByClassName(a):void 0},p=[],o=[],(c.qsa=Y.test(e.querySelectorAll))&&(gb(function(a){a.innerHTML="<select t=''><option selected=''></option></select>",a.querySelectorAll("[t^='']").length&&o.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||o.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll(":checked").length||o.push(":checked")}),gb(function(a){var b=e.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&o.push("name"+K+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||o.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),o.push(",.*:")})),(c.matchesSelector=Y.test(q=m.webkitMatchesSelector||m.mozMatchesSelector||m.oMatchesSelector||m.msMatchesSelector))&&gb(function(a){c.disconnectedMatch=q.call(a,"div"),q.call(a,"[s!='']:x"),p.push("!=",O)}),o=o.length&&new RegExp(o.join("|")),p=p.length&&new RegExp(p.join("|")),b=Y.test(m.compareDocumentPosition),r=b||Y.test(m.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},z=b?function(a,b){if(a===b)return j=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===e||a.ownerDocument===t&&r(t,a)?-1:b===e||b.ownerDocument===t&&r(t,b)?1:i?I.call(i,a)-I.call(i,b):0:4&d?-1:1)}:function(a,b){if(a===b)return j=!0,0;var c,d=0,f=a.parentNode,g=b.parentNode,h=[a],k=[b];if(!f||!g)return a===e?-1:b===e?1:f?-1:g?1:i?I.call(i,a)-I.call(i,b):0;if(f===g)return ib(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)k.unshift(c);while(h[d]===k[d])d++;return d?ib(h[d],k[d]):h[d]===t?-1:k[d]===t?1:0},e):l},db.matches=function(a,b){return db(a,null,null,b)},db.matchesSelector=function(a,b){if((a.ownerDocument||a)!==l&&k(a),b=b.replace(S,"='$1']"),!(!c.matchesSelector||!n||p&&p.test(b)||o&&o.test(b)))try{var d=q.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return db(b,l,null,[a]).length>0},db.contains=function(a,b){return(a.ownerDocument||a)!==l&&k(a),r(a,b)},db.attr=function(a,b){(a.ownerDocument||a)!==l&&k(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!n):void 0;return void 0!==f?f:c.attributes||!n?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},db.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},db.uniqueSort=function(a){var b,d=[],e=0,f=0;if(j=!c.detectDuplicates,i=!c.sortStable&&a.slice(0),a.sort(z),j){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return i=null,a},e=db.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=db.selectors={cacheLength:50,createPseudo:fb,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ab,bb),a[3]=(a[4]||a[5]||"").replace(ab,bb),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||db.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&db.error(a[0]),a},PSEUDO:function(a){var b,c=!a[5]&&a[2];return V.CHILD.test(a[0])?null:(a[3]&&void 0!==a[4]?a[2]=a[4]:c&&T.test(c)&&(b=ob(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ab,bb).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=w[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&w(a,function(a){return b.test("string"==typeof a.className&&a.className||typeof a.getAttribute!==A&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=db.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),t=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&t){k=q[s]||(q[s]={}),j=k[a]||[],n=j[0]===u&&j[1],m=j[0]===u&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[u,n,m];break}}else if(t&&(j=(b[s]||(b[s]={}))[a])&&j[0]===u)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(t&&((l[s]||(l[s]={}))[a]=[u,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||db.error("unsupported pseudo: "+a);return e[s]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?fb(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I.call(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:fb(function(a){var b=[],c=[],d=g(a.replace(P,"$1"));return d[s]?fb(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),!c.pop()}}),has:fb(function(a){return function(b){return db(a,b).length>0}}),contains:fb(function(a){return function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:fb(function(a){return U.test(a||"")||db.error("unsupported lang: "+a),a=a.replace(ab,bb).toLowerCase(),function(b){var c;do if(c=n?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===m},focus:function(a){return a===l.activeElement&&(!l.hasFocus||l.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:lb(function(){return[0]}),last:lb(function(a,b){return[b-1]}),eq:lb(function(a,b,c){return[0>c?c+b:c]}),even:lb(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:lb(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:lb(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:lb(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=jb(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=kb(b);function nb(){}nb.prototype=d.filters=d.pseudos,d.setFilters=new nb;function ob(a,b){var c,e,f,g,h,i,j,k=x[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=Q.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?db.error(a):x(a,i).slice(0)}function pb(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function qb(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=v++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[u,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[s]||(b[s]={}),(h=i[d])&&h[0]===u&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function rb(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function sb(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function tb(a,b,c,d,e,f){return d&&!d[s]&&(d=tb(d)),e&&!e[s]&&(e=tb(e,f)),fb(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||wb(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:sb(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=sb(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I.call(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=sb(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ub(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],i=g||d.relative[" "],j=g?1:0,k=qb(function(a){return a===b},i,!0),l=qb(function(a){return I.call(b,a)>-1},i,!0),m=[function(a,c,d){return!g&&(d||c!==h)||((b=c).nodeType?k(a,c,d):l(a,c,d))}];f>j;j++)if(c=d.relative[a[j].type])m=[qb(rb(m),c)];else{if(c=d.filter[a[j].type].apply(null,a[j].matches),c[s]){for(e=++j;f>e;e++)if(d.relative[a[e].type])break;return tb(j>1&&rb(m),j>1&&pb(a.slice(0,j-1).concat({value:" "===a[j-2].type?"*":""})).replace(P,"$1"),c,e>j&&ub(a.slice(j,e)),f>e&&ub(a=a.slice(e)),f>e&&pb(a))}m.push(c)}return rb(m)}function vb(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,i,j,k){var m,n,o,p=0,q="0",r=f&&[],s=[],t=h,v=f||e&&d.find.TAG("*",k),w=u+=null==t?1:Math.random()||.1,x=v.length;for(k&&(h=g!==l&&g);q!==x&&null!=(m=v[q]);q++){if(e&&m){n=0;while(o=a[n++])if(o(m,g,i)){j.push(m);break}k&&(u=w)}c&&((m=!o&&m)&&p--,f&&r.push(m))}if(p+=q,c&&q!==p){n=0;while(o=b[n++])o(r,s,g,i);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=E.call(j));s=sb(s)}G.apply(j,s),k&&!f&&s.length>0&&p+b.length>1&&db.uniqueSort(j)}return k&&(u=w,h=t),r};return c?fb(f):f}g=db.compile=function(a,b){var c,d=[],e=[],f=y[a+" "];if(!f){b||(b=ob(a)),c=b.length;while(c--)f=ub(b[c]),f[s]?d.push(f):e.push(f);f=y(a,vb(e,d))}return f};function wb(a,b,c){for(var d=0,e=b.length;e>d;d++)db(a,b[d],c);return c}function xb(a,b,e,f){var h,i,j,k,l,m=ob(a);if(!f&&1===m.length){if(i=m[0]=m[0].slice(0),i.length>2&&"ID"===(j=i[0]).type&&c.getById&&9===b.nodeType&&n&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(ab,bb),b)||[])[0],!b)return e;a=a.slice(i.shift().value.length)}h=V.needsContext.test(a)?0:i.length;while(h--){if(j=i[h],d.relative[k=j.type])break;if((l=d.find[k])&&(f=l(j.matches[0].replace(ab,bb),$.test(i[0].type)&&mb(b.parentNode)||b))){if(i.splice(h,1),a=f.length&&pb(i),!a)return G.apply(e,f),e;break}}}return g(a,m)(f,b,!n,e,$.test(a)&&mb(b.parentNode)||b),e}return c.sortStable=s.split("").sort(z).join("")===s,c.detectDuplicates=!!j,k(),c.sortDetached=gb(function(a){return 1&a.compareDocumentPosition(l.createElement("div"))}),gb(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||hb("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&gb(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||hb("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),gb(function(a){return null==a.getAttribute("disabled")})||hb(J,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),db}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,w=/^.[^:#\[\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return n.inArray(a,b)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;e>b;b++)if(n.contains(d[b],this))return!0}));for(b=0;e>b;b++)n.find(a,d[b],c);return c=this.pushStack(e>1?n.unique(c):c),c.selector=this.selector?this.selector+" "+a:a,c},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,"string"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=a.document,A=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,B=n.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a.charAt(0)&&">"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:A.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:z,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}if(d=z.getElementById(c[2]),d&&d.parentNode){if(d.id!==c[2])return y.find(a);this.length=1,this[0]=d}return this.context=z,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};B.prototype=n.fn,y=n(z);var C=/^(?:parents|prev(?:Until|All))/,D={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=a[b];while(e&&9!==e.nodeType&&(void 0===c||1!==e.nodeType||!n(e).is(c)))1===e.nodeType&&d.push(e),e=e[b];return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b,c=n(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(n.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?"string"==typeof a?n.inArray(this[0],n(a)):n.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function E(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,"parentNode")},parentsUntil:function(a,b,c){return n.dir(a,"parentNode",c)},next:function(a){return E(a,"nextSibling")},prev:function(a){return E(a,"previousSibling")},nextAll:function(a){return n.dir(a,"nextSibling")},prevAll:function(a){return n.dir(a,"previousSibling")},nextUntil:function(a,b,c){return n.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return n.dir(a,"previousSibling",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return n.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(D[a]||(e=n.unique(e)),C.test(a)&&(e=e.reverse())),this.pushStack(e)}});var F=/\S+/g,G={};function H(a){var b=G[a]={};return n.each(a.match(F)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?G[a]||H(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(c=a.memory&&l,d=!0,f=g||0,g=0,e=h.length,b=!0;h&&e>f;f++)if(h[f].apply(l[0],l[1])===!1&&a.stopOnFalse){c=!1;break}b=!1,h&&(i?i.length&&j(i.shift()):c?h=[]:k.disable())},k={add:function(){if(h){var d=h.length;!function f(b){n.each(b,function(b,c){var d=n.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&f(c)})}(arguments),b?e=h.length:c&&(g=d,j(c))}return this},remove:function(){return h&&n.each(arguments,function(a,c){var d;while((d=n.inArray(c,h,d))>-1)h.splice(d,1),b&&(e>=d&&e--,f>=d&&f--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],e=0,this},disable:function(){return h=i=c=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,c||k.disable(),this},locked:function(){return!i},fireWith:function(a,c){return!h||d&&!i||(c=c||[],c=[a,c.slice?c.slice():c],b?i.push(c):j(c)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!d}};return k},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){if(a===!0?!--n.readyWait:!n.isReady){if(!z.body)return setTimeout(n.ready);n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(z,[n]),n.fn.trigger&&n(z).trigger("ready").off("ready"))}}});function J(){z.addEventListener?(z.removeEventListener("DOMContentLoaded",K,!1),a.removeEventListener("load",K,!1)):(z.detachEvent("onreadystatechange",K),a.detachEvent("onload",K))}function K(){(z.addEventListener||"load"===event.type||"complete"===z.readyState)&&(J(),n.ready())}n.ready.promise=function(b){if(!I)if(I=n.Deferred(),"complete"===z.readyState)setTimeout(n.ready);else if(z.addEventListener)z.addEventListener("DOMContentLoaded",K,!1),a.addEventListener("load",K,!1);else{z.attachEvent("onreadystatechange",K),a.attachEvent("onload",K);var c=!1;try{c=null==a.frameElement&&z.documentElement}catch(d){}c&&c.doScroll&&!function e(){if(!n.isReady){try{c.doScroll("left")}catch(a){return setTimeout(e,50)}J(),n.ready()}}()}return I.promise(b)};var L="undefined",M;for(M in n(l))break;l.ownLast="0"!==M,l.inlineBlockNeedsLayout=!1,n(function(){var a,b,c=z.getElementsByTagName("body")[0];c&&(a=z.createElement("div"),a.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",b=z.createElement("div"),c.appendChild(a).appendChild(b),typeof b.style.zoom!==L&&(b.style.cssText="border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1",(l.inlineBlockNeedsLayout=3===b.offsetWidth)&&(c.style.zoom=1)),c.removeChild(a),a=b=null)}),function(){var a=z.createElement("div");if(null==l.deleteExpando){l.deleteExpando=!0;try{delete a.test}catch(b){l.deleteExpando=!1}}a=null}(),n.acceptData=function(a){var b=n.noData[(a.nodeName+" ").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute("classid")===b};var N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){if(void 0===c&&1===a.nodeType){var d="data-"+b.replace(O,"-$1").toLowerCase();if(c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}n.data(a,b,c)}else c=void 0}return c}function Q(a){var b;for(b in a)if(("data"!==b||!n.isEmptyObject(a[b]))&&"toJSON"!==b)return!1;return!0}function R(a,b,d,e){if(n.acceptData(a)){var f,g,h=n.expando,i=a.nodeType,j=i?n.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||"string"!=typeof b)return k||(k=i?a[h]=c.pop()||n.guid++:h),j[k]||(j[k]=i?{}:{toJSON:n.noop}),("object"==typeof b||"function"==typeof b)&&(e?j[k]=n.extend(j[k],b):j[k].data=n.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[n.camelCase(b)]=d),"string"==typeof b?(f=g[b],null==f&&(f=g[n.camelCase(b)])):f=g,f
}}function S(a,b,c){if(n.acceptData(a)){var d,e,f=a.nodeType,g=f?n.cache:a,h=f?a[n.expando]:n.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){n.isArray(b)?b=b.concat(n.map(b,n.camelCase)):b in d?b=[b]:(b=n.camelCase(b),b=b in d?[b]:b.split(" ")),e=b.length;while(e--)delete d[b[e]];if(c?!Q(d):!n.isEmptyObject(d))return}(c||(delete g[h].data,Q(g[h])))&&(f?n.cleanData([a],!0):l.deleteExpando||g!=g.window?delete g[h]:g[h]=null)}}}n.extend({cache:{},noData:{"applet ":!0,"embed ":!0,"object ":"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(a){return a=a.nodeType?n.cache[a[n.expando]]:a[n.expando],!!a&&!Q(a)},data:function(a,b,c){return R(a,b,c)},removeData:function(a,b){return S(a,b)},_data:function(a,b,c){return R(a,b,c,!0)},_removeData:function(a,b){return S(a,b,!0)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=n.data(f),1===f.nodeType&&!n._data(f,"parsedAttrs"))){c=g.length;while(c--)d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d]));n._data(f,"parsedAttrs",!0)}return e}return"object"==typeof a?this.each(function(){n.data(this,a)}):arguments.length>1?this.each(function(){n.data(this,a,b)}):f?P(f,a,n.data(f,a)):void 0},removeData:function(a){return this.each(function(){n.removeData(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=n._data(a,b),c&&(!d||n.isArray(c)?d=n._data(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return n._data(a,c)||n._data(a,c,{empty:n.Callbacks("once memory").add(function(){n._removeData(a,b+"queue"),n._removeData(a,c)})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=n._data(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var T=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)},W=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},X=/^(?:checkbox|radio)$/i;!function(){var a=z.createDocumentFragment(),b=z.createElement("div"),c=z.createElement("input");if(b.setAttribute("className","t"),b.innerHTML="  <link/><table></table><a href='/a'>a</a>",l.leadingWhitespace=3===b.firstChild.nodeType,l.tbody=!b.getElementsByTagName("tbody").length,l.htmlSerialize=!!b.getElementsByTagName("link").length,l.html5Clone="<:nav></:nav>"!==z.createElement("nav").cloneNode(!0).outerHTML,c.type="checkbox",c.checked=!0,a.appendChild(c),l.appendChecked=c.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue,a.appendChild(b),b.innerHTML="<input type='radio' checked='checked' name='t'/>",l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,l.noCloneEvent=!0,b.attachEvent&&(b.attachEvent("onclick",function(){l.noCloneEvent=!1}),b.cloneNode(!0).click()),null==l.deleteExpando){l.deleteExpando=!0;try{delete b.test}catch(d){l.deleteExpando=!1}}a=b=c=null}(),function(){var b,c,d=z.createElement("div");for(b in{submit:!0,change:!0,focusin:!0})c="on"+b,(l[b+"Bubbles"]=c in a)||(d.setAttribute(c,"t"),l[b+"Bubbles"]=d.attributes[c].expando===!1);d=null}();var Y=/^(?:input|select|textarea)$/i,Z=/^key/,$=/^(?:mouse|contextmenu)|click/,_=/^(?:focusinfocus|focusoutblur)$/,ab=/^([^.]*)(?:\.(.+)|)$/;function bb(){return!0}function cb(){return!1}function db(){try{return z.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=n.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return typeof n===L||a&&n.event.triggered===a.type?void 0:n.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||"").match(F)||[""],h=b.length;while(h--)f=ab.exec(b[h])||[],o=q=f[1],p=(f[2]||"").split(".").sort(),o&&(j=n.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=n.event.special[o]||{},l=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},i),(m=g[o])||(m=g[o]=[],m.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent("on"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,l):m.push(l),n.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=n.hasData(a)&&n._data(a);if(r&&(k=r.events)){b=(b||"").match(F)||[""],j=b.length;while(j--)if(h=ab.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=k[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),i=f=m.length;while(f--)g=m[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&("**"!==d||!g.selector)||(m.splice(f,1),g.selector&&m.delegateCount--,l.remove&&l.remove.call(a,g));i&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(k)&&(delete r.handle,n._removeData(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,l,m,o=[d||z],p=j.call(b,"type")?b.type:b,q=j.call(b,"namespace")?b.namespace.split("."):[];if(h=l=d=d||z,3!==d.nodeType&&8!==d.nodeType&&!_.test(p+n.event.triggered)&&(p.indexOf(".")>=0&&(q=p.split("."),p=q.shift(),q.sort()),g=p.indexOf(":")<0&&"on"+p,b=b[n.expando]?b:new n.Event(p,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=q.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),k=n.event.special[p]||{},e||!k.trigger||k.trigger.apply(d,c)!==!1)){if(!e&&!k.noBubble&&!n.isWindow(d)){for(i=k.delegateType||p,_.test(i+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),l=h;l===(d.ownerDocument||z)&&o.push(l.defaultView||l.parentWindow||a)}m=0;while((h=o[m++])&&!b.isPropagationStopped())b.type=m>1?i:k.bindType||p,f=(n._data(h,"events")||{})[b.type]&&n._data(h,"handle"),f&&f.apply(h,c),f=g&&h[g],f&&f.apply&&n.acceptData(h)&&(b.result=f.apply(h,c),b.result===!1&&b.preventDefault());if(b.type=p,!e&&!b.isDefaultPrevented()&&(!k._default||k._default.apply(o.pop(),c)===!1)&&n.acceptData(d)&&g&&d[p]&&!n.isWindow(d)){l=d[g],l&&(d[g]=null),n.event.triggered=p;try{d[p]()}catch(r){}n.event.triggered=void 0,l&&(d[g]=l)}return b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(n._data(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,g=0;while((e=f.handlers[g++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(e.namespace))&&(a.handleObj=e,a.data=e.data,c=((n.event.special[e.origType]||{}).handle||e.handler).apply(f.elem,i),void 0!==c&&(a.result=c)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(e=[],f=0;h>f;f++)d=b[f],c=d.selector+" ",void 0===e[c]&&(e[c]=d.needsContext?n(c,this).index(i)>=0:n.find(c,this,null,[i]).length),e[c]&&e.push(d);e.length&&g.push({elem:i,handlers:e})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=$.test(e)?this.mouseHooks:Z.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=f.srcElement||z),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,g.filter?g.filter(a,f):a},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button,g=b.fromElement;return null==a.pageX&&null!=b.clientX&&(d=a.target.ownerDocument||z,e=d.documentElement,c=d.body,a.pageX=b.clientX+(e&&e.scrollLeft||c&&c.scrollLeft||0)-(e&&e.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||c&&c.scrollTop||0)-(e&&e.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&g&&(a.relatedTarget=g===a.target?b.toElement:g),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==db()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:"focusin"},blur:{trigger:function(){return this===db()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return n.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=z.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){var d="on"+b;a.detachEvent&&(typeof a[d]===L&&(a[d]=null),a.detachEvent(d,c))},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&(a.returnValue===!1||a.getPreventDefault&&a.getPreventDefault())?bb:cb):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:cb,isPropagationStopped:cb,isImmediatePropagationStopped:cb,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=bb,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=bb,a&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=bb,this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),l.submitBubbles||(n.event.special.submit={setup:function(){return n.nodeName(this,"form")?!1:void n.event.add(this,"click._submit keypress._submit",function(a){var b=a.target,c=n.nodeName(b,"input")||n.nodeName(b,"button")?b.form:void 0;c&&!n._data(c,"submitBubbles")&&(n.event.add(c,"submit._submit",function(a){a._submit_bubble=!0}),n._data(c,"submitBubbles",!0))})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&n.event.simulate("submit",this.parentNode,a,!0))},teardown:function(){return n.nodeName(this,"form")?!1:void n.event.remove(this,"._submit")}}),l.changeBubbles||(n.event.special.change={setup:function(){return Y.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(n.event.add(this,"propertychange._change",function(a){"checked"===a.originalEvent.propertyName&&(this._just_changed=!0)}),n.event.add(this,"click._change",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1),n.event.simulate("change",this,a,!0)})),!1):void n.event.add(this,"beforeactivate._change",function(a){var b=a.target;Y.test(b.nodeName)&&!n._data(b,"changeBubbles")&&(n.event.add(b,"change._change",function(a){!this.parentNode||a.isSimulated||a.isTrigger||n.event.simulate("change",this.parentNode,a,!0)}),n._data(b,"changeBubbles",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||"radio"!==b.type&&"checkbox"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return n.event.remove(this,"._change"),!Y.test(this.nodeName)}}),l.focusinBubbles||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=n._data(d,b);e||d.addEventListener(a,c,!0),n._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=n._data(d,b)-1;e?n._data(d,b,e):(d.removeEventListener(a,c,!0),n._removeData(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(f in a)this.on(f,b,c,a[f],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=cb;else if(!d)return this;return 1===e&&(g=d,d=function(a){return n().off(a),g.apply(this,arguments)},d.guid=g.guid||(g.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=cb),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});function eb(a){var b=fb.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}var fb="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",gb=/ jQuery\d+="(?:null|\d+)"/g,hb=new RegExp("<(?:"+fb+")[\\s/>]","i"),ib=/^\s+/,jb=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,kb=/<([\w:]+)/,lb=/<tbody/i,mb=/<|&#?\w+;/,nb=/<(?:script|style|link)/i,ob=/checked\s*(?:[^=]|=\s*.checked.)/i,pb=/^$|\/(?:java|ecma)script/i,qb=/^true\/(.*)/,rb=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,sb={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:l.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},tb=eb(z),ub=tb.appendChild(z.createElement("div"));sb.optgroup=sb.option,sb.tbody=sb.tfoot=sb.colgroup=sb.caption=sb.thead,sb.th=sb.td;function vb(a,b){var c,d,e=0,f=typeof a.getElementsByTagName!==L?a.getElementsByTagName(b||"*"):typeof a.querySelectorAll!==L?a.querySelectorAll(b||"*"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||n.nodeName(d,b)?f.push(d):n.merge(f,vb(d,b));return void 0===b||b&&n.nodeName(a,b)?n.merge([a],f):f}function wb(a){X.test(a.type)&&(a.defaultChecked=a.checked)}function xb(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function yb(a){return a.type=(null!==n.find.attr(a,"type"))+"/"+a.type,a}function zb(a){var b=qb.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Ab(a,b){for(var c,d=0;null!=(c=a[d]);d++)n._data(c,"globalEval",!b||n._data(b[d],"globalEval"))}function Bb(a,b){if(1===b.nodeType&&n.hasData(a)){var c,d,e,f=n._data(a),g=n._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)n.event.add(b,c,h[c][d])}g.data&&(g.data=n.extend({},g.data))}}function Cb(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!l.noCloneEvent&&b[n.expando]){e=n._data(b);for(d in e.events)n.removeEvent(b,d,e.handle);b.removeAttribute(n.expando)}"script"===c&&b.text!==a.text?(yb(b).text=a.text,zb(b)):"object"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),l.html5Clone&&a.innerHTML&&!n.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):"input"===c&&X.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):"option"===c?b.defaultSelected=b.selected=a.defaultSelected:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}}n.extend({clone:function(a,b,c){var d,e,f,g,h,i=n.contains(a.ownerDocument,a);if(l.html5Clone||n.isXMLDoc(a)||!hb.test("<"+a.nodeName+">")?f=a.cloneNode(!0):(ub.innerHTML=a.outerHTML,ub.removeChild(f=ub.firstChild)),!(l.noCloneEvent&&l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(d=vb(f),h=vb(a),g=0;null!=(e=h[g]);++g)d[g]&&Cb(e,d[g]);if(b)if(c)for(h=h||vb(a),d=d||vb(f),g=0;null!=(e=h[g]);g++)Bb(e,d[g]);else Bb(a,f);return d=vb(f,"script"),d.length>0&&Ab(d,!i&&vb(a,"script")),d=h=e=null,f},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k,m=a.length,o=eb(b),p=[],q=0;m>q;q++)if(f=a[q],f||0===f)if("object"===n.type(f))n.merge(p,f.nodeType?[f]:f);else if(mb.test(f)){h=h||o.appendChild(b.createElement("div")),i=(kb.exec(f)||["",""])[1].toLowerCase(),k=sb[i]||sb._default,h.innerHTML=k[1]+f.replace(jb,"<$1></$2>")+k[2],e=k[0];while(e--)h=h.lastChild;if(!l.leadingWhitespace&&ib.test(f)&&p.push(b.createTextNode(ib.exec(f)[0])),!l.tbody){f="table"!==i||lb.test(f)?"<table>"!==k[1]||lb.test(f)?0:h:h.firstChild,e=f&&f.childNodes.length;while(e--)n.nodeName(j=f.childNodes[e],"tbody")&&!j.childNodes.length&&f.removeChild(j)}n.merge(p,h.childNodes),h.textContent="";while(h.firstChild)h.removeChild(h.firstChild);h=o.lastChild}else p.push(b.createTextNode(f));h&&o.removeChild(h),l.appendChecked||n.grep(vb(p,"input"),wb),q=0;while(f=p[q++])if((!d||-1===n.inArray(f,d))&&(g=n.contains(f.ownerDocument,f),h=vb(o.appendChild(f),"script"),g&&Ab(h),c)){e=0;while(f=h[e++])pb.test(f.type||"")&&c.push(f)}return h=null,o},cleanData:function(a,b){for(var d,e,f,g,h=0,i=n.expando,j=n.cache,k=l.deleteExpando,m=n.event.special;null!=(d=a[h]);h++)if((b||n.acceptData(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)m[e]?n.event.remove(d,e):n.removeEvent(d,e,g.handle);j[f]&&(delete j[f],k?delete d[i]:typeof d.removeAttribute!==L?d.removeAttribute(i):d[i]=null,c.push(f))}}}),n.fn.extend({text:function(a){return W(this,function(a){return void 0===a?n.text(this):this.empty().append((this[0]&&this[0].ownerDocument||z).createTextNode(a))},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=xb(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=xb(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(vb(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&Ab(vb(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&n.cleanData(vb(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&n.nodeName(a,"select")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return W(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(gb,""):void 0;if(!("string"!=typeof a||nb.test(a)||!l.htmlSerialize&&hb.test(a)||!l.leadingWhitespace&&ib.test(a)||sb[(kb.exec(a)||["",""])[1].toLowerCase()])){a=a.replace(jb,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(vb(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(vb(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,k=this.length,m=this,o=k-1,p=a[0],q=n.isFunction(p);if(q||k>1&&"string"==typeof p&&!l.checkClone&&ob.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(k&&(i=n.buildFragment(a,this[0].ownerDocument,!1,this),c=i.firstChild,1===i.childNodes.length&&(i=c),c)){for(g=n.map(vb(i,"script"),yb),f=g.length;k>j;j++)d=i,j!==o&&(d=n.clone(d,!0,!0),f&&n.merge(g,vb(d,"script"))),b.call(this[j],d,j);if(f)for(h=g[g.length-1].ownerDocument,n.map(g,zb),j=0;f>j;j++)d=g[j],pb.test(d.type||"")&&!n._data(d,"globalEval")&&n.contains(h,d)&&(d.src?n._evalUrl&&n._evalUrl(d.src):n.globalEval((d.text||d.textContent||d.innerHTML||"").replace(rb,"")));i=c=null}return this}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=0,e=[],g=n(a),h=g.length-1;h>=d;d++)c=d===h?this:this.clone(!0),n(g[d])[b](c),f.apply(e,c.get());return this.pushStack(e)}});var Db,Eb={};function Fb(b,c){var d=n(c.createElement(b)).appendTo(c.body),e=a.getDefaultComputedStyle?a.getDefaultComputedStyle(d[0]).display:n.css(d[0],"display");return d.detach(),e}function Gb(a){var b=z,c=Eb[a];return c||(c=Fb(a,b),"none"!==c&&c||(Db=(Db||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=(Db[0].contentWindow||Db[0].contentDocument).document,b.write(),b.close(),c=Fb(a,b),Db.detach()),Eb[a]=c),c}!function(){var a,b,c=z.createElement("div"),d="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0";c.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",a=c.getElementsByTagName("a")[0],a.style.cssText="float:left;opacity:.5",l.opacity=/^0.5/.test(a.style.opacity),l.cssFloat=!!a.style.cssFloat,c.style.backgroundClip="content-box",c.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===c.style.backgroundClip,a=c=null,l.shrinkWrapBlocks=function(){var a,c,e,f;if(null==b){if(a=z.getElementsByTagName("body")[0],!a)return;f="border:0;width:0;height:0;position:absolute;top:0;left:-9999px",c=z.createElement("div"),e=z.createElement("div"),a.appendChild(c).appendChild(e),b=!1,typeof e.style.zoom!==L&&(e.style.cssText=d+";width:1px;padding:1px;zoom:1",e.innerHTML="<div></div>",e.firstChild.style.width="5px",b=3!==e.offsetWidth),a.removeChild(c),a=c=e=null}return b}}();var Hb=/^margin/,Ib=new RegExp("^("+T+")(?!px)[a-z%]+$","i"),Jb,Kb,Lb=/^(top|right|bottom|left)$/;a.getComputedStyle?(Jb=function(a){return a.ownerDocument.defaultView.getComputedStyle(a,null)},Kb=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Jb(a),g=c?c.getPropertyValue(b)||c[b]:void 0,c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),Ib.test(g)&&Hb.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0===g?g:g+""}):z.documentElement.currentStyle&&(Jb=function(a){return a.currentStyle},Kb=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Jb(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Ib.test(g)&&!Lb.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left="fontSize"===b?"1em":g,g=h.pixelLeft+"px",h.left=d,f&&(e.left=f)),void 0===g?g:g+""||"auto"});function Mb(a,b){return{get:function(){var c=a();if(null!=c)return c?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d,e,f,g,h=z.createElement("div"),i="border:0;width:0;height:0;position:absolute;top:0;left:-9999px",j="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0";h.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",b=h.getElementsByTagName("a")[0],b.style.cssText="float:left;opacity:.5",l.opacity=/^0.5/.test(b.style.opacity),l.cssFloat=!!b.style.cssFloat,h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,b=h=null,n.extend(l,{reliableHiddenOffsets:function(){if(null!=c)return c;var a,b,d,e=z.createElement("div"),f=z.getElementsByTagName("body")[0];if(f)return e.setAttribute("className","t"),e.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",a=z.createElement("div"),a.style.cssText=i,f.appendChild(a).appendChild(e),e.innerHTML="<table><tr><td></td><td>t</td></tr></table>",b=e.getElementsByTagName("td"),b[0].style.cssText="padding:0;margin:0;border:0;display:none",d=0===b[0].offsetHeight,b[0].style.display="",b[1].style.display="none",c=d&&0===b[0].offsetHeight,f.removeChild(a),e=f=null,c},boxSizing:function(){return null==d&&k(),d},boxSizingReliable:function(){return null==e&&k(),e},pixelPosition:function(){return null==f&&k(),f},reliableMarginRight:function(){var b,c,d,e;if(null==g&&a.getComputedStyle){if(b=z.getElementsByTagName("body")[0],!b)return;c=z.createElement("div"),d=z.createElement("div"),c.style.cssText=i,b.appendChild(c).appendChild(d),e=d.appendChild(z.createElement("div")),e.style.cssText=d.style.cssText=j,e.style.marginRight=e.style.width="0",d.style.width="1px",g=!parseFloat((a.getComputedStyle(e,null)||{}).marginRight),b.removeChild(c)}return g}});function k(){var b,c,h=z.getElementsByTagName("body")[0];h&&(b=z.createElement("div"),c=z.createElement("div"),b.style.cssText=i,h.appendChild(b).appendChild(c),c.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;display:block;padding:1px;border:1px;width:4px;margin-top:1%;top:1%",n.swap(h,null!=h.style.zoom?{zoom:1}:{},function(){d=4===c.offsetWidth}),e=!0,f=!1,g=!0,a.getComputedStyle&&(f="1%"!==(a.getComputedStyle(c,null)||{}).top,e="4px"===(a.getComputedStyle(c,null)||{width:"4px"}).width),h.removeChild(b),c=h=null)}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var Nb=/alpha\([^)]*\)/i,Ob=/opacity\s*=\s*([^)]*)/,Pb=/^(none|table(?!-c[ea]).+)/,Qb=new RegExp("^("+T+")(.*)$","i"),Rb=new RegExp("^([+-])=("+T+")","i"),Sb={position:"absolute",visibility:"hidden",display:"block"},Tb={letterSpacing:0,fontWeight:400},Ub=["Webkit","O","Moz","ms"];function Vb(a,b){if(b in a)return b;var c=b.charAt(0).toUpperCase()+b.slice(1),d=b,e=Ub.length;while(e--)if(b=Ub[e]+c,b in a)return b;return d}function Wb(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=n._data(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=n._data(d,"olddisplay",Gb(d.nodeName)))):f[g]||(e=V(d),(c&&"none"!==c||!e)&&n._data(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}function Xb(a,b,c){var d=Qb.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Yb(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Zb(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Jb(a),g=l.boxSizing()&&"border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Kb(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ib.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Yb(a,b,c||(g?"border":"content"),d,f)+"px"}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Kb(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":l.cssFloat?"cssFloat":"styleFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;if(b=n.cssProps[h]||(n.cssProps[h]=Vb(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c)return g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,"string"===f&&(e=Rb.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||n.cssNumber[h]||(c+="px"),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),!(g&&"set"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]="",i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Vb(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Kb(a,b,d)),"normal"===f&&b in Tb&&(f=Tb[b]),""===c||c?(e=parseFloat(f),c===!0||n.isNumeric(e)?e||0:f):f}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?0===a.offsetWidth&&Pb.test(n.css(a,"display"))?n.swap(a,Sb,function(){return Zb(a,b,d)}):Zb(a,b,d):void 0},set:function(a,c,d){var e=d&&Jb(a);return Xb(a,c,d?Yb(a,b,d,l.boxSizing()&&"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),l.opacity||(n.cssHooks.opacity={get:function(a,b){return Ob.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=n.isNumeric(b)?"alpha(opacity="+100*b+")":"",f=d&&d.filter||c.filter||"";c.zoom=1,(b>=1||""===b)&&""===n.trim(f.replace(Nb,""))&&c.removeAttribute&&(c.removeAttribute("filter"),""===b||d&&!d.filter)||(c.filter=Nb.test(f)?f.replace(Nb,e):f+" "+e)}}),n.cssHooks.marginRight=Mb(l.reliableMarginRight,function(a,b){return b?n.swap(a,{display:"inline-block"},Kb,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Hb.test(a)||(n.cssHooks[a+b].set=Xb)}),n.fn.extend({css:function(a,b){return W(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Jb(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)
},a,b,arguments.length>1)},show:function(){return Wb(this,!0)},hide:function(){return Wb(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function $b(a,b,c,d,e){return new $b.prototype.init(a,b,c,d,e)}n.Tween=$b,$b.prototype={constructor:$b,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=$b.propHooks[this.prop];return a&&a.get?a.get(this):$b.propHooks._default.get(this)},run:function(a){var b,c=$b.propHooks[this.prop];return this.pos=b=this.options.duration?n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):$b.propHooks._default.set(this),this}},$b.prototype.init.prototype=$b.prototype,$b.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},$b.propHooks.scrollTop=$b.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=$b.prototype.init,n.fx.step={};var _b,ac,bc=/^(?:toggle|show|hide)$/,cc=new RegExp("^(?:([+-])=|)("+T+")([a-z%]*)$","i"),dc=/queueHooks$/,ec=[jc],fc={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=cc.exec(b),f=e&&e[3]||(n.cssNumber[a]?"":"px"),g=(n.cssNumber[a]||"px"!==f&&+d)&&cc.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function gc(){return setTimeout(function(){_b=void 0}),_b=n.now()}function hc(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=U[e],d["margin"+c]=d["padding"+c]=a;return b&&(d.opacity=d.width=a),d}function ic(a,b,c){for(var d,e=(fc[b]||[]).concat(fc["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function jc(a,b,c){var d,e,f,g,h,i,j,k,m=this,o={},p=a.style,q=a.nodeType&&V(a),r=n._data(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,m.always(function(){m.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=n.css(a,"display"),k=Gb(a.nodeName),"none"===j&&(j=k),"inline"===j&&"none"===n.css(a,"float")&&(l.inlineBlockNeedsLayout&&"inline"!==k?p.zoom=1:p.display="inline-block")),c.overflow&&(p.overflow="hidden",l.shrinkWrapBlocks()||m.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],bc.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(q?"hide":"show")){if("show"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||n.style(a,d)}if(!n.isEmptyObject(o)){r?"hidden"in r&&(q=r.hidden):r=n._data(a,"fxshow",{}),f&&(r.hidden=!q),q?n(a).show():m.done(function(){n(a).hide()}),m.done(function(){var b;n._removeData(a,"fxshow");for(b in o)n.style(a,b,o[b])});for(d in o)g=ic(q?r[d]:0,d,m),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function kc(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function lc(a,b,c){var d,e,f=0,g=ec.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=_b||gc(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:_b||gc(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(kc(k,j.opts.specialEasing);g>f;f++)if(d=ec[f].call(j,a,k,j.opts))return d;return n.map(k,ic,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(lc,{tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],fc[c]=fc[c]||[],fc[c].unshift(b)},prefilter:function(a,b){b?ec.unshift(a):ec.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=lc(this,n.extend({},a),f);(e||n._data(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=n._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&dc.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=n._data(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(hc(b,!0),a,d,e)}}),n.each({slideDown:hc("show"),slideUp:hc("hide"),slideToggle:hc("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=n.timers,c=0;for(_b=n.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||n.fx.stop(),_b=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){ac||(ac=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(ac),ac=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a,b,c,d,e=z.createElement("div");e.setAttribute("className","t"),e.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",a=e.getElementsByTagName("a")[0],c=z.createElement("select"),d=c.appendChild(z.createElement("option")),b=e.getElementsByTagName("input")[0],a.style.cssText="top:1px",l.getSetAttribute="t"!==e.className,l.style=/top/.test(a.getAttribute("style")),l.hrefNormalized="/a"===a.getAttribute("href"),l.checkOn=!!b.value,l.optSelected=d.selected,l.enctype=!!z.createElement("form").enctype,c.disabled=!0,l.optDisabled=!d.disabled,b=z.createElement("input"),b.setAttribute("value",""),l.input=""===b.getAttribute("value"),b.value="t",b.setAttribute("type","radio"),l.radioValue="t"===b.value,a=b=c=d=e=null}();var mc=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(mc,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.text(a)}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(l.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)if(d=e[g],n.inArray(n.valHooks.option.get(d),f)>=0)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var nc,oc,pc=n.expr.attrHandle,qc=/^(?:checked|selected)$/i,rc=l.getSetAttribute,sc=l.input;n.fn.extend({attr:function(a,b){return W(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===L?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?oc:nc)),void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void n.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(F);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)?sc&&rc||!qc.test(c)?a[d]=!1:a[n.camelCase("default-"+c)]=a[d]=!1:n.attr(a,c,""),a.removeAttribute(rc?c:d)},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),oc={set:function(a,b,c){return b===!1?n.removeAttr(a,c):sc&&rc||!qc.test(c)?a.setAttribute(!rc&&n.propFix[c]||c,c):a[n.camelCase("default-"+c)]=a[c]=!0,c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=pc[b]||n.find.attr;pc[b]=sc&&rc||!qc.test(b)?function(a,b,d){var e,f;return d||(f=pc[b],pc[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,pc[b]=f),e}:function(a,b,c){return c?void 0:a[n.camelCase("default-"+b)]?b.toLowerCase():null}}),sc&&rc||(n.attrHooks.value={set:function(a,b,c){return n.nodeName(a,"input")?void(a.defaultValue=b):nc&&nc.set(a,b,c)}}),rc||(nc={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+="","value"===c||b===a.getAttribute(c)?b:void 0}},pc.id=pc.name=pc.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&""!==d.value?d.value:null},n.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:nc.set},n.attrHooks.contenteditable={set:function(a,b,c){nc.set(a,""===b?!1:b,c)}},n.each(["width","height"],function(a,b){n.attrHooks[b]={set:function(a,c){return""===c?(a.setAttribute(b,"auto"),c):void 0}}})),l.style||(n.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+""}});var tc=/^(?:input|select|textarea|button|object)$/i,uc=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return W(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return a=n.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),n.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):tc.test(a.nodeName)||uc.test(a.nodeName)&&a.href?0:-1}}}}),l.hrefNormalized||n.each(["href","src"],function(a,b){n.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this}),l.enctype||(n.propFix.enctype="encoding");var vc=/[\t\r\n\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j="string"==typeof a&&a;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(F)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(vc," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j=0===arguments.length||"string"==typeof a&&a;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(j)for(b=(a||"").match(F)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(vc," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?n.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=n(this),f=a.match(F)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===L||"boolean"===c)&&(this.className&&n._data(this,"__className__",this.className),this.className=this.className||a===!1?"":n._data(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(vc," ").indexOf(b)>=0)return!0;return!1}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var wc=n.now(),xc=/\?/,yc=/(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;n.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+"");var c,d=null,e=n.trim(b+"");return e&&!n.trim(e.replace(yc,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,"")}))?Function("return "+e)():n.error("Invalid JSON: "+b)},n.parseXML=function(b){var c,d;if(!b||"string"!=typeof b)return null;try{a.DOMParser?(d=new DOMParser,c=d.parseFromString(b,"text/xml")):(c=new ActiveXObject("Microsoft.XMLDOM"),c.async="false",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var zc,Ac,Bc=/#.*$/,Cc=/([?&])_=[^&]*/,Dc=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Ec=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Fc=/^(?:GET|HEAD)$/,Gc=/^\/\//,Hc=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,Ic={},Jc={},Kc="*/".concat("*");try{Ac=location.href}catch(Lc){Ac=z.createElement("a"),Ac.href="",Ac=Ac.href}zc=Hc.exec(Ac.toLowerCase())||[];function Mc(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(F)||[];if(n.isFunction(c))while(d=f[e++])"+"===d.charAt(0)?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Nc(a,b,c,d){var e={},f=a===Jc;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Oc(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&n.extend(!0,a,c),a}function Pc(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader("Content-Type"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+" "+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Qc(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ac,type:"GET",isLocal:Ec.test(zc[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Kc,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Oc(Oc(a,n.ajaxSettings),b):Oc(n.ajaxSettings,a)},ajaxPrefilter:Mc(Ic),ajaxTransport:Mc(Jc),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!j){j={};while(b=Dc.exec(f))j[b[1].toLowerCase()]=b[2]}b=j[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?f:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return i&&i.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||Ac)+"").replace(Bc,"").replace(Gc,zc[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||"*").toLowerCase().match(F)||[""],null==k.crossDomain&&(c=Hc.exec(k.url.toLowerCase()),k.crossDomain=!(!c||c[1]===zc[1]&&c[2]===zc[2]&&(c[3]||("http:"===c[1]?"80":"443"))===(zc[3]||("http:"===zc[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),Nc(Ic,k,b,v),2===t)return v;h=k.global,h&&0===n.active++&&n.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!Fc.test(k.type),e=k.url,k.hasContent||(k.data&&(e=k.url+=(xc.test(e)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=Cc.test(e)?e.replace(Cc,"$1_="+wc++):e+(xc.test(e)?"&":"?")+"_="+wc++)),k.ifModified&&(n.lastModified[e]&&v.setRequestHeader("If-Modified-Since",n.lastModified[e]),n.etag[e]&&v.setRequestHeader("If-None-Match",n.etag[e])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+Kc+"; q=0.01":""):k.accepts["*"]);for(d in k.headers)v.setRequestHeader(d,k.headers[d]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(d in{success:1,error:1,complete:1})v[d](k[d]);if(i=Nc(Jc,k,b,v)){v.readyState=1,h&&m.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,i.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,c,d){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),i=void 0,f=d||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,c&&(u=Pc(k,v,c)),u=Qc(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(n.lastModified[e]=w),w=v.getResponseHeader("etag"),w&&(n.etag[e]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,h&&m.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),h&&(m.trigger("ajaxComplete",[v,k]),--n.active||n.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){if(n.isFunction(a))return this.each(function(b){n(this).wrapAll(a.call(this,b))});if(this[0]){var b=n(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0||!l.reliableHiddenOffsets()&&"none"===(a.style&&a.style.display||n.css(a,"display"))},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var Rc=/%20/g,Sc=/\[\]$/,Tc=/\r?\n/g,Uc=/^(?:submit|button|image|reset|file)$/i,Vc=/^(?:input|select|textarea|keygen)/i;function Wc(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Sc.test(a)?d(a,e):Wc(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Wc(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Wc(c,a[c],b,e);return d.join("&").replace(Rc,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Vc.test(this.nodeName)&&!Uc.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Tc,"\r\n")}}):{name:b.name,value:c.replace(Tc,"\r\n")}}).get()}}),n.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return!this.isLocal&&/^(get|post|head|put|delete|options)$/i.test(this.type)&&$c()||_c()}:$c;var Xc=0,Yc={},Zc=n.ajaxSettings.xhr();a.ActiveXObject&&n(a).on("unload",function(){for(var a in Yc)Yc[a](void 0,!0)}),l.cors=!!Zc&&"withCredentials"in Zc,Zc=l.ajax=!!Zc,Zc&&n.ajaxTransport(function(a){if(!a.crossDomain||l.cors){var b;return{send:function(c,d){var e,f=a.xhr(),g=++Xc;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)void 0!==c[e]&&f.setRequestHeader(e,c[e]+"");f.send(a.hasContent&&a.data||null),b=function(c,e){var h,i,j;if(b&&(e||4===f.readyState))if(delete Yc[g],b=void 0,f.onreadystatechange=n.noop,e)4!==f.readyState&&f.abort();else{j={},h=f.status,"string"==typeof f.responseText&&(j.text=f.responseText);try{i=f.statusText}catch(k){i=""}h||!a.isLocal||a.crossDomain?1223===h&&(h=204):h=j.text?200:404}j&&d(h,i,j,f.getAllResponseHeaders())},a.async?4===f.readyState?setTimeout(b):f.onreadystatechange=Yc[g]=b:b()},abort:function(){b&&b(void 0,!0)}}}});function $c(){try{return new a.XMLHttpRequest}catch(b){}}function _c(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c=z.head||n("head")[0]||z.documentElement;return{send:function(d,e){b=z.createElement("script"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||e(200,"success"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var ad=[],bd=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=ad.pop()||n.expando+"_"+wc++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(bd.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&bd.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(bd,"$1"+e):b.jsonp!==!1&&(b.url+=(xc.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,ad.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||z;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var cd=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&cd)return cd.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=a.slice(h,a.length),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(f="POST"),g.length>0&&n.ajax({url:a,type:f,dataType:"html",data:b}).done(function(a){e=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,e||[a.responseText,b,a])}),this},n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var dd=a.document.documentElement;function ed(a){return n.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&n.inArray("auto",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,n.contains(b,e)?(typeof e.getBoundingClientRect!==L&&(d=e.getBoundingClientRect()),c=ed(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return"fixed"===n.css(d,"position")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(c=a.offset()),c.top+=n.css(a[0],"borderTopWidth",!0),c.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-c.top-n.css(d,"marginTop",!0),left:b.left-c.left-n.css(d,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||dd;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||dd})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c=/Y/.test(b);n.fn[a]=function(d){return W(this,function(a,d,e){var f=ed(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?n(f).scrollLeft():e,c?e:n(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Mb(l.pixelPosition,function(a,c){return c?(c=Kb(a,b),Ib.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return W(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var fd=a.jQuery,gd=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=gd),b&&a.jQuery===n&&(a.jQuery=fd),n},typeof b===L&&(a.jQuery=a.$=n),n});



!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

window.theme = window.theme || {};

    /* ================ SLATE ================ */
    window.theme = window.theme || {};

    theme.Sections = function Sections() {
      this.constructors = {};
      this.instances = [];

      document.addEventListener(
        'shopify:section:load',
        this._onSectionLoad.bind(this)
      );
      document.addEventListener(
        'shopify:section:unload',
        this._onSectionUnload.bind(this)
      );
      document.addEventListener(
        'shopify:section:select',
        this._onSelect.bind(this)
      );
      document.addEventListener(
        'shopify:section:deselect',
        this._onDeselect.bind(this)
      );
      document.addEventListener(
        'shopify:block:select',
        this._onBlockSelect.bind(this)
      );
      document.addEventListener(
        'shopify:block:deselect',
        this._onBlockDeselect.bind(this)
      );
    };

    theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
      _createInstance: function(container, constructor) {
        var id = container.getAttribute('data-section-id');
        var type = container.getAttribute('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });

        this.instances.push(instance);
      },

      _onSectionLoad: function(evt) {
        var container = document.querySelector(
          '[data-section-id="' + evt.detail.sectionId + '"]'
        );

        if (container) {
          this._createInstance(container);
        }
      },

      _onSectionUnload: function(evt) {
        this.instances = this.instances.filter(function(instance) {
          var isEventInstance = instance.id === evt.detail.sectionId;

          if (isEventInstance) {
            if (typeof instance.onUnload === 'function') {
              instance.onUnload(evt);
            }
          }

          return !isEventInstance;
        });
      },

      _onSelect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
          return instance.id === evt.detail.sectionId;
        });

        if (
          typeof instance !== 'undefined' &&
          typeof instance.onSelect === 'function'
        ) {
          instance.onSelect(evt);
        }
      },

      _onDeselect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
          return instance.id === evt.detail.sectionId;
        });

        if (
          typeof instance !== 'undefined' &&
          typeof instance.onDeselect === 'function'
        ) {
          instance.onDeselect(evt);
        }
      },

      _onBlockSelect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
          return instance.id === evt.detail.sectionId;
        });

        if (
          typeof instance !== 'undefined' &&
          typeof instance.onBlockSelect === 'function'
        ) {
          instance.onBlockSelect(evt);
        }
      },

      _onBlockDeselect: function(evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function(instance) {
          return instance.id === evt.detail.sectionId;
        });

        if (
          typeof instance !== 'undefined' &&
          typeof instance.onBlockDeselect === 'function'
        ) {
          instance.onBlockDeselect(evt);
        }
      },

      register: function(type, constructor) {
        this.constructors[type] = constructor;

        document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
          function(container) {
            this._createInstance(container, constructor);
          }.bind(this)
        );
      }
    });

    window.slate = window.slate || {};

    /**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

    slate.utils = {
      /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
      getParameterByName: function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },

      resizeSelects: function(selects) {
        selects.forEach(function(select) {
          var arrowWidth = 55;

          var test = document.createElement('span');
          test.innerHTML = select.selectedOptions[0].label;

          document.querySelector('.site-footer').appendChild(test);

          var width = test.offsetWidth + arrowWidth;
          test.remove();

          select.style.width = width + 'px';
        });
      },

      keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
      }
    };

    window.slate = window.slate || {};

    /**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

    slate.rte = {
      /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
      wrapTable: function(options) {
        options.tables.forEach(function(table) {
          var wrapper = document.createElement('div');
          wrapper.classList.add(options.tableWrapperClass);

          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });
      },

      /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
      wrapIframe: function(options) {
        options.iframes.forEach(function(iframe) {
          var wrapper = document.createElement('div');
          wrapper.classList.add(options.iframeWrapperClass);

          iframe.parentNode.insertBefore(wrapper, iframe);
          wrapper.appendChild(iframe);

          iframe.src = iframe.src;
        });
      }
    };

    window.slate = window.slate || {};

    /**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

    slate.a11y = {
      state: {
        firstFocusable: null,
        lastFocusable: null
      },
      /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
      pageLinkFocus: function(element) {
        if (!element) return;
        var focusClass = 'js-focus-hidden';

        element.setAttribute('tabIndex', '-1');
        element.focus();
        element.classList.add(focusClass);
        element.addEventListener('blur', callback, { once: true });

        function callback() {
          element.classList.remove(focusClass);
          element.removeAttribute('tabindex');
        }
      },

      /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
      trapFocus: function(options) {
        var focusableElements = Array.from(
          options.container.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
          )
        ).filter(function(element) {
          var width = element.offsetWidth;
          var height = element.offsetHeight;

          return (
            width !== 0 &&
            height !== 0 &&
            getComputedStyle(element).getPropertyValue('display') !== 'none'
          );
        });

        this.state.firstFocusable = focusableElements[0];
        this.state.lastFocusable = focusableElements[focusableElements.length - 1];

        if (!options.elementToFocus) {
          options.elementToFocus = options.container;
        }

        options.container.setAttribute('tabindex', '-1');
        options.elementToFocus.focus();

        this._setupHandlers();

        document.addEventListener('focusin', this._onFocusInHandler);
        document.addEventListener('focusout', this._onFocusOutHandler);
      },

      _setupHandlers: function() {
        if (!this._onFocusInHandler) {
          this._onFocusInHandler = this._onFocusIn.bind(this);
        }

        if (!this._onFocusOutHandler) {
          this._onFocusOutHandler = this._onFocusIn.bind(this);
        }

        if (!this._manageFocusHandler) {
          this._manageFocusHandler = this._manageFocus.bind(this);
        }
      },

      _onFocusOut: function() {
        document.removeEventListener('keydown', this._manageFocusHandler);
      },

      _onFocusIn: function(evt) {
        if (
          evt.target !== this.state.lastFocusable &&
          evt.target !== this.state.firstFocusable
        )
          return;

        document.addEventListener('keydown', this._manageFocusHandler);
      },

      _manageFocus: function(evt) {
        if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

        /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
        if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          this.state.firstFocusable.focus();
        }
        /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
        if (evt.target === this.state.firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          this.state.lastFocusable.focus();
        }
      },

      /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
      removeTrapFocus: function(options) {
        if (options.container) {
          options.container.removeAttribute('tabindex');
        }
        document.removeEventListener('focusin', this._onFocusInHandler);
      },

      /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
      accessibleLinks: function(options) {
        var body = document.querySelector('body');

        var idSelectors = {
          newWindow: 'a11y-new-window-message',
          external: 'a11y-external-message',
          newWindowExternal: 'a11y-new-window-external-message'
        };

        if (options.links === undefined || !options.links.length) {
          options.links = document.querySelectorAll(
            'a[href]:not([aria-describedby])'
          );
        }

        function generateHTML(customMessages) {
          if (typeof customMessages !== 'object') {
            customMessages = {};
          }

          var messages = Object.assign(
            {
              newWindow: 'Opens in a new window.',
              external: 'Opens external website.',
              newWindowExternal: 'Opens external website in a new window.'
            },
            customMessages
          );

          var container = document.createElement('ul');
          var htmlMessages = '';

          for (var message in messages) {
            htmlMessages +=
              '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
          }

          container.setAttribute('hidden', true);
          container.innerHTML = htmlMessages;

          body.appendChild(container);
        }

        function _externalSite(link) {
          var hostname = window.location.hostname;

          return link.hostname !== hostname;
        }

        options.links.forEach(function(link) {
          var target = link.getAttribute('target');
          var rel = link.getAttribute('rel');
          var isExternal = _externalSite(link);
          var isTargetBlank = target === '_blank';

          if (isExternal) {
            link.setAttribute('aria-describedby', idSelectors.external);
          }

          if (isTargetBlank) {
            if (!rel || rel.indexOf('noopener') === -1) {
              var relValue = rel === undefined ? '' : rel + ' ';
              relValue = relValue + 'noopener';
              link.setAttribute('rel', relValue);
            }

            link.setAttribute('aria-describedby', idSelectors.newWindow);
          }

          if (isExternal && isTargetBlank) {
            link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
          }
        });

        generateHTML(options.messages);
      }
    };

    /**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

    theme.Images = (function() {
      /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

      function preload(images, size) {
        if (typeof images === 'string') {
          images = [images];
        }

        for (var i = 0; i < images.length; i++) {
          var image = images[i];
          this.loadImage(this.getSizedImageUrl(image, size));
        }
      }

      /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
      function loadImage(path) {
        new Image().src = path;
      }

      /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
      function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);

        if (callback) {
          callback(imageUrl, image, element); // eslint-disable-line callback-return
        } else {
          element.src = imageUrl;
        }
      }

      /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
      function imageSize(src) {
        var match = src.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );

        if (match !== null) {
          if (match[2] !== undefined) {
            return match[1] + match[2];
          } else {
            return match[1];
          }
        } else {
          return null;
        }
      }

      /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return this.removeProtocol(src);
        }

        var match = src.match(
          /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match !== null) {
          var prefix = src.split(match[0]);
          var suffix = match[0];

          return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }

        return null;
      }

      function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
      }

      return {
        preload: preload,
        loadImage: loadImage,
        switchImage: switchImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
      };
    })();

    /**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

    theme.Currency = (function() {
      var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.');
          var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : '';

          return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }

      return {
        formatMoney: formatMoney
      };
    })();

    /**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

    slate.Variants = (function() {
      /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
      function Variants(options) {
        this.container = options.container;
        this.product = options.product;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.singleOptions = this.container.querySelectorAll(
          options.singleOptionSelector
        );
        this.currentVariant = this._getVariantFromOptions();

        this.singleOptions.forEach(
          function(option) {
            option.addEventListener('change', this._onSelectChange.bind(this));
          }.bind(this)
        );
      }

      Variants.prototype = Object.assign({}, Variants.prototype, {
        /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
        _getCurrentOptions: function() {
          var result = [];

          this.singleOptions.forEach(function(option) {
            var type = option.getAttribute('type');
            var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

            if (!isRadioOrCheckbox || option.checked) {
              result.push({
                value: option.value,
                index: option.getAttribute('data-index')
              });
            }
          });

          return result;
        },

        /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
        _getVariantFromOptions: function() {
          var selectedValues = this._getCurrentOptions();
          var variants = this.product.variants;

          var found = variants.find(function(variant) {
            return selectedValues.every(function(values) {
              return variant[values.index] === values.value;
            });
          });

          return found;
        },

        /**
     * Event handler for when a variant input changes.
     */
        _onSelectChange: function() {
          var variant = this._getVariantFromOptions();

          this.container.dispatchEvent(
            new CustomEvent('variantChange', {
              detail: {
                variant: variant
              },
              bubbles: true,
              cancelable: true
            })
          );

          if (!variant) {
            return;
          }

          this._updateMasterSelect(variant);
          this._updateImages(variant);
          this._updatePrice(variant);
          this._updateSKU(variant);
          this.currentVariant = variant;

          if (this.enableHistoryState) {
            this._updateHistoryState(variant);
          }
        },

        /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
        _updateImages: function(variant) {
          var variantImage = variant.featured_image || {};
          var currentVariantImage = this.currentVariant.featured_image || {};

          if (
            !variant.featured_image ||
            variantImage.src === currentVariantImage.src
          ) {
            return;
          }

          this.container.dispatchEvent(
            new CustomEvent('variantImageChange', {
              detail: {
                variant: variant
              },
              bubbles: true,
              cancelable: true
            })
          );
        },

        /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
        _updatePrice: function(variant) {
          if (
            variant.price === this.currentVariant.price &&
            variant.compare_at_price === this.currentVariant.compare_at_price &&
            variant.unit_price === this.currentVariant.unit_price
          ) {
            return;
          }

          this.container.dispatchEvent(
            new CustomEvent('variantPriceChange', {
              detail: {
                variant: variant
              },
              bubbles: true,
              cancelable: true
            })
          );
        },

        /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
        _updateSKU: function(variant) {
          if (variant.sku === this.currentVariant.sku) {
            return;
          }

          this.container.dispatchEvent(
            new CustomEvent('variantSKUChange', {
              detail: {
                variant: variant
              },
              bubbles: true,
              cancelable: true
            })
          );
        },

        /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
        _updateHistoryState: function(variant) {
          if (!history.replaceState || !variant) {
            return;
          }

          var newurl =
              window.location.protocol +
              '//' +
              window.location.host +
              window.location.pathname +
              '?variant=' +
              variant.id;
          window.history.replaceState({ path: newurl }, '', newurl);
        },

        /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
        _updateMasterSelect: function(variant) {
          var masterSelect = this.container.querySelector(this.originalSelectorId);

          if (!masterSelect) return;
          masterSelect.value = variant.id;
        }
      });

      return Variants;
    })();

    this.Shopify = this.Shopify || {};
    this.Shopify.theme = this.Shopify.theme || {};
    this.Shopify.theme.PredictiveSearch = (function() {
      'use strict';

      function validateQuery(query) {
        var error;

        if (query === null || query === undefined) {
          error = new TypeError("'query' is missing");
          error.type = 'argument';
          throw error;
        }

        if (typeof query !== 'string') {
          error = new TypeError("'query' is not a string");
          error.type = 'argument';
          throw error;
        }
      }

      function GenericError() {
        var error = Error.call(this);

        error.name = 'Server error';
        error.message = 'Something went wrong on the server';
        error.status = 500;

        return error;
      }

      function NotFoundError(status) {
        var error = Error.call(this);

        error.name = 'Not found';
        error.message = 'Not found';
        error.status = status;

        return error;
      }

      function ServerError() {
        var error = Error.call(this);

        error.name = 'Server error';
        error.message = 'Something went wrong on the server';
        error.status = 500;

        return error;
      }

      function ContentTypeError(status) {
        var error = Error.call(this);

        error.name = 'Content-Type error';
        error.message = 'Content-Type was not provided or is of wrong type';
        error.status = status;

        return error;
      }

      function JsonParseError(status) {
        var error = Error.call(this);

        error.name = 'JSON parse error';
        error.message = 'JSON syntax error';
        error.status = status;

        return error;
      }

      function ThrottledError(status, name, message, retryAfter) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;
        error.retryAfter = retryAfter;

        return error;
      }

      function InvalidParameterError(status, name, message) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;

        return error;
      }

      function ExpectationFailedError(status, name, message) {
        var error = Error.call(this);

        error.name = name;
        error.message = message;
        error.status = status;

        return error;
      }

      function request(searchUrl, queryParams, query, onSuccess, onError) {
        var xhr = new XMLHttpRequest();
        var route = searchUrl + '/suggest.json';

        xhr.onreadystatechange = function() {
          if (xhr.readyState !== XMLHttpRequest.DONE) {
            return;
          }

          var contentType = xhr.getResponseHeader('Content-Type');

          if (xhr.status >= 500) {
            onError(new ServerError());

            return;
          }

          if (xhr.status === 404) {
            onError(new NotFoundError(xhr.status));

            return;
          }

          if (
            typeof contentType !== 'string' ||
            contentType.toLowerCase().match('application/json') === null
          ) {
            onError(new ContentTypeError(xhr.status));

            return;
          }

          if (xhr.status === 417) {
            try {
              var invalidParameterJson = JSON.parse(xhr.responseText);

              onError(
                new InvalidParameterError(
                  xhr.status,
                  invalidParameterJson.message,
                  invalidParameterJson.description
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }

            return;
          }

          if (xhr.status === 422) {
            try {
              var expectationFailedJson = JSON.parse(xhr.responseText);

              onError(
                new ExpectationFailedError(
                  xhr.status,
                  expectationFailedJson.message,
                  expectationFailedJson.description
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }

            return;
          }

          if (xhr.status === 429) {
            try {
              var throttledJson = JSON.parse(xhr.responseText);

              onError(
                new ThrottledError(
                  xhr.status,
                  throttledJson.message,
                  throttledJson.description,
                  xhr.getResponseHeader('Retry-After')
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }

            return;
          }

          if (xhr.status === 200) {
            try {
              var res = JSON.parse(xhr.responseText);
              res.query = query;
              onSuccess(res);
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }

            return;
          }

          try {
            var genericErrorJson = JSON.parse(xhr.responseText);
            onError(
              new GenericError(
                xhr.status,
                genericErrorJson.message,
                genericErrorJson.description
              )
            );
          } catch (error) {
            onError(new JsonParseError(xhr.status));
          }

          return;
        };

        xhr.open(
          'get',
          route + '?q=' + encodeURIComponent(query) + '&' + queryParams
        );

        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.send();
      }

      function Cache(config) {
        this._store = {};
        this._keys = [];
        if (config && config.bucketSize) {
          this.bucketSize = config.bucketSize;
        } else {
          this.bucketSize = 20;
        }
      }

      Cache.prototype.set = function(key, value) {
        if (this.count() >= this.bucketSize) {
          var deleteKey = this._keys.splice(0, 1);
          this.delete(deleteKey);
        }

        this._keys.push(key);
        this._store[key] = value;

        return this._store;
      };

      Cache.prototype.get = function(key) {
        return this._store[key];
      };

      Cache.prototype.has = function(key) {
        return Boolean(this._store[key]);
      };

      Cache.prototype.count = function() {
        return Object.keys(this._store).length;
      };

      Cache.prototype.delete = function(key) {
        var exists = Boolean(this._store[key]);
        delete this._store[key];
        return exists && !this._store[key];
      };

      function Dispatcher() {
        this.events = {};
      }

      Dispatcher.prototype.on = function(eventName, callback) {
        var event = this.events[eventName];
        if (!event) {
          event = new DispatcherEvent(eventName);
          this.events[eventName] = event;
        }
        event.registerCallback(callback);
      };

      Dispatcher.prototype.off = function(eventName, callback) {
        var event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
          event.unregisterCallback(callback);
          if (event.callbacks.length === 0) {
            delete this.events[eventName];
          }
        }
      };

      Dispatcher.prototype.dispatch = function(eventName, payload) {
        var event = this.events[eventName];
        if (event) {
          event.fire(payload);
        }
      };

      function DispatcherEvent(eventName) {
        this.eventName = eventName;
        this.callbacks = [];
      }

      DispatcherEvent.prototype.registerCallback = function(callback) {
        this.callbacks.push(callback);
      };

      DispatcherEvent.prototype.unregisterCallback = function(callback) {
        var index = this.callbacks.indexOf(callback);
        if (index > -1) {
          this.callbacks.splice(index, 1);
        }
      };

      DispatcherEvent.prototype.fire = function(payload) {
        var callbacks = this.callbacks.slice(0);
        callbacks.forEach(function(callback) {
          callback(payload);
        });
      };

      function debounce(func, wait) {
        var timeout = null;
        return function() {
          var context = this;
          var args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            timeout = null;
            func.apply(context, args);
          }, wait || 0);
        };
      }

      function objectToQueryParams(obj, parentKey) {
        var output = '';
        parentKey = parentKey || null;

        Object.keys(obj).forEach(function(key) {
          var outputKey = key + '=';
          if (parentKey) {
            outputKey = parentKey + '[' + key + ']';
          }

          switch (trueTypeOf(obj[key])) {
            case 'object':
              output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
              break;
            case 'array':
              output += outputKey + '=' + obj[key].join(',') + '&';
              break;
            default:
              if (parentKey) {
                outputKey += '=';
              }
              output += outputKey + encodeURIComponent(obj[key]) + '&';
              break;
          }
        });

        return output;
      }

      function trueTypeOf(obj) {
        return Object.prototype.toString
        .call(obj)
        .slice(8, -1)
        .toLowerCase();
      }

      var DEBOUNCE_RATE = 10;
      var requestDebounced = debounce(request, DEBOUNCE_RATE);

      function PredictiveSearch(params, searchUrl) {
        if (!params) {
          throw new TypeError('No params object was specified');
        }

        this.searchUrl = searchUrl;

        this._retryAfter = null;
        this._currentQuery = null;

        this.dispatcher = new Dispatcher();
        this.cache = new Cache({ bucketSize: 40 });

        this.queryParams = objectToQueryParams(params);
      }

      PredictiveSearch.TYPES = {
        PRODUCT: 'product',
        PAGE: 'page',
        ARTICLE: 'article'
      };

      PredictiveSearch.FIELDS = {
        AUTHOR: 'author',
        BODY: 'body',
        PRODUCT_TYPE: 'product_type',
        TAG: 'tag',
        TITLE: 'title',
        VARIANTS_BARCODE: 'variants.barcode',
        VARIANTS_SKU: 'variants.sku',
        VARIANTS_TITLE: 'variants.title',
        VENDOR: 'vendor'
      };

      PredictiveSearch.UNAVAILABLE_PRODUCTS = {
        SHOW: 'show',
        HIDE: 'hide',
        LAST: 'last'
      };

      PredictiveSearch.prototype.query = function query(query) {
        try {
          validateQuery(query);
        } catch (error) {
          this.dispatcher.dispatch('error', error);
          return;
        }

        if (query === '') {
          return this;
        }

        this._currentQuery = normalizeQuery(query);
        var cacheResult = this.cache.get(this._currentQuery);
        if (cacheResult) {
          this.dispatcher.dispatch('success', cacheResult);
          return this;
        }

        requestDebounced(
          this.searchUrl,
          this.queryParams,
          query,
          function(result) {
            this.cache.set(normalizeQuery(result.query), result);
            if (normalizeQuery(result.query) === this._currentQuery) {
              this._retryAfter = null;
              this.dispatcher.dispatch('success', result);
            }
          }.bind(this),
          function(error) {
            if (error.retryAfter) {
              this._retryAfter = error.retryAfter;
            }
            this.dispatcher.dispatch('error', error);
          }.bind(this)
        );

        return this;
      };

      PredictiveSearch.prototype.on = function on(eventName, callback) {
        this.dispatcher.on(eventName, callback);

        return this;
      };

      PredictiveSearch.prototype.off = function on(eventName, callback) {
        this.dispatcher.off(eventName, callback);

        return this;
      };

      function normalizeQuery(query) {
        if (typeof query !== 'string') {
          return null;
        }

        return query
        .trim()
        .replace(' ', '-')
        .toLowerCase();
      }

      return PredictiveSearch;
    })();

    this.Shopify = this.Shopify || {};
    this.Shopify.theme = this.Shopify.theme || {};
    this.Shopify.theme.PredictiveSearchComponent = (function(PredictiveSearch) {
      'use strict';

      PredictiveSearch =
        PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
      ? PredictiveSearch['default']
      : PredictiveSearch;

      var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
        resources: {
          type: [PredictiveSearch.TYPES.PRODUCT],
          options: {
            unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
            fields: [
              PredictiveSearch.FIELDS.TITLE,
              PredictiveSearch.FIELDS.VENDOR,
              PredictiveSearch.FIELDS.PRODUCT_TYPE,
              PredictiveSearch.FIELDS.VARIANTS_TITLE
            ]
          }
        }
      };

      function PredictiveSearchComponent(config) {
        // validate config
        if (
          !config ||
          !config.selectors ||
          !config.selectors.input ||
          !isString(config.selectors.input) ||
          !config.selectors.result ||
          !isString(config.selectors.result) ||
          !config.resultTemplateFct ||
          !isFunction(config.resultTemplateFct) ||
          !config.numberOfResultsTemplateFct ||
          !isFunction(config.numberOfResultsTemplateFct) ||
          !config.loadingResultsMessageTemplateFct ||
          !isFunction(config.loadingResultsMessageTemplateFct)
        ) {
          var error = new TypeError(
            'PredictiveSearchComponent config is not valid'
          );
          error.type = 'argument';
          throw error;
        }

        // Find nodes
        this.nodes = findNodes(config.selectors);

        // Validate nodes
        if (!isValidNodes(this.nodes)) {
          // eslint-disable-next-line no-console
          console.warn('Could not find valid nodes');
          return;
        }

        this.searchUrl = config.searchUrl || '/search';

        // Store the keyword that was used for the search
        this._searchKeyword = '';

        // Assign result template
        this.resultTemplateFct = config.resultTemplateFct;

        // Assign number of results template
        this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

        // Assign loading state template function
        this.loadingResultsMessageTemplateFct =
          config.loadingResultsMessageTemplateFct;

        // Assign number of search results
        this.numberOfResults = config.numberOfResults || 4;

        // Set classes
        this.classes = {
          visibleVariant: config.visibleVariant
          ? config.visibleVariant
          : 'predictive-search-wrapper--visible',
          itemSelected: config.itemSelectedClass
          ? config.itemSelectedClass
          : 'predictive-search-item--selected',
          clearButtonVisible: config.clearButtonVisibleClass
          ? config.clearButtonVisibleClass
          : 'predictive-search__clear-button--visible'
        };

        this.selectors = {
          searchResult: config.searchResult
          ? config.searchResult
          : '[data-search-result]'
        };

        // Assign callbacks
        this.callbacks = assignCallbacks(config);

        // Add input attributes
        addInputAttributes(this.nodes.input);

        // Add input event listeners
        this._addInputEventListeners();

        // Add body listener
        this._addBodyEventListener();

        // Add accessibility announcer
        this._addAccessibilityAnnouncer();

        // Display the reset button if the input is not empty
        this._toggleClearButtonVisibility();

        // Instantiate Predictive Search API
        this.predictiveSearch = new PredictiveSearch(
          config.PredictiveSearchAPIConfig
          ? config.PredictiveSearchAPIConfig
          : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG,
          this.searchUrl
        );

        // Add predictive search success event listener
        this.predictiveSearch.on(
          'success',
          this._handlePredictiveSearchSuccess.bind(this)
        );

        // Add predictive search error event listener
        this.predictiveSearch.on(
          'error',
          this._handlePredictiveSearchError.bind(this)
        );
      }

      /**
   * Private methods
   */
      function findNodes(selectors) {
        return {
          input: document.querySelector(selectors.input),
          reset: document.querySelector(selectors.reset),
          result: document.querySelector(selectors.result)
        };
      }

      function isValidNodes(nodes) {
        if (
          !nodes ||
          !nodes.input ||
          !nodes.result ||
          nodes.input.tagName !== 'INPUT'
        ) {
          return false;
        }

        return true;
      }

      function assignCallbacks(config) {
        return {
          onBodyMousedown: config.onBodyMousedown,
          onBeforeOpen: config.onBeforeOpen,
          onOpen: config.onOpen,
          onBeforeClose: config.onBeforeClose,
          onClose: config.onClose,
          onInputFocus: config.onInputFocus,
          onInputKeyup: config.onInputKeyup,
          onInputBlur: config.onInputBlur,
          onInputReset: config.onInputReset,
          onBeforeDestroy: config.onBeforeDestroy,
          onDestroy: config.onDestroy
        };
      }

      function addInputAttributes(input) {
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
      }

      function removeInputAttributes(input) {
        input.removeAttribute('autocorrect', 'off');
        input.removeAttribute('autocomplete', 'off');
        input.removeAttribute('autocapitalize', 'off');
        input.removeAttribute('spellcheck', 'false');
      }

      /**
   * Public variables
   */
      PredictiveSearchComponent.prototype.isResultVisible = false;
      PredictiveSearchComponent.prototype.results = {};

      /**
   * "Private" variables
   */
      PredictiveSearchComponent.prototype._latencyTimer = null;
      PredictiveSearchComponent.prototype._resultNodeClicked = false;

      /**
   * "Private" instance methods
   */
      PredictiveSearchComponent.prototype._addInputEventListeners = function() {
        var input = this.nodes.input;
        var reset = this.nodes.reset;

        if (!input) {
          return;
        }

        this._handleInputFocus = this._handleInputFocus.bind(this);
        this._handleInputBlur = this._handleInputBlur.bind(this);
        this._handleInputKeyup = this._handleInputKeyup.bind(this);
        this._handleInputKeydown = this._handleInputKeydown.bind(this);

        input.addEventListener('focus', this._handleInputFocus);
        input.addEventListener('blur', this._handleInputBlur);
        input.addEventListener('keyup', this._handleInputKeyup);
        input.addEventListener('keydown', this._handleInputKeydown);

        if (reset) {
          this._handleInputReset = this._handleInputReset.bind(this);
          reset.addEventListener('click', this._handleInputReset);
        }
      };

      PredictiveSearchComponent.prototype._removeInputEventListeners = function() {
        var input = this.nodes.input;

        input.removeEventListener('focus', this._handleInputFocus);
        input.removeEventListener('blur', this._handleInputBlur);
        input.removeEventListener('keyup', this._handleInputKeyup);
        input.removeEventListener('keydown', this._handleInputKeydown);
      };

      PredictiveSearchComponent.prototype._addBodyEventListener = function() {
        this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

        document
        .querySelector('body')
        .addEventListener('mousedown', this._handleBodyMousedown);
      };

      PredictiveSearchComponent.prototype._removeBodyEventListener = function() {
        document
        .querySelector('body')
        .removeEventListener('mousedown', this._handleBodyMousedown);
      };

      PredictiveSearchComponent.prototype._removeClearButtonEventListener = function() {
        var reset = this.nodes.reset;

        if (!reset) {
          return;
        }

        reset.removeEventListener('click', this._handleInputReset);
      };

      /**
   * Event handlers
   */
      PredictiveSearchComponent.prototype._handleBodyMousedown = function(evt) {
        if (this.isResultVisible && this.nodes !== null) {
          if (
            evt.target.isEqualNode(this.nodes.input) ||
            this.nodes.input.contains(evt.target) ||
            evt.target.isEqualNode(this.nodes.result) ||
            this.nodes.result.contains(evt.target)
          ) {
            this._resultNodeClicked = true;
          } else {
            if (isFunction(this.callbacks.onBodyMousedown)) {
              var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
              if (isBoolean(returnedValue) && returnedValue) {
                this.close();
              }
            } else {
              this.close();
            }
          }
        }
      };

      PredictiveSearchComponent.prototype._handleInputFocus = function(evt) {
        if (isFunction(this.callbacks.onInputFocus)) {
          var returnedValue = this.callbacks.onInputFocus(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (evt.target.value.length > 0) {
          this._search();
        }

        return true;
      };

      PredictiveSearchComponent.prototype._handleInputBlur = function() {
        // This has to be done async, to wait for the focus to be on the next
        // element and avoid closing the results.
        // Example: Going from the input to the reset button.
        setTimeout(
          function() {
            if (isFunction(this.callbacks.onInputBlur)) {
              var returnedValue = this.callbacks.onInputBlur(this.nodes);
              if (isBoolean(returnedValue) && !returnedValue) {
                return false;
              }
            }

            if (document.activeElement.isEqualNode(this.nodes.reset)) {
              return false;
            }

            if (this._resultNodeClicked) {
              this._resultNodeClicked = false;
              return false;
            }

            this.close();
          }.bind(this)
        );

        return true;
      };

      PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function() {
        this._accessibilityAnnouncerDiv = window.document.createElement('div');

        this._accessibilityAnnouncerDiv.setAttribute(
          'style',
          'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
        );

        this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
        this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
        this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

        this.nodes.result.parentElement.appendChild(
          this._accessibilityAnnouncerDiv
        );
      };

      PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function() {
        this.nodes.result.parentElement.removeChild(
          this._accessibilityAnnouncerDiv
        );
      };

      PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function(
      previousSelectedElement,
       currentSelectedElement
      ) {
        // Update the active descendant on the search input
        this.nodes.input.setAttribute(
          'aria-activedescendant',
          currentSelectedElement.id
        );

        // Unmark the previousSelected elemented as selected
        if (previousSelectedElement) {
          previousSelectedElement.removeAttribute('aria-selected');
        }

        // Mark the element as selected
        currentSelectedElement.setAttribute('aria-selected', true);
      };

      PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function() {
        this.nodes.input.setAttribute('aria-activedescendant', '');
      };

      PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function(
      results
      ) {
        var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
        var newMessage = this.numberOfResultsTemplateFct(results);

        // If the messages are the same, they won't get announced
        // add white space so it gets announced
        if (currentAnnouncedMessage === newMessage) {
          newMessage = newMessage + '&nbsp;';
        }

        this._accessibilityAnnouncerDiv.innerHTML = newMessage;
      };

      PredictiveSearchComponent.prototype._announceLoadingState = function() {
        this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
      };

      PredictiveSearchComponent.prototype._handleInputKeyup = function(evt) {
        var UP_ARROW_KEY_CODE = 38;
        var DOWN_ARROW_KEY_CODE = 40;
        var RETURN_KEY_CODE = 13;
        var ESCAPE_KEY_CODE = 27;

        if (isFunction(this.callbacks.onInputKeyup)) {
          var returnedValue = this.callbacks.onInputKeyup(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        this._toggleClearButtonVisibility();

        if (this.isResultVisible && this.nodes !== null) {
          if (evt.keyCode === UP_ARROW_KEY_CODE) {
            this._navigateOption(evt, 'UP');
            return true;
          }

          if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
            this._navigateOption(evt, 'DOWN');
            return true;
          }

          if (evt.keyCode === RETURN_KEY_CODE) {
            this._selectOption();
            return true;
          }

          if (evt.keyCode === ESCAPE_KEY_CODE) {
            this.close();
          }
        }

        if (evt.target.value.length <= 0) {
          this.close();
          this._setKeyword('');
        } else if (evt.target.value.length > 0) {
          this._search();
        }

        return true;
      };

      PredictiveSearchComponent.prototype._handleInputKeydown = function(evt) {
        var RETURN_KEY_CODE = 13;
        var UP_ARROW_KEY_CODE = 38;
        var DOWN_ARROW_KEY_CODE = 40;

        // Prevent the form default submission if there is a selected option
        if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
          evt.preventDefault();
        }

        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (
          evt.keyCode === UP_ARROW_KEY_CODE ||
          evt.keyCode === DOWN_ARROW_KEY_CODE
        ) {
          evt.preventDefault();
        }
      };

      PredictiveSearchComponent.prototype._handleInputReset = function(evt) {
        evt.preventDefault();

        if (isFunction(this.callbacks.onInputReset)) {
          var returnedValue = this.callbacks.onInputReset(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        this.nodes.input.value = '';
        this.nodes.input.focus();
        this._toggleClearButtonVisibility();
        this.close();

        return true;
      };

      PredictiveSearchComponent.prototype._navigateOption = function(
      evt,
       direction
      ) {
        var currentOption = this._getSelectedOption();

        if (!currentOption) {
          var firstOption = this.nodes.result.querySelector(
            this.selectors.searchResult
          );
          firstOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            null,
            firstOption
          );
        } else {
          if (direction === 'DOWN') {
            var nextOption = currentOption.nextElementSibling;
            if (nextOption) {
              currentOption.classList.remove(this.classes.itemSelected);
              nextOption.classList.add(this.classes.itemSelected);
              this._updateAccessibilityAttributesAfterSelectingElement(
                currentOption,
                nextOption
              );
            }
          } else {
            var previousOption = currentOption.previousElementSibling;
            if (previousOption) {
              currentOption.classList.remove(this.classes.itemSelected);
              previousOption.classList.add(this.classes.itemSelected);
              this._updateAccessibilityAttributesAfterSelectingElement(
                currentOption,
                previousOption
              );
            }
          }
        }
      };

      PredictiveSearchComponent.prototype._getSelectedOption = function() {
        return this.nodes.result.querySelector('.' + this.classes.itemSelected);
      };

      PredictiveSearchComponent.prototype._selectOption = function() {
        var selectedOption = this._getSelectedOption();

        if (selectedOption) {
          selectedOption.querySelector('a, button').click();
        }
      };

      PredictiveSearchComponent.prototype._search = function() {
        var newSearchKeyword = this.nodes.input.value;

        if (this._searchKeyword === newSearchKeyword) {
          return;
        }

        clearTimeout(this._latencyTimer);
        this._latencyTimer = setTimeout(
          function() {
            this.results.isLoading = true;

            // Annonuce that we're loading the results
            this._announceLoadingState();

            this.nodes.result.classList.add(this.classes.visibleVariant);
            // NOTE: We could benifit in using DOMPurify.
            // https://github.com/cure53/DOMPurify
            this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
          }.bind(this),
          500
        );

        this.predictiveSearch.query(newSearchKeyword);
        this._setKeyword(newSearchKeyword);
      };

      PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function(
      json
      ) {
        clearTimeout(this._latencyTimer);
        this.results = json.resources.results;

        this.results.isLoading = false;
        this.results.products = this.results.products.slice(
          0,
          this.numberOfResults
        );
        this.results.canLoadMore =
          this.numberOfResults <= this.results.products.length;
        this.results.searchQuery = this.nodes.input.value;

        if (this.results.products.length > 0 || this.results.searchQuery) {
          this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
          this._announceNumberOfResultsFound(this.results);
          this.open();
        } else {
          this.nodes.result.innerHTML = '';

          this._closeOnNoResults();
        }
      };

      PredictiveSearchComponent.prototype._handlePredictiveSearchError = function() {
        clearTimeout(this._latencyTimer);
        this.nodes.result.innerHTML = '';

        this._closeOnNoResults();
      };

      PredictiveSearchComponent.prototype._closeOnNoResults = function() {
        if (this.nodes) {
          this.nodes.result.classList.remove(this.classes.visibleVariant);
        }

        this.isResultVisible = false;
      };

      PredictiveSearchComponent.prototype._setKeyword = function(keyword) {
        this._searchKeyword = keyword;
      };

      PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function() {
        if (!this.nodes.reset) {
          return;
        }

        if (this.nodes.input.value.length > 0) {
          this.nodes.reset.classList.add(this.classes.clearButtonVisible);
        } else {
          this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
        }
      };

      /**
   * Public methods
   */
      PredictiveSearchComponent.prototype.open = function() {
        if (this.isResultVisible) {
          return;
        }

        if (isFunction(this.callbacks.onBeforeOpen)) {
          var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        this.nodes.result.classList.add(this.classes.visibleVariant);
        this.nodes.input.setAttribute('aria-expanded', true);
        this.isResultVisible = true;

        if (isFunction(this.callbacks.onOpen)) {
          return this.callbacks.onOpen(this.nodes) || true;
        }

        return true;
      };

      PredictiveSearchComponent.prototype.close = function() {
        if (!this.isResultVisible) {
          return true;
        }

        if (isFunction(this.callbacks.onBeforeClose)) {
          var returnedValue = this.callbacks.onBeforeClose(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (this.nodes) {
          this.nodes.result.classList.remove(this.classes.visibleVariant);
        }

        this.nodes.input.setAttribute('aria-expanded', false);
        this._clearAriaActiveDescendant();
        this._setKeyword('');

        if (isFunction(this.callbacks.onClose)) {
          this.callbacks.onClose(this.nodes);
        }

        this.isResultVisible = false;
        this.results = {};

        return true;
      };

      PredictiveSearchComponent.prototype.destroy = function() {
        this.close();

        if (isFunction(this.callbacks.onBeforeDestroy)) {
          var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        this.nodes.result.classList.remove(this.classes.visibleVariant);
        removeInputAttributes(this.nodes.input);
        this._removeInputEventListeners();
        this._removeBodyEventListener();
        this._removeAccessibilityAnnouncer();
        this._removeClearButtonEventListener();

        if (isFunction(this.callbacks.onDestroy)) {
          this.callbacks.onDestroy(this.nodes);
        }

        return true;
      };

      PredictiveSearchComponent.prototype.clearAndClose = function() {
        this.nodes.input.value = '';
        this.close();
      };

      /**
   * Utilities
   */
      function getTypeOf(value) {
        return Object.prototype.toString.call(value);
      }

      function isString(value) {
        return getTypeOf(value) === '[object String]';
      }

      function isBoolean(value) {
        return getTypeOf(value) === '[object Boolean]';
      }

      function isFunction(value) {
        return getTypeOf(value) === '[object Function]';
      }

      return PredictiveSearchComponent;
    })(Shopify.theme.PredictiveSearch);

    window.theme = window.theme || {};

    theme.TouchEvents = function TouchEvents(element, options) {
      this.axis;
      this.checkEvents = [];
      this.eventHandlers = {};
      this.eventModel = {};
      this.events = [
        ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
        ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
        ['mousedown', 'mousemove', 'mouseup']
      ];
      this.eventType;
      this.difference = {};
      this.direction;
      this.start = {};

      this.element = element;
      this.options = Object.assign(
        {},
        {
          dragThreshold: 10,
          start: function() {}, // eslint-disable-line
          move: function() {}, // eslint-disable-line
          end: function() {} // eslint-disable-line
        },
        options
      );

      this.checkEvents = this._getCheckEvents();
      this.eventModel = this._getEventModel();

      this._setupEventHandlers();
    };

    theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
      destroy: function() {
        this.element.removeEventListener(
          'dragstart',
          this.eventHandlers.preventDefault
        );

        this.element.removeEventListener(
          this.events[this.eventModel][0],
          this.eventHandlers.touchStart
        );

        if (!this.eventModel) {
          this.element.removeEventListener(
            this.events[2][0],
            this.eventHandlers.touchStart
          );
        }

        this.element.removeEventListener('click', this.eventHandlers.preventClick);
      },

      _setupEventHandlers: function() {
        this.eventHandlers.preventDefault = this._preventDefault.bind(this);
        this.eventHandlers.preventClick = this._preventClick.bind(this);
        this.eventHandlers.touchStart = this._touchStart.bind(this);
        this.eventHandlers.touchMove = this._touchMove.bind(this);
        this.eventHandlers.touchEnd = this._touchEnd.bind(this);

        // Prevent element from dragging when using mouse
        this.element.addEventListener(
          'dragstart',
          this.eventHandlers.preventDefault
        );

        // Bind the touchstart/pointerdown event
        this.element.addEventListener(
          this.events[this.eventModel][0],
          this.eventHandlers.touchStart
        );

        // Bind mousedown if necessary
        if (!this.eventModel) {
          this.element.addEventListener(
            this.events[2][0],
            this.eventHandlers.touchStart
          );
        }

        // No clicking during touch
        this.element.addEventListener('click', this.eventHandlers.preventClick);
      },

      _touchStart: function(event) {
        this.eventType = this.eventModel;

        if (event.type === 'mousedown' && !this.eventModel) {
          this.eventType = 2;
        }

        if (this.checkEvents[this.eventType](event)) return;
        if (this.eventType) this._preventDefault(event);

        document.addEventListener(
          this.events[this.eventType][1],
          this.eventHandlers.touchMove
        );

        document.addEventListener(
          this.events[this.eventType][2],
          this.eventHandlers.touchEnd
        );

        if (this.eventType < 2) {
          document.addEventListener(
            this.events[this.eventType][3],
            this.eventHandlers.touchEnd
          );
        }

        this.start = {
          xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
          yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
          time: new Date().getTime()
        };

        // Ensure we empty out the this.difference object
        Object.keys(this.difference).forEach(
          function(key) {
            delete this.difference[key];
          }.bind(this)
        );

        this.options.start(event);
      },

      _touchMove: function(event) {
        this.difference = this._getDifference(event);

        // Prevent document from scrolling during swipe gesture
        document['on' + this.events[this.eventType][1]] = function(event) {
          this._preventDefault(event);
        }.bind(this);

        // Get the direction user is dragging
        if (!this.axis) {
          if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
            this.axis = 'xPosition';
          } else if (
            this.options.dragThreshold < Math.abs(this.difference.yPosition)
          ) {
            this.axis = 'yPosition';
          } else {
            this.axis = false;
          }
        } else if (this.axis === 'xPosition') {
          this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
        } else if (this.axis === 'yPosition') {
          this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
        }

        this.options.move(event, this.direction, this.difference);
      },

      _touchEnd: function(event) {
        document.removeEventListener(
          this.events[this.eventType][1],
          this.eventHandlers.touchMove
        );

        document.removeEventListener(
          this.events[this.eventType][2],
          this.eventHandlers.touchEnd
        );

        if (this.eventType < 2) {
          document.removeEventListener(
            this.events[this.eventType][3],
            this.eventHandlers.touchEnd
          );
        }

        // Re-enable document scrolling
        document['on' + this.events[this.eventType][1]] = function() {
          return true;
        };

        this.options.end(event, this.direction, this.difference);
        this.axis = false;
      },

      _getDifference: function(event) {
        return {
          xPosition:
          (this.eventType ? event.clientX : event.touches[0].clientX) -
          this.start.xPosition,
          yPosition:
          (this.eventType ? event.clientY : event.touches[0].clientY) -
          this.start.yPosition,
          time: new Date().getTime() - this.start.time
        };
      },

      _getCheckEvents: function() {
        return [
          // Touch events
          function(event) {
            // Skip the event if it's a multi-touch or pinch move
            return (
              (event.touches && event.touches.length > 1) ||
              (event.scale && event.scale !== 1)
            );
          },
          // Pointer events
          function(event) {
            // Skip it, if:
            // 1. The event is not primary (other pointers during multi-touch),
            // 2. Left mouse button is not pressed,
            // 3. Event is not a touch event
            return (
              !event.isPrimary ||
              (event.buttons && event.buttons !== 1) ||
              (event.pointerType !== 'touch' && event.pointerType !== 'pen')
            );
          },
          // Mouse events
          function(event) {
            // Skip the event if left mouse button is not pressed
            return event.buttons && event.buttons !== 1;
          }
        ];
      },

      _getEventModel: function() {
        return window.navigator.pointerEnabled ? 1 : 0;
      },

      _preventDefault: function(event) {
        event.preventDefault ? event.preventDefault() : (event.returnValue = false);
      },

      _preventClick: function(event) {
        if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
          this._preventDefault(event);
        }
      }
    });


    /* ================ GLOBAL ================ */
    /*============================================================================
  Drawer modules
==============================================================================*/
    theme.Drawers = (function() {
      function Drawer(id, position, options) {
        var DEFAULT_OPEN_CLASS = 'js-drawer-open';
        var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

        var defaults = {
          selectors: {
            openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
            close: '.' + DEFAULT_CLOSE_CLASS
          },
          classes: {
            open: DEFAULT_OPEN_CLASS,
            openVariant: DEFAULT_OPEN_CLASS + '-' + position
          },
          withPredictiveSearch: false
        };

        this.nodes = {
          parents: [document.documentElement, document.body],
          page: document.getElementById('PageContainer')
        };

        this.eventHandlers = {};

        this.config = Object.assign({}, defaults, options);
        this.position = position;
        this.drawer = document.getElementById(id);

        if (!this.drawer) {
          return false;
        }

        this.drawerIsOpen = false;
        this.init();
      }

      Drawer.prototype.init = function() {
        document
        .querySelector(this.config.selectors.openVariant)
        .addEventListener('click', this.open.bind(this));
        this.drawer
        .querySelector(this.config.selectors.close)
        .addEventListener('click', this.close.bind(this));
      };

      Drawer.prototype.open = function(evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // Prevent following href if link is clicked
        if (evt) {
          evt.preventDefault();
        } else {
          externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.activeSource = evt.currentTarget;
        }

        if (this.drawerIsOpen && !externalCall) {
          return this.close();
        }

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        if (!this.config.withPredictiveSearch) {
          theme.Helpers.prepareTransition(this.drawer);
        }

        this.nodes.parents.forEach(
          function(parent) {
            parent.classList.add(
              this.config.classes.open,
              this.config.classes.openVariant
            );
          }.bind(this)
        );

        this.drawerIsOpen = true;

        // Run function when draw opens if set
        if (
          this.config.onDrawerOpen &&
          typeof this.config.onDrawerOpen === 'function'
        ) {
          if (!externalCall) {
            this.config.onDrawerOpen();
          }
        }

        if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'true');
        }

        // Set focus on drawer
        var trapFocusConfig = {
          container: this.drawer
        };

        if (this.config.elementToFocusOnOpen) {
          trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
        }

        slate.a11y.trapFocus(trapFocusConfig);

        this.bindEvents();

        return this;
      };

      Drawer.prototype.close = function() {
        if (!this.drawerIsOpen) {
          // don't close a closed drawer
          return;
        }

        // deselect any focused form elements
        document.activeElement.dispatchEvent(
          new CustomEvent('blur', { bubbles: true, cancelable: true })
        );

        // Ensure closing transition is applied to moved elements, like the nav
        if (!this.config.withPredictiveSearch) {
          theme.Helpers.prepareTransition(this.drawer);
        }

        this.nodes.parents.forEach(
          function(parent) {
            parent.classList.remove(
              this.config.classes.open,
              this.config.classes.openVariant
            );
          }.bind(this)
        );

        if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false');
        }

        this.drawerIsOpen = false;

        // Remove focus on drawer
        slate.a11y.removeTrapFocus({
          container: this.drawer
        });

        this.unbindEvents();

        // Run function when draw closes if set
        if (
          this.config.onDrawerClose &&
          typeof this.config.onDrawerClose === 'function'
        ) {
          this.config.onDrawerClose();
        }
      };

      Drawer.prototype.bindEvents = function() {
        this.eventHandlers.drawerKeyupHandler = function(evt) {
          // close on 'esc' keypress
          if (evt.keyCode === 27) {
            this.close();
            return false;
          } else {
            return true;
          }
        }.bind(this);

        this.eventHandlers.drawerTouchmoveHandler = function() {
          return false;
        };

        this.eventHandlers.drawerClickHandler = function() {
          this.close();
          return false;
        }.bind(this);

        // Add event listener to document body
        document.body.addEventListener(
          'keyup',
          this.eventHandlers.drawerKeyupHandler
        );

        // Lock scrolling on mobile
        this.nodes.page.addEventListener(
          'touchmove',
          this.eventHandlers.drawerTouchmoveHandler
        );

        this.nodes.page.addEventListener(
          'click',
          this.eventHandlers.drawerClickHandler
        );
      };

      Drawer.prototype.unbindEvents = function() {
        this.nodes.page.removeEventListener(
          'touchmove',
          this.eventHandlers.drawerTouchmoveHandler
        );
        this.nodes.page.removeEventListener(
          'click',
          this.eventHandlers.drawerClickHandler
        );
        document.body.removeEventListener(
          'keyup',
          this.eventHandlers.drawerKeyupHandler
        );
      };

      return Drawer;
    })();

    theme.Helpers = (function() {
      var touchDevice = false;

      var classes = {
        preventScrolling: 'prevent-scrolling'
      };

      var scrollPosition = window.pageYOffset;

      function setTouch() {
        touchDevice = true;
      }

      function isTouch() {
        return touchDevice;
      }

      function enableScrollLock() {
        scrollPosition = window.pageYOffset;
        document.body.style.top = '-' + scrollPosition + 'px';
        document.body.classList.add(classes.preventScrolling);
      }

      function disableScrollLock() {
        document.body.classList.remove(classes.preventScrolling);
        document.body.style.removeProperty('top');
        window.scrollTo(0, scrollPosition);
      }

      function debounce(func, wait, immediate) {
        var timeout;

        return function() {
          var context = this,
              args = arguments;

          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      }

      function getScript(source, beforeEl) {
        return new Promise(function(resolve, reject) {
          var script = document.createElement('script');
          var prior = beforeEl || document.getElementsByTagName('script')[0];

          script.async = true;
          script.defer = true;

          // eslint-disable-next-line shopify/prefer-early-return
          function onloadHander(_, isAbort) {
            if (
              isAbort ||
              !script.readyState ||
              /loaded|complete/.test(script.readyState)
            ) {
              script.onload = null;
              script.onreadystatechange = null;
              script = undefined;

              if (isAbort) {
                reject();
              } else {
                resolve();
              }
            }
          }

          script.onload = onloadHander;
          script.onreadystatechange = onloadHander;

          script.src = source;
          prior.parentNode.insertBefore(script, prior);
        });
      }

      /* Based on the prepareTransition by Jonathan Snook */
      /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
      function prepareTransition(element) {
        element.addEventListener(
          'transitionend',
          function(event) {
            event.currentTarget.classList.remove('is-transitioning');
          },
          { once: true }
        );

        var properties = [
          'transition-duration',
          '-moz-transition-duration',
          '-webkit-transition-duration',
          '-o-transition-duration'
        ];

        var duration = 0;

        properties.forEach(function(property) {
          var computedValue = getComputedStyle(element)[property];

          if (computedValue) {
            computedValue.replace(/\D/g, '');
            duration || (duration = parseFloat(computedValue));
          }
        });

        if (duration !== 0) {
          element.classList.add('is-transitioning');
          element.offsetWidth;
        }
      }

      /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
      function serialize(form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function(field) {
          if (
            !field.name ||
            field.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
          )
            return;
          if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function(option) {
              if (!option.selected) return;
              arr.push(
                encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
              );
            });
            return;
          }
          if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
            return;
          arr.push(
            encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
          );
        });
        return arr.join('&');
      }
      function cookiesEnabled() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        return cookieEnabled;
      }

      function promiseStylesheet(stylesheet) {
        var stylesheetUrl = stylesheet || theme.stylesheet;

        if (typeof this.stylesheetPromise === 'undefined') {
          this.stylesheetPromise = new Promise(function(resolve) {
            var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

            if (link.loaded) resolve();

            link.addEventListener('load', function() {
              setTimeout(resolve, 0);
            });
          });
        }

        return this.stylesheetPromise;
      }

      return {
        setTouch: setTouch,
        isTouch: isTouch,
        enableScrollLock: enableScrollLock,
        disableScrollLock: disableScrollLock,
        debounce: debounce,
        getScript: getScript,
        prepareTransition: prepareTransition,
        serialize: serialize,
        cookiesEnabled: cookiesEnabled,
        promiseStylesheet: promiseStylesheet
      };
    })();

    theme.LibraryLoader = (function() {
      var types = {
        link: 'link',
        script: 'script'
      };

      var status = {
        requested: 'requested',
        loaded: 'loaded'
      };

      var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

      var libraries = {
        plyrShopifyStyles: {
          tagId: 'plyr-shopify-styles',
          src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
          type: types.link
        },
        modelViewerUiStyles: {
          tagId: 'shopify-model-viewer-ui-styles',
          src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
          type: types.link
        }
      };

      function load(libraryName, callback) {
        var library = libraries[libraryName];

        if (!library) return;
        if (library.status === status.requested) return;

        callback = callback || function() {};
        if (library.status === status.loaded) {
          callback();
          return;
        }

        library.status = status.requested;

        var tag;

        switch (library.type) {
          case types.script:
            tag = createScriptTag(library, callback);
            break;
          case types.link:
            tag = createLinkTag(library, callback);
            break;
        }

        tag.id = library.tagId;
        library.element = tag;

        var firstScriptTag = document.getElementsByTagName(library.type)[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

      function createScriptTag(library, callback) {
        var tag = document.createElement('script');
        tag.src = library.src;
        tag.addEventListener('load', function() {
          library.status = status.loaded;
          callback();
        });
        return tag;
      }

      function createLinkTag(library, callback) {
        var tag = document.createElement('link');
        tag.href = library.src;
        tag.rel = 'stylesheet';
        tag.type = 'text/css';
        tag.addEventListener('load', function() {
          library.status = status.loaded;
          callback();
        });
        return tag;
      }

      return {
        load: load
      };
    })();


    /* ================ MODULES ================ */
    window.theme = window.theme || {};

    theme.Header = (function() {
      var selectors = {
        body: 'body',
        navigation: '#AccessibleNav',
        siteNavHasDropdown: '[data-has-dropdowns]',
        siteNavChildLinks: '.site-nav__child-link',
        siteNavActiveDropdown: '.site-nav--active-dropdown',
        siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
        siteNavCenteredDropdown: '.site-nav__dropdown--centered',
        siteNavLinkMain: '.site-nav__link--main',
        siteNavChildLink: '.site-nav__link--last',
        siteNavDropdown: '.site-nav__dropdown',
        siteHeader: '.site-header'
      };

      var config = {
        activeClass: 'site-nav--active-dropdown',
        childLinkClass: 'site-nav__child-link',
        rightDropdownClass: 'site-nav__dropdown--right',
        leftDropdownClass: 'site-nav__dropdown--left'
      };

      var cache = {};

      function init() {
        cacheSelectors();
        styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();

        cache.parents.forEach(function(element) {
          element.addEventListener('click', submenuParentClickHandler);
        });

        // check when we're leaving a dropdown and close the active dropdown
        cache.siteNavChildLink.forEach(function(element) {
          element.addEventListener('focusout', submenuFocusoutHandler);
        });

        cache.topLevel.forEach(function(element) {
          element.addEventListener('focus', hideDropdown);
        });

        cache.subMenuLinks.forEach(function(element) {
          element.addEventListener('click', stopImmediatePropagation);
        });

        window.addEventListener('resize', resizeHandler);
      }

      function stopImmediatePropagation(event) {
        event.stopImmediatePropagation();
      }

      function cacheSelectors() {
        var navigation = document.querySelector(selectors.navigation);

        cache = {
          nav: navigation,
          topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
          parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
          subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
          activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
          siteHeader: document.querySelector(selectors.siteHeader),
          siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
        };
      }

      function showDropdown(element) {
        element.classList.add(config.activeClass);

        if (cache.activeDropdown) hideDropdown();

        cache.activeDropdown = element;

        element
        .querySelector(selectors.siteNavLinkMain)
        .setAttribute('aria-expanded', 'true');

        setTimeout(function() {
          window.addEventListener('keyup', keyUpHandler);
          document.body.addEventListener('click', hideDropdown);
        }, 250);
      }

      function hideDropdown() {
        if (!cache.activeDropdown) return;

        cache.activeDropdown
        .querySelector(selectors.siteNavLinkMain)
        .setAttribute('aria-expanded', 'false');
        cache.activeDropdown.classList.remove(config.activeClass);

        cache.activeDropdown = document.querySelector(
          selectors.siteNavActiveDropdown
        );

        window.removeEventListener('keyup', keyUpHandler);
        document.body.removeEventListener('click', hideDropdown);
      }

      function styleDropdowns(dropdownListItems) {
        dropdownListItems.forEach(function(item) {
          var dropdownLi = item.querySelector(selectors.siteNavDropdown);

          if (!dropdownLi) return;

          if (isRightOfLogo(item)) {
            dropdownLi.classList.remove(config.leftDropdownClass);
            dropdownLi.classList.add(config.rightDropdownClass);
          } else {
            dropdownLi.classList.remove(config.rightDropdownClass);
            dropdownLi.classList.add(config.leftDropdownClass);
          }
        });
      }

      function isRightOfLogo(item) {
        var rect = item.getBoundingClientRect();
        var win = item.ownerDocument.defaultView;
        var leftOffset = rect.left + win.pageXOffset;

        var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
        return leftOffset > headerWidth;
      }

      function positionFullWidthDropdowns() {
        document
        .querySelectorAll(selectors.siteNavHasCenteredDropdown)
        .forEach(function(el) {
          var fullWidthDropdown = el.querySelector(
            selectors.siteNavCenteredDropdown
          );

          var fullWidthDropdownOffset = el.offsetTop + 41;
          fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
        });
      }

      function keyUpHandler(event) {
        if (event.keyCode === 27) hideDropdown();
      }

      function resizeHandler() {
        adjustStyleAndPosition();
      }

      function submenuParentClickHandler(event) {
        var element = event.currentTarget;

        element.classList.contains(config.activeClass)
        ? hideDropdown()
        : showDropdown(element);
      }

      function submenuFocusoutHandler() {
        setTimeout(function() {
          if (
            document.activeElement.classList.contains(config.childLinkClass) ||
            !cache.activeDropdown
          ) {
            return;
          }

          hideDropdown();
        });
      }

      var adjustStyleAndPosition = theme.Helpers.debounce(function() {
        styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      }, 50);

      function unload() {
        cache.topLevel.forEach(function(element) {
          element.removeEventListener('focus', hideDropdown);
        });

        cache.subMenuLinks.forEach(function(element) {
          element.removeEventListener('click', stopImmediatePropagation);
        });

        cache.parents.forEach(function(element) {
          element.removeEventListener('click', submenuParentClickHandler);
        });

        cache.siteNavChildLink.forEach(function(element) {
          element.removeEventListener('focusout', submenuFocusoutHandler);
        });

        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('keyup', keyUpHandler);
        document.body.removeEventListener('click', hideDropdown);
      }

      return {
        init: init,
        unload: unload
      };
    })();

    window.theme = window.theme || {};

    theme.MobileNav = (function() {
      var classes = {
        mobileNavOpenIcon: 'mobile-nav--open',
        mobileNavCloseIcon: 'mobile-nav--close',
        navLinkWrapper: 'mobile-nav__item',
        navLink: 'mobile-nav__link',
        subNavLink: 'mobile-nav__sublist-link',
        return: 'mobile-nav__return-btn',
        subNavActive: 'is-active',
        subNavClosing: 'is-closing',
        navOpen: 'js-menu--is-open',
        subNavShowing: 'sub-nav--is-open',
        thirdNavShowing: 'third-nav--is-open',
        subNavToggleBtn: 'js-toggle-submenu'
      };

      var cache = {};
      var isTransitioning;
      var activeSubNav;
      var activeTrigger;
      var menuLevel = 1;
      var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
      var mql = window.matchMedia(mediumUpQuery);

      function init() {
        cacheSelectors();

        if (cache.mobileNavToggle) {
          cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
        }

        cache.subNavToggleBtns.forEach(function(element) {
          element.addEventListener('click', toggleSubNav);
        });

        mql.addListener(initBreakpoints);
      }

      function initBreakpoints() {
        if (
          mql.matches &&
          cache.mobileNavContainer.classList.contains(classes.navOpen)
        ) {
          closeMobileNav();
        }
      }

      function toggleMobileNav() {
        var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
          classes.mobileNavCloseIcon
        );

        if (mobileNavIsOpen) {
          closeMobileNav();
        } else {
          openMobileNav();
        }
      }

      function cacheSelectors() {
        cache = {
          pageContainer: document.querySelector('#PageContainer'),
          siteHeader: document.querySelector('.site-header'),
          mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
          mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
          mobileNav: document.querySelector('#MobileNav'),
          sectionHeader: document.querySelector('#shopify-section-header'),
          subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
        };
      }

      function openMobileNav() {
        var translateHeaderHeight = cache.siteHeader.offsetHeight;

        theme.Helpers.prepareTransition(cache.mobileNavContainer);
        cache.mobileNavContainer.classList.add(classes.navOpen);

        cache.mobileNavContainer.style.transform =
          'translateY(' + translateHeaderHeight + 'px)';

        cache.pageContainer.style.transform =
          'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

        slate.a11y.trapFocus({
          container: cache.sectionHeader,
          elementToFocus: cache.mobileNavToggle
        });

        cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
        cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
        cache.mobileNavToggle.setAttribute('aria-expanded', true);

        window.addEventListener('keyup', keyUpHandler);
      }

      function keyUpHandler(event) {
        if (event.which === 27) {
          closeMobileNav();
        }
      }

      function closeMobileNav() {
        theme.Helpers.prepareTransition(cache.mobileNavContainer);
        cache.mobileNavContainer.classList.remove(classes.navOpen);
        cache.mobileNavContainer.style.transform = 'translateY(-100%)';
        cache.pageContainer.setAttribute('style', '');

        slate.a11y.trapFocus({
          container: document.querySelector('html'),
          elementToFocus: document.body
        });

        cache.mobileNavContainer.addEventListener(
          'transitionend',
          mobileNavRemoveTrapFocus,
          { once: true }
        );

        cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
        cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
        cache.mobileNavToggle.setAttribute('aria-expanded', false);
        cache.mobileNavToggle.focus();

        window.removeEventListener('keyup', keyUpHandler);
        window.scrollTo(0, 0);
      }

      function mobileNavRemoveTrapFocus() {
        slate.a11y.removeTrapFocus({
          container: cache.mobileNav
        });
      }

      function toggleSubNav(event) {
        if (isTransitioning) return;

        var toggleBtn = event.currentTarget;
        var isReturn = toggleBtn.classList.contains(classes.return);

        isTransitioning = true;

        if (isReturn) {
          var subNavToggleBtn = document.querySelectorAll(
            '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
          );

          subNavToggleBtn.forEach(function(element) {
            element.classList.remove(classes.subNavActive);
          });

          if (activeTrigger) {
            activeTrigger.classList.remove(classes.subNavActive);
          }
        } else {
          toggleBtn.classList.add(classes.subNavActive);
        }

        activeTrigger = toggleBtn;

        goToSubnav(toggleBtn.getAttribute('data-target'));
      }

      function goToSubnav(target) {
        var targetMenu = target
        ? document.querySelector(
          '.mobile-nav__dropdown[data-parent="' + target + '"]'
        )
        : cache.mobileNav;

        menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

        if (activeSubNav) {
          theme.Helpers.prepareTransition(activeSubNav);
          activeSubNav.classList.add(classes.subNavClosing);
        }

        activeSubNav = targetMenu;

        var translateMenuHeight = targetMenu.offsetHeight;

        var openNavClass =
            menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

        cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
        cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
        cache.mobileNavContainer.classList.add(openNavClass);

        if (!target) {
          cache.mobileNavContainer.classList.remove(
            classes.thirdNavShowing,
            classes.subNavShowing
          );
        }

        /* if going back to first subnav, focus is on whole header */
        var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

        cache.mobileNavContainer.addEventListener(
          'transitionend',
          trapMobileNavFocus,
          { once: true }
        );

        function trapMobileNavFocus() {
          slate.a11y.trapFocus({
            container: container
          });

          cache.mobileNavContainer.removeEventListener(
            'transitionend',
            trapMobileNavFocus
          );

          isTransitioning = false;
        }

        // Match height of subnav
        cache.pageContainer.style.transform =
          'translateY(' + translateMenuHeight + 'px)';

        activeSubNav.classList.remove(classes.subNavClosing);
      }

      function unload() {
        mql.removeListener(initBreakpoints);
      }

      return {
        init: init,
        unload: unload,
        closeMobileNav: closeMobileNav
      };
    })();

    window.Modals = (function() {
      function Modal(id, name, options) {
        var defaults = {
          close: '.js-modal-close',
          open: '.js-modal-open-' + name,
          openClass: 'modal--is-active',
          closeModalOnClick: false
        };

        this.modal = document.getElementById(id);

        if (!this.modal) return false;

        this.nodes = {
          parents: [document.querySelector('html'), document.body]
        };

        this.config = Object.assign(defaults, options);

        this.modalIsOpen = false;

        this.focusOnOpen = this.config.focusOnOpen
        ? document.getElementById(this.config.focusOnOpen)
        : this.modal;

        this.openElement = document.querySelector(this.config.open);
        this.init();
      }

      Modal.prototype.init = function() {
        this.openElement.addEventListener('click', this.open.bind(this));

        this.modal
        .querySelector(this.config.close)
        .addEventListener('click', this.closeModal.bind(this));
      };

      Modal.prototype.open = function(evt) {
        var self = this;
        // Keep track if modal was opened from a click, or called by another function
        var externalCall = false;

        if (this.modalIsOpen) return;

        // Prevent following href if link is clicked
        if (evt) {
          evt.preventDefault();
        } else {
          externalCall = true;
        }

        // Without this, the modal opens, the click event bubbles up
        // which closes the modal.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
        }

        if (this.modalIsOpen && !externalCall) {
          this.closeModal();
        }

        this.modal.classList.add(this.config.openClass);

        this.nodes.parents.forEach(function(node) {
          node.classList.add(self.config.openClass);
        });

        this.modalIsOpen = true;

        slate.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen
        });

        this.bindEvents();
      };

      Modal.prototype.closeModal = function() {
        if (!this.modalIsOpen) return;

        document.activeElement.blur();

        this.modal.classList.remove(this.config.openClass);

        var self = this;

        this.nodes.parents.forEach(function(node) {
          node.classList.remove(self.config.openClass);
        });

        this.modalIsOpen = false;

        slate.a11y.removeTrapFocus({
          container: this.modal
        });

        this.openElement.focus();

        this.unbindEvents();
      };

      Modal.prototype.bindEvents = function() {
        this.keyupHandler = this.keyupHandler.bind(this);
        this.clickHandler = this.clickHandler.bind(this);
        document.body.addEventListener('keyup', this.keyupHandler);
        document.body.addEventListener('click', this.clickHandler);
      };

      Modal.prototype.unbindEvents = function() {
        document.body.removeEventListener('keyup', this.keyupHandler);
        document.body.removeEventListener('click', this.clickHandler);
      };

      Modal.prototype.keyupHandler = function(event) {
        if (event.keyCode === 27) {
          this.closeModal();
        }
      };

      Modal.prototype.clickHandler = function(event) {
        if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
          this.closeModal();
        }
      };

      return Modal;
    })();

    (function() {
      var selectors = {
        backButton: '.return-link'
      };

      var backButton = document.querySelector(selectors.backButton);

      if (!document.referrer || !backButton || !window.history.length) {
        return;
      }

      backButton.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();

          var referrerDomain = urlDomain(document.referrer);
          var shopDomain = urlDomain(window.location.href);

          if (shopDomain === referrerDomain) {
            history.back();
          }

          return false;
        },
        { once: true }
      );

      function urlDomain(url) {
        var anchor = document.createElement('a');
        anchor.ref = url;

        return anchor.hostname;
      }
    })();

    theme.Slideshow = (function() {
      var selectors = {
        button: '[data-slider-button]',
        indicator: '[data-slider-indicator]',
        indicators: '[data-slider-indicators]',
        pause: '[data-slider-pause]',
        slider: '[data-slider]',
        sliderItem: '[data-slider-item]',
        sliderItemLink: '[data-slider-item-link]',
        sliderTrack: '[data-slider-track]',
        sliderContainer: '[data-slider-container]'
      };

      var classes = {
        isPaused: 'slideshow__pause--is-paused',
        indicator: 'slider-indicators__item',
        indicatorActive: 'slick-active',
        sliderInitialized: 'slick-initialized',
        slideActive: 'slideshow__slide--active',
        slideClone: 'slick-cloned'
      };

      var attributes = {
        buttonNext: 'data-slider-button-next'
      };

      function Slideshow(container, options) {
        this.container = container;
        console.log(this.container,options);
        this.slider = this.container.querySelector(selectors.slider);
        if (!this.slider) return;

        this.eventHandlers = {};
        this.lastSlide = 0;
        this.slideIndex = 0;
        this.sliderContainer = null;
        this.slides = [];
        this.options = Object.assign(
          {},
          {
            autoplay: false,
            canUseKeyboardArrows: true,
            canUseTouchEvents: false,
            slideActiveClass: classes.slideActive,
            slideInterval: 0,
            slidesToShow: 0,
            slidesToScroll: 1,
            type: 'fade'
          },
          options
        );

        this.sliderContainer = this.slider.querySelector(selectors.sliderContainer);
        this.adaptHeight =
          this.sliderContainer.getAttribute('data-adapt-height') === 'true';
        this.slides = Array.from(
          this.sliderContainer.querySelectorAll(selectors.sliderItem)
        );
        // adding -1 to accomodate Array order
        this.lastSlide = this.slides.length - 1;
        this.buttons = this.container.querySelectorAll(selectors.button);
        this.pause = this.container.querySelector(selectors.pause);
        this.indicators = this.container.querySelectorAll(selectors.indicators);
		console.log(this.indicators);
        if (this.slides.length <= 1) return;

        this.timeout = 250;

        if (this.options.autoplay) {
          this.startAutoplay();
        }

        if (this.adaptHeight) {
          this.setSlideshowHeight();
        }

        if (this.options.type === 'slide') {
          this.isFirstSlide = false;
          this.isLastSlide = false;
          this.sliderItemWidthTotal = 0;
          this.sliderTrack = this.slider.querySelector(selectors.sliderTrack);
          // added setTimeout due to matchMedia calling too early
          // which result wrong value when getting dimension from an element
          this.sliderItemWidthTotal = 0;
          theme.Helpers.promiseStylesheet().then(
            function() {
              this._setupSlideType();
            }.bind(this)
          );
        } else {
          this.setupSlider(0);
        }

        this._setupEventHandlers();
      }

      Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
        /**
     * Moves to the previous slide
     */
        previousSlide: function() {
          this._move();
        },

        /**
     * Moves to the next slide
     */
        nextSlide: function() {
          this._move('next');
        },

        /**
     * Moves to the specified slide
     * @param {Number} index - The index of the slide to move to
     */
        setSlide: function(index) {
          this._setPosition(Number(index));
        },

        /**
     * Starts autoplaying the slider if autoplay is enabled
     */
        startAutoplay: function() {
          this.isAutoPlaying = true;

          window.clearTimeout(this.autoTimeOut);

          this.autoTimeOut = window.setTimeout(
            function() {
              var nextSlideIndex = this._getNextSlideIndex('next');
              this._setPosition(nextSlideIndex);
            }.bind(this),
            this.options.slideInterval
          );
        },

        /**
     * Stops autoplaying the slider if autoplay is enabled
     */
        stopAutoplay: function() {
          this.isAutoPlaying = false;

          window.clearTimeout(this.autoTimeOut);
        },

        /**
     * Set active states for sliders and indicators
     * @param {index} integer - Slide index to set up slider from
     */
        setupSlider: function(index) {
          this.slideIndex = index;
		
          if (this.indicators.length) {
            this._setActiveIndicator(index);
          }

          this._setupActiveSlide(index);
        },

        /**
     * Removes event listeners, among other things when wanting to destroy the
     * slider instance. This method needs to be called manually and will most
     * likely be included in a section's onUnload() method.
     */
        destroy: function() {
          if (this.adaptHeight) {
            window.removeEventListener('resize', this.eventHandlers.debounceResize);
          }

          this.container.removeEventListener(
            'focus',
            this.eventHandlers.focus,
            true
          );
          this.slider.removeEventListener(
            'focusin',
            this.eventHandlers.focusIn,
            true
          );
          this.slider.removeEventListener(
            'focusout',
            this.eventHandlers.focusOut,
            true
          );
          this.container.removeEventListener('blur', this.eventHandlers.blur, true);

          if (this.buttons) {
            this.buttons.forEach(
              function(button) {
                button.removeEventListener('click', this.eventHandlers.clickButton);
              }.bind(this)
            );
          }

          this.indicators.forEach(function(indicatorWrapper) {
            indicatorWrapper.childNodes.forEach(function(indicator) {
              indicator.firstElementChild.removeEventListener(
                'click',
                this.eventHandlers.onClickIndicator
              );

              indicator.firstElementChild.removeEventListener(
                'keydown',
                this.eventHandlers.onKeydownIndicator
              );
            }, this);
          }, this);

          if (this.options.type === 'slide') {
            window.removeEventListener(
              'resize',
              this.eventHandlers.debounceResizeSlideIn
            );

            if (this.touchEvents && this.options.canUseTouchEvents) {
              this.touchEvents.destroy();
              this.touchEvents = null;
            }
          }
        },

        _setupEventHandlers: function() {
          this.eventHandlers.focus = this._onFocus.bind(this);
          this.eventHandlers.focusIn = this._onFocusIn.bind(this);
          this.eventHandlers.focusOut = this._onFocusOut.bind(this);
          this.eventHandlers.blur = this._onBlur.bind(this);
          this.eventHandlers.keyUp = this._onKeyUp.bind(this);
          this.eventHandlers.clickButton = this._onClickButton.bind(this);
          this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this);
          this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(
            this
          );
          this.eventHandlers.onClickPause = this._onClickPause.bind(this);

          if (this.adaptHeight) {
            this.eventHandlers.debounceResize = theme.Helpers.debounce(
              function() {
                this.setSlideshowHeight();
              }.bind(this),
              50
            );

            window.addEventListener('resize', this.eventHandlers.debounceResize);
          }

          this.container.addEventListener('focus', this.eventHandlers.focus, true);
          this.slider.addEventListener('focusin', this.eventHandlers.focusIn, true);
          this.slider.addEventListener(
            'focusout',
            this.eventHandlers.focusOut,
            true
          );
          this.container.addEventListener('blur', this.eventHandlers.blur, true);

          if (this.buttons) {
            this.buttons.forEach(
              function(button) {
                button.addEventListener('click', this.eventHandlers.clickButton);
              }.bind(this)
            );
          }

          if (this.pause) {
            this.pause.addEventListener('click', this.eventHandlers.onClickPause);
          }

          this.indicators.forEach(function(indicatorWrapper) {
            indicatorWrapper.childNodes.forEach(function(indicator) {
              indicator.firstElementChild.addEventListener(
                'click',
                this.eventHandlers.onClickIndicator
              );

              indicator.firstElementChild.addEventListener(
                'keydown',
                this.eventHandlers.onKeydownIndicator
              );
            }, this);
          }, this);

          if (this.options.type === 'slide') {
            this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
              function() {
                this.sliderItemWidthTotal = 0;
                this._setupSlideType(true);
              }.bind(this),
              50
            );

            window.addEventListener(
              'resize',
              this.eventHandlers.debounceResizeSlideIn
            );

            if (
              this.options.canUseTouchEvents &&
              this.options.slidesToScroll < this.slides.length
            ) {
              this._setupTouchEvents();
            }
          }
        },

        _setupTouchEvents: function() {
          this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
            start: function() {
              this._onTouchStart();
            }.bind(this),
            move: function(event, direction, difference) {
              this._onTouchMove(event, direction, difference);
            }.bind(this),
            end: function(event, direction, difference) {
              this._onTouchEnd(event, direction, difference);
            }.bind(this)
          });
        },

        /**
     * Set slideshop for "slide-in" effect
     * @param {Boolean} onResize if function call came from resize event
     */
        _setupSlideType: function(onResize) {
          this.sliderItemWidth = Math.floor(
            this.sliderContainer.offsetWidth / this.options.slidesToShow
          );
          this.sliderTranslateXMove =
            this.sliderItemWidth * this.options.slidesToScroll;

          if (!onResize) {
            this.sliderContainer.classList.add(classes.sliderInitialized);
          }

          // Loop through all slider items
          // Set width according to the number of items to show in 1 slide
          // Set container width to accomodate all items
          this.slides.forEach(function(sliderItem, index) {
            var sliderItemLink = sliderItem.querySelector(selectors.sliderItemLink);
            sliderItem.style.width = this.sliderItemWidth + 'px';
            sliderItem.setAttribute('aria-hidden', true);
            sliderItem.setAttribute('tabindex', -1);
            this.sliderItemWidthTotal =
              this.sliderItemWidthTotal + sliderItem.offsetWidth;

            if (sliderItemLink) {
              sliderItemLink.setAttribute('tabindex', -1);
            }

            if (index < this.options.slidesToShow) {
              sliderItem.setAttribute('aria-hidden', false);
              sliderItem.classList.add(this.options.slideActiveClass);

              if (sliderItemLink) {
                sliderItemLink.setAttribute('tabindex', 0);
              }
            }
          }, this);

          this.sliderTrack.style.width =
            Math.floor(this.sliderItemWidthTotal) + 'px';
          this.sliderTrack.style.transform = 'translateX(-0px)';

          // set disabled attribute on Previous button
          if (this.buttons.length) {
            this.buttons[0].setAttribute('aria-disabled', true);
            this.buttons[1].removeAttribute('aria-disabled');
          }

          if (this.indicators.length) {
            this._setActiveIndicator(0);
          }
        },

        _onTouchStart: function() {
          this.touchStartPosition = this._getTranslateXPosition();
        },

        _onTouchMove: function(event, direction, difference) {
          // Fix touch events cause unexpected behaviour
          // when the dragging motion goes beyond the theme editor preview.
          var threshold = 80;
          if (
            Shopify.designMode &&
            (event.clientX <= threshold ||
             event.clientX >= window.innerWidth - threshold)
          ) {
            event.target.dispatchEvent(
              new MouseEvent('mouseup', {
                bubbles: true,
                cancelable: true
              })
            );
            return;
          }

          if (direction !== 'left' && direction !== 'right') return;

          this.touchMovePosition = this.touchStartPosition + difference.xPosition;

          this.sliderTrack.style.transform =
            'translateX(' + this.touchMovePosition + 'px';
        },

        _onTouchEnd: function(event, direction, difference) {
          var nextTranslateXPosition = 0;

          if (Object.keys(difference).length === 0) return;

          var slideDirection = direction === 'left' ? 'next' : '';

          if (direction === 'left') {
            if (this._isNextTranslateXLast(this.touchStartPosition)) {
              nextTranslateXPosition = this.touchStartPosition;
            } else {
              nextTranslateXPosition =
                this.touchStartPosition - this.sliderTranslateXMove;
            }
          } else {
            nextTranslateXPosition =
              this.touchStartPosition + this.sliderTranslateXMove;
            if (this._isNextTranslateXFirst(this.touchStartPosition)) {
              nextTranslateXPosition = 0;
            }
          }

          this.slideIndex = this._getNextSlideIndex(slideDirection);

          this.sliderTrack.style.transition = 'transform 500ms ease 0s';
          this.sliderTrack.style.transform =
            'translateX(' + nextTranslateXPosition + 'px';

          window.setTimeout(
            function() {
              this.sliderTrack.style.transition = '';
            }.bind(this),
            500
          );

          this._verifyFirstLastSlideTranslateX(nextTranslateXPosition);

          this._postTransitionEnd();
        },

        /**
     * Events handlers for next and previous button
     * @param {Object} event event handler
     */
        _onClickButton: function(event) {
          // prevent multiple clicks
          if (event.detail > 1) return;

          var button = event.currentTarget;
          var nextButton = button.hasAttribute(attributes.buttonNext);

          if (
            this.options.type === 'slide' &&
            button.getAttribute('aria-disabled') === 'true'
          ) {
            return;
          }

          if (this.options.autoplay && this.isAutoPlaying) {
            this.stopAutoplay();
          }

          if (nextButton) {
            this.nextSlide();
          } else {
            this.previousSlide();
          }
        },

        _onClickIndicator: function(event) {
          event.preventDefault();
			console.log('_onClickIndicator');
          if (event.target.classList.contains(classes.indicatorActive)) return;

          if (this.options.autoplay && this.isAutoPlaying) {
            this.stopAutoplay();
          }

          this.slideIndex = Number(event.target.dataset.slideNumber);
          alert();
          this.goToSlideByIndex(this.slideIndex);
          
        },

        goToSlideByIndex: function(index) {
          console.log(index);
           console.log(this);
          this._setPosition(index,this)

          if (this.options.type === 'slide' && this.sliderTrack) {
            this.sliderTrack.style.transition = 'transform 500ms ease 0s';
            var newPosition = index * this.slides[0].offsetWidth;

            this.sliderTrack.style.transform = 'translateX(-' + newPosition + 'px)';

            if (this.options.slidesToShow > 1) {
              this._verifyFirstLastSlideTranslateX(newPosition);

              if (this.buttons.length) {
                this._disableArrows();
              }

              this._setupMultipleActiveSlide(
                index,
                index + (this.options.slidesToShow - 1)
              );
            }
          }
        },

        _onKeydownIndicator: function(event) {
          if (event.keyCode !== slate.utils.keyboardKeys.ENTER) return;

          this._onClickIndicator(event);

          this.slider.focus();
        },

        _onClickPause: function(event) {
          if (!event.currentTarget.classList.contains(classes.isPaused)) {
            event.currentTarget.classList.add(classes.isPaused);
            this.stopAutoplay();
          } else {
            event.currentTarget.classList.remove(classes.isPaused);
            this.startAutoplay();
          }
        },

        _onFocus: function() {
          this.container.addEventListener('keyup', this.eventHandlers.keyUp);
        },

        _onFocusIn: function() {
          if (this.slider.hasAttribute('aria-live')) return;

          if (this.options.autoplay && this.isAutoPlaying) {
            this.stopAutoplay();
          }

          this.slider.setAttribute('aria-live', 'polite');
        },

        _onBlur: function() {
          this.container.removeEventListener('keyup', this.eventHandlers.keyUp);
        },

        _onFocusOut: function() {
          this.slider.removeAttribute('aria-live');

          // Adding a setTimeout because everytime we focus out
          // It automatically goes to <body>
          // We want to resume autoplay when focus is outside of the slideshow container
          setTimeout(
            function() {
              if (
                !document.activeElement.closest(
                  '#' + this.slider.getAttribute('id')
                )
              ) {
                if (
                  this.options.autoplay &&
                  !this.isAutoPlaying &&
                  !this.pause.classList.contains(classes.isPaused)
                ) {
                  this.startAutoplay();
                }
              }
            }.bind(this),
            this.timeout
          );
        },

        _onKeyUp: function(event) {
          switch (event.keyCode) {
            case slate.utils.keyboardKeys.LEFTARROW:
              if (!this.options.canUseKeyboardArrows) return;

              if (this.options.type === 'slide' && this.isFirstSlide) {
                return;
              }

              this.previousSlide();

              break;
            case slate.utils.keyboardKeys.RIGHTARROW:
              if (!this.options.canUseKeyboardArrows) return;

              if (this.options.type === 'slide' && this.isLastSlide) {
                return;
              }

              this.nextSlide();

              break;
            case slate.utils.keyboardKeys.ESCAPE:
              this.slider.blur();
              break;
          }
        },

        _move: function(direction) {
          if (this.options.type === 'slide') {
            this.slideIndex = this._getNextSlideIndex(direction);
            this._moveSlideshow(direction);
          } else {
            var nextSlideIndex = this._getNextSlideIndex(direction);
            this._setPosition(nextSlideIndex);
          }
        },

        _moveSlideshow: function(direction) {
          this.direction = direction;
          var valueXToMove = 0;

          // Get current position of translateX
          var currentTranslateXPosition = this._getTranslateXPosition();
          var currentActiveSlidesIndex = this._getActiveSlidesIndex();

          // In the future, we'll use ES6 deconstructure
          // Math.min(...currentActiveSlidesIndex);
          var currentActiveSlidesMinIndex = Math.min.apply(
            Math,
            currentActiveSlidesIndex
          );
          var currentActiveSlidesMaxIndex = Math.max.apply(
            Math,
            currentActiveSlidesIndex
          );

          // Set the next active state depending on the direction
          // We bump up the index depending on the "slidesToShow" option
          this.nextMinIndex =
            direction === 'next'
          ? currentActiveSlidesMinIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - this.options.slidesToShow;
          this.nextMaxIndex =
            direction === 'next'
          ? currentActiveSlidesMaxIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - 1;

          this.sliderTrack.style.transition = 'transform 500ms ease 0s';

          if (direction === 'next') {
            valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove;
            this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
          } else {
            valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove;
            this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
          }

          this._verifyFirstLastSlideTranslateX(valueXToMove);

          this._postTransitionEnd();

          this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
        },

        _setPosition: function(nextSlideIndex) {
          this.slideIndex = nextSlideIndex;
          console.log(this.indicators);
          if (this.indicators.length) {
            this._setActiveIndicator(nextSlideIndex);
          }

          this._setupActiveSlide(nextSlideIndex);

          if (this.options.autoplay && this.isAutoPlaying) {
            this.startAutoplay();
          }

          this.container.dispatchEvent(
            new CustomEvent('slider_slide_changed', {
              detail: nextSlideIndex
            })
          );
        },

        _setupActiveSlide: function(index) {
          this.slides.forEach(function(slide) {
            slide.setAttribute('aria-hidden', true);
            slide.classList.remove(this.options.slideActiveClass);
          }, this);

          this.slides[index].setAttribute('aria-hidden', false);
          this.slides[index].classList.add(this.options.slideActiveClass);
        },

        /**
     * Loops through all slide items
     * Set the active state depending the direction and slide indexes
     * Because slide-in effect can have multiple items in 1 slide, we need to target multiple active elements
     * @param {String} direction "next" for next slides or empty string for previous
     * @param {*} minIndex the current active minimum index
     * @param {*} maxIndex the current active maximum index
     */
        _setupMultipleActiveSlide: function(minIndex, maxIndex) {
          this.slides.forEach(function(slide) {
            var sliderIndex = Number(slide.getAttribute('data-slider-slide-index'));
            var sliderItemLink = slide.querySelector(selectors.sliderItemLink);

            slide.setAttribute('aria-hidden', true);
            slide.classList.remove(this.options.slideActiveClass);
            if (sliderItemLink) {
              sliderItemLink.setAttribute('tabindex', -1);
            }

            if (sliderIndex >= minIndex && sliderIndex <= maxIndex) {
              slide.setAttribute('aria-hidden', false);
              slide.classList.add(this.options.slideActiveClass);

              if (sliderItemLink) {
                sliderItemLink.setAttribute('tabindex', 0);
              }
            }
          }, this);
        },

        _setActiveIndicator: function(index) {
          this.indicators.forEach(function(indicatorWrapper) {
            var activeIndicator = indicatorWrapper.querySelector(
              '.' + classes.indicatorActive
            );

            var nextIndicator = indicatorWrapper.childNodes[index];

            if (activeIndicator) {
              activeIndicator.setAttribute('aria-selected', false);
              activeIndicator.classList.remove(classes.indicatorActive);
              activeIndicator.firstElementChild.removeAttribute('aria-current');
            }

            nextIndicator.classList.add(classes.indicatorActive);
            nextIndicator.setAttribute('aria-selected', true);
            nextIndicator.firstElementChild.setAttribute('aria-current', true);
          }, this);
        },

        setSlideshowHeight: function() {
          var minAspectRatio = this.sliderContainer.getAttribute(
            'data-min-aspect-ratio'
          );
          this.sliderContainer.style.height =
            document.documentElement.offsetWidth / minAspectRatio + 'px';
        },

        /**
     * Increase or decrease index position of the slideshow
     * Automatically auto-rotate
     * - Last slide goes to first slide when clicking "next"
     * - First slide goes to last slide when clicking "previous"
     * @param {String} direction "next" as a String, other empty string is previous slide
     */
        _getNextSlideIndex: function(direction) {
          var counter = direction === 'next' ? 1 : -1;

          if (direction === 'next') {
            if (this.slideIndex === this.lastSlide) {
              return this.options.type === 'slide' ? this.lastSlide : 0;
            }
          } else if (!this.slideIndex) {
            return this.options.type === 'slide' ? 0 : this.lastSlide;
          }

          return this.slideIndex + counter;
        },

        /**
     * In "slide-in" type, multiple items are active in 1 slide
     * This will return an array containing their indexes
     */
        _getActiveSlidesIndex: function() {
          var currentActiveSlides = this.slides.filter(function(sliderItem) {
            if (sliderItem.classList.contains(this.options.slideActiveClass)) {
              return sliderItem;
            }
          }, this);
          var currentActiveSlidesIndex = currentActiveSlides.map(function(
                                                                 sliderItem
          ) {
            return Number(sliderItem.getAttribute('data-slider-slide-index'));
          });

          return currentActiveSlidesIndex;
        },

        /**
     * This checks the next "translateX" value and verifies
     * If it's at the last slide or beginning of the slide
     * So we can disable the arrow buttons
     */
        _disableArrows: function() {
          if (this.buttons.length === 0) return;

          var previousButton = this.buttons[0];
          var nextButton = this.buttons[1];

          // first slide
          if (this.isFirstSlide) {
            previousButton.setAttribute('aria-disabled', true);
          } else {
            previousButton.removeAttribute('aria-disabled');
          }

          // last slide
          if (this.isLastSlide) {
            nextButton.setAttribute('aria-disabled', true);
          } else {
            nextButton.removeAttribute('aria-disabled');
          }
        },

        /**
     * Verify if translateX reaches at first or last slide
     * @param {Number} translateXValue
     */
        _verifyFirstLastSlideTranslateX: function(translateXValue) {
          // first slide
          if (this._isNextTranslateXFirst(translateXValue)) {
            this.isFirstSlide = true;
          } else {
            this.isFirstSlide = false;
          }

          // last slide
          if (this._isNextTranslateXLast(translateXValue)) {
            this.isLastSlide = true;
          } else {
            this.isLastSlide = false;
          }
        },

        _getTranslateXPosition: function() {
          return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
        },

        _isNextTranslateXFirst: function(translateXValue) {
          return translateXValue === 0;
        },

        _isNextTranslateXLast: function(translateXValue) {
          // because translateX values are using negative, I'm converting into positive value
          var translateXValueAbsolute = Math.abs(translateXValue);
          var nextTranslateXValue =
              translateXValueAbsolute + this.sliderTranslateXMove;

          return nextTranslateXValue >= this.sliderItemWidthTotal;
        },

        _postTransitionEnd: function() {
          if (this.buttons.length) {
            this._disableArrows();
          }

          if (this.indicators.length) {
            this._setActiveIndicator(this.slideIndex);
          }
        }
      });

      return Slideshow;
    })();

    theme.Video = (function() {
      var autoplayCheckComplete = false;
      var playOnClickChecked = false;
      var playOnClick = false;
      var youtubeLoaded = false;
      var videos = {};
      var videoPlayers = [];
      var videoOptions = {
        ratio: 16 / 9,
        scrollAnimationDuration: 400,
        playerVars: {
          // eslint-disable-next-line camelcase
          iv_load_policy: 3,
          modestbranding: 1,
          autoplay: 0,
          controls: 0,
          wmode: 'opaque',
          branding: 0,
          autohide: 0,
          rel: 0
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerChange
        }
      };
      var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        backgroundVideoWrapper: 'video-background-wrapper',
        videoWithImage: 'video--image_with_play',
        backgroundVideo: 'video--background',
        userPaused: 'is-paused',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay',
        wrapperMinHeight: 'video-section-wrapper--min-height'
      };

      var selectors = {
        section: '.video-section',
        videoWrapper: '.video-section-wrapper',
        playVideoBtn: '.video-control__play',
        closeVideoBtn: '.video-control__close-wrapper',
        pauseVideoBtn: '.video__pause',
        pauseVideoStop: '.video__pause-stop',
        pauseVideoResume: '.video__pause-resume',
        fallbackText: '.icon__fallback-text'
      };

      /**
   * Public functions
   */
      function init(video) {
        if (!video) return;

        videos[video.id] = {
          id: video.id,
          videoId: video.dataset.id,
          type: video.dataset.type,
          status:
          video.dataset.type === 'image_with_play' ? 'closed' : 'background', // closed, open, background
          video: video,
          videoWrapper: video.closest(selectors.videoWrapper),
          section: video.closest(selectors.section),
          controls: video.dataset.type === 'background' ? 0 : 1
        };

        if (!youtubeLoaded) {
          // This code loads the IFrame Player API code asynchronously.
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        playOnClickCheck();
      }

      function customPlayVideo(playerId) {
        // Make sure we have carried out the playOnClick check first
        if (!playOnClickChecked && !playOnClick) {
          return;
        }

        if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
          privatePlayVideo(playerId);
        }
      }

      function pauseVideo(playerId) {
        if (
          videoPlayers[playerId] &&
          typeof videoPlayers[playerId].pauseVideo === 'function'
        ) {
          videoPlayers[playerId].pauseVideo();
        }
      }

      function loadVideos() {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            createPlayer(key);
          }
        }

        initEvents();
        youtubeLoaded = true;
      }

      function editorLoadVideo(key) {
        if (!youtubeLoaded) {
          return;
        }
        createPlayer(key);

        initEvents();
      }

      /**
   * Private functions
   */

      function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var videoWrapper = videoData.videoWrapper;

        if (playOnClick) {
          // playOnClick means we are probably on mobile (no autoplay).
          // setAsPlaying will show the iframe, requiring another click
          // to play the video.
          setAsPlaying(videoData);
        } else if (clicked || autoplayCheckComplete) {
          // Play if autoplay is available or clicked to play
          videoWrapper.classList.remove(classes.loading);
          setAsPlaying(videoData);
          player.playVideo();
          return;
        } else {
          player.playVideo();
        }
      }

      function setAutoplaySupport(supported) {
        var supportClass = supported
        ? classes.supportsAutoplay
        : classes.supportsNoAutoplay;
        document.documentElement.classList.remove(
          classes.supportsAutoplay,
          classes.supportsNoAutoplay
        );
        document.documentElement.classList.add(supportClass);

        if (!supported) {
          playOnClick = true;
        }

        autoplayCheckComplete = true;
      }

      function playOnClickCheck() {
        if (playOnClickChecked) {
          return;
        }

        if (isMobile()) {
          playOnClick = true;
        }

        if (playOnClick) {
          // No need to also do the autoplay check
          setAutoplaySupport(false);
        }

        playOnClickChecked = true;
      }

      // The API will call this function when each video player is ready
      function onPlayerReady(evt) {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);
        var videoTitle = evt.target.getVideoData().title;
        playOnClickCheck();

        // Prevent tabbing through YouTube player controls until visible
        document.getElementById(videoData.id).setAttribute('tabindex', '-1');

        sizeBackgroundVideos();
        setButtonLabels(videoData.videoWrapper, videoTitle);

        // Customize based on options from the video ID
        if (videoData.type === 'background') {
          evt.target.mute();
          privatePlayVideo(videoData.id);
        }

        videoData.videoWrapper.classList.add(classes.loaded);
      }

      function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        if (
          videoData.status === 'background' &&
          !isMobile() &&
          !autoplayCheckComplete &&
          (evt.data === YT.PlayerState.PLAYING ||
           evt.data === YT.PlayerState.BUFFERING)
        ) {
          setAutoplaySupport(true);
          autoplayCheckComplete = true;
          videoData.videoWrapper.classList.remove(classes.loading);
        }
        switch (evt.data) {
          case YT.PlayerState.ENDED:
            setAsFinished(videoData);
            break;
          case YT.PlayerState.PAUSED:
            // Seeking on a YouTube video also fires a PAUSED state change,
            // checking the state after a delay prevents us pausing the video when
            // the user is seeking instead of pausing
            setTimeout(function() {
              if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
                setAsPaused(videoData);
              }
            }, 200);
            break;
        }
      }

      function setAsFinished(videoData) {
        switch (videoData.type) {
          case 'background':
            videoPlayers[videoData.id].seekTo(0);
            break;
          case 'image_with_play':
            closeVideo(videoData.id);
            toggleExpandVideo(videoData.id, false);
            break;
        }
      }

      function setAsPlaying(videoData) {
        var videoWrapper = videoData.videoWrapper;
        var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

        videoWrapper.classList.remove(classes.loading);

        if (pauseButton.classList.contains(classes.userPaused)) {
          pauseButton.classList.remove(classes.userPaused);
        }

        // Do not change element visibility if it is a background video
        if (videoData.status === 'background') {
          return;
        }

        document.getElementById(videoData.id).setAttribute('tabindex', '0');

        if (videoData.type === 'image_with_play') {
          videoWrapper.classList.remove(classes.paused);
          videoWrapper.classList.add(classes.playing);
        }

        // Update focus to the close button so we stay within the video wrapper,
        // allowing time for the scroll animation
        setTimeout(function() {
          videoWrapper.querySelector(selectors.closeVideoBtn).focus();
        }, videoOptions.scrollAnimationDuration);
      }

      function setAsPaused(videoData) {
        var videoWrapper = videoData.videoWrapper;

        // YT's events fire after our click event. This status flag ensures
        // we don't interact with a closed or background video.
        if (videoData.type === 'image_with_play') {
          if (videoData.status === 'closed') {
            videoWrapper.classList.remove(classes.paused);
          } else {
            videoWrapper.classList.add(classes.paused);
          }
        }

        videoWrapper.classList.remove(classes.playing);
      }

      function closeVideo(playerId) {
        var videoData = videos[playerId];
        var videoWrapper = videoData.videoWrapper;

        document.getElementById(videoData.id).setAttribute('tabindex', '-1');

        videoData.status = 'closed';

        switch (videoData.type) {
          case 'image_with_play':
            videoPlayers[playerId].stopVideo();
            setAsPaused(videoData); // in case the video is already paused
            break;
          case 'background':
            videoPlayers[playerId].mute();
            setBackgroundVideo(playerId);
            break;
        }

        videoWrapper.classList.remove(classes.paused, classes.playing);
      }

      function getVideoOptions(evt) {
        var id = evt.target.getIframe().id;
        return videos[id];
      }

      function toggleExpandVideo(playerId, expand) {
        var video = videos[playerId];
        var elementTop =
            video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
        var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
        var offset = 0;
        var newHeight = 0;

        if (isMobile()) {
          video.videoWrapper.parentElement.classList.toggle('page-width', !expand);
        }

        if (expand) {
          if (isMobile()) {
            newHeight = window.innerWidth / videoOptions.ratio;
          } else {
            newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
          }
          offset = (window.innerHeight - newHeight) / 2;

          video.videoWrapper.style.height =
            video.videoWrapper.getBoundingClientRect().height + 'px';
          video.videoWrapper.classList.remove(classes.wrapperMinHeight);
          video.videoWrapper.style.height = newHeight + 'px';

          // Animate doesn't work in mobile editor, so we don't use it
          if (!(isMobile() && Shopify.designMode)) {
            var scrollBehavior = document.documentElement.style.scrollBehavior;
            document.documentElement.style.scrollBehavior = 'smooth';
            window.scrollTo({ top: elementTop - offset });
            document.documentElement.style.scrollBehavior = scrollBehavior;
          }
        } else {
          if (isMobile()) {
            newHeight = video.videoWrapper.dataset.mobileHeight;
          } else {
            newHeight = video.videoWrapper.dataset.desktopHeight;
          }

          video.videoWrapper.style.height = newHeight + 'px';

          setTimeout(function() {
            video.videoWrapper.classList.add(classes.wrapperMinHeight);
          }, 600);
          // Set focus on play button, but don't scroll page
          var x = window.scrollX;
          var y = window.scrollY;
          playButton.focus();
          window.scrollTo(x, y);
        }
      }

      function togglePause(playerId) {
        var pauseButton = videos[playerId].videoWrapper.querySelector(
          selectors.pauseVideoBtn
        );
        var paused = pauseButton.classList.contains(classes.userPaused);
        if (paused) {
          pauseButton.classList.remove(classes.userPaused);
          customPlayVideo(playerId);
        } else {
          pauseButton.classList.add(classes.userPaused);
          pauseVideo(playerId);
        }
        pauseButton.setAttribute('aria-pressed', !paused);
      }

      function startVideoOnClick(playerId) {
        var video = videos[playerId];

        // add loading class to wrapper
        video.videoWrapper.classList.add(classes.loading);

        // Explicity set the video wrapper height (needed for height transition)
        video.videoWrapper.style.height = video.videoWrapper.offsetHeight + 'px';

        video.status = 'open';

        switch (video.type) {
          case 'image_with_play':
            privatePlayVideo(playerId, true);
            break;
          case 'background':
            unsetBackgroundVideo(playerId, video);
            videoPlayers[playerId].unMute();
            privatePlayVideo(playerId, true);
            break;
        }

        toggleExpandVideo(playerId, true);

        // esc to close video player
        document.addEventListener('keydown', handleVideoPlayerKeydown);
      }

      var handleVideoPlayerKeydown = function(evt) {
        var playerId = document.activeElement.dataset.controls;
        if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
          return;
        }

        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      };

      function sizeBackgroundVideos() {
        var backgroundVideos = document.querySelectorAll(
          '.' + classes.backgroundVideo
        );
        backgroundVideos.forEach(function(el) {
          sizeBackgroundVideo(el);
        });
      }

      function sizeBackgroundVideo(videoPlayer) {
        if (!youtubeLoaded) {
          return;
        }

        if (isMobile()) {
          videoPlayer.style.cssText = null;
        } else {
          var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
          var videoWidth = videoWrapper.clientWidth;
          var playerWidth = videoPlayer.clientWidth;
          var desktopHeight = videoWrapper.dataset.desktopHeight;

          // when screen aspect ratio differs from video, video must center and underlay one dimension
          if (videoWidth / videoOptions.ratio < desktopHeight) {
            playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
            var styles =
                'width: ' +
                playerWidth +
                'px; height: ' +
                desktopHeight +
                'px; left: ' +
                (videoWidth - playerWidth) / 2 +
                'px; top: 0;';
            videoPlayer.style.cssText = styles;
          } else {
            // new video width < window width (gap to right)
            desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
            var styles2 =
                'width: ' +
                videoWidth +
                'px; height: ' +
                desktopHeight +
                'px; top: ' +
                (desktopHeight - desktopHeight) / 2 +
                'px; left: 0;'; // player height is greater, offset top; reset left
            videoPlayer.style.cssText = styles2;
          }

          theme.Helpers.prepareTransition(videoPlayer);
          videoWrapper.classList.add(classes.loaded);
        }
      }

      function unsetBackgroundVideo(playerId) {
        // Switch the background video to a chrome-only player once played
        var player = document.getElementById(playerId);
        player.classList.remove(classes.backgroundVideo);
        player.classList.add(classes.videoWithImage);

        setTimeout(function() {
          document.getElementById(playerId).style.cssText = null;
        }, 600);

        videos[playerId].videoWrapper.classList.remove(
          classes.backgroundVideoWrapper
        );
        videos[playerId].videoWrapper.classList.add(classes.playing);

        videos[playerId].status = 'open';
      }

      function setBackgroundVideo(playerId) {
        var player = document.getElementById(playerId);
        player.classList.remove(classes.videoWithImage);
        player.classList.add(classes.backgroundVideo);

        videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

        videos[playerId].status = 'background';
        sizeBackgroundVideo(player);
      }

      function isMobile() {
        return window.innerWidth < theme.breakpoints.medium;
      }

      var handleWindowResize = theme.Helpers.debounce(function() {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;
        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].videoWrapper.classList.contains(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].videoWrapper.style.height =
                document.documentElement.clientWidth / videoOptions.ratio + 'px';
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            var videosWithImage = videos[key].videoWrapper.querySelectorAll(
              '.' + classes.videoWithImage
            );
            if (videosWithImage.length) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      }, 200);

      var handleWindowScroll = theme.Helpers.debounce(function() {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var videoWrapper = videos[key].videoWrapper;
            var condition =
                videoWrapper.getBoundingClientRect().top +
                window.pageYOffset +
                videoWrapper.offsetHeight * 0.75 <
                window.pageYOffset ||
                videoWrapper.getBoundingClientRect().top +
                window.pageYOffset +
                videoWrapper.offsetHeight * 0.25 >
                window.pageYOffset + window.innerHeight;

            // Close the video if more than 75% of it is scrolled out of view
            if (videoWrapper.classList.contains(classes.playing)) {
              if (!condition) return;
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      }, 50);

      function initEvents() {
        var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
        var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
        var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

        playVideoBtns.forEach(function(btn) {
          btn.addEventListener('click', function(evt) {
            var playerId = evt.currentTarget.dataset.controls;
            startVideoOnClick(playerId);
          });
        });

        closeVideoBtns.forEach(function(btn) {
          btn.addEventListener('click', function(evt) {
            var playerId = evt.currentTarget.dataset.controls;

            evt.currentTarget.blur();
            closeVideo(playerId);
            toggleExpandVideo(playerId, false);
          });
        });

        pauseVideoBtns.forEach(function(btn) {
          btn.addEventListener('click', function(evt) {
            var playerId = evt.currentTarget.dataset.controls;
            togglePause(playerId);
          });
        });

        // Listen to resize to keep a background-size:cover-like layout
        window.addEventListener('resize', handleWindowResize);

        window.addEventListener('scroll', handleWindowScroll);
      }

      function createPlayer(key) {
        var args = Object.assign(videoOptions, videos[key]);

        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }

      function removeEvents() {
        document.removeEventListener('keydown', handleVideoPlayerKeydown);
        window.removeEventListener('resize', handleWindowResize);
        window.removeEventListener('scroll', handleWindowScroll);
      }

      function setButtonLabels(videoWrapper, title) {
        var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
        var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
        var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
        var closeButtonText = closeButton.querySelector(selectors.fallbackText);

        var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
        var pauseButtonStopText = pauseButtonStop.querySelector(
          selectors.fallbackText
        );

        var pauseButtonResume = pauseButton.querySelector(
          selectors.pauseVideoResume
        );
        var pauseButtonResumeText = pauseButtonResume.querySelector(
          selectors.fallbackText
        );

        // Insert the video title retrieved from YouTube into the instructional text
        // for each button
        playButtons.forEach(function(playButton) {
          var playButtonText = playButton.querySelector(selectors.fallbackText);

          playButtonText.textContent = playButtonText.textContent.replace(
            '[video_title]',
            title
          );
        });
        closeButtonText.textContent = closeButtonText.textContent.replace(
          '[video_title]',
          title
        );
        pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
          '[video_title]',
          title
        );
        pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
          '[video_title]',
          title
        );
      }

      return {
        init: init,
        editorLoadVideo: editorLoadVideo,
        loadVideos: loadVideos,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
      };
    })();

    theme.ProductVideo = (function() {
      var videos = {};

      var hosts = {
        shopify: 'shopify',
        external: 'external'
      };

      var selectors = {
        productMediaWrapper: '[data-product-single-media-wrapper]'
      };

      var attributes = {
        enableVideoLooping: 'enable-video-looping',
        videoId: 'video-id'
      };

      function init(videoContainer, sectionId) {
        if (!videoContainer) {
          return;
        }

        var videoElement = videoContainer.querySelector('iframe, video');

        if (!videoElement) {
          return;
        }

        var mediaId = videoContainer.getAttribute('data-media-id');

        videos[mediaId] = {
          mediaId: mediaId,
          sectionId: sectionId,
          host: hostFromVideoElement(videoElement),
          container: videoContainer,
          element: videoElement,
          ready: function() {
            createPlayer(this);
          }
        };

        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '2.0',
            onLoad: setupVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
      }

      function setupVideos(errors) {
        if (errors) {
          fallbackToNativeVideo();
          return;
        }

        loadVideos();
      }

      function createPlayer(video) {
        if (video.player) {
          return;
        }

        var productMediaWrapper = video.container.closest(
          selectors.productMediaWrapper
        );

        var enableLooping =
            productMediaWrapper.getAttribute(
              'data-' + attributes.enableVideoLooping
            ) === 'true';

        // eslint-disable-next-line no-undef
        video.player = new Shopify.Video(video.element, {
          loop: { active: enableLooping }
        });

        var pauseVideo = function() {
          if (!video.player) return;
          video.player.pause();
        };

        productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
        productMediaWrapper.addEventListener('xrLaunch', pauseVideo);

        productMediaWrapper.addEventListener('mediaVisible', function() {
          if (theme.Helpers.isTouch()) return;
          if (!video.player) return;
          video.player.play();
        });
      }

      function hostFromVideoElement(video) {
        if (video.tagName === 'VIDEO') {
          return hosts.shopify;
        }

        return hosts.external;
      }

      function loadVideos() {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];
            video.ready();
          }
        }
      }

      function fallbackToNativeVideo() {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.nativeVideo) continue;

            if (video.host === hosts.shopify) {
              video.element.setAttribute('controls', 'controls');
              video.nativeVideo = true;
            }
          }
        }
      }

      function removeSectionVideos(sectionId) {
        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var video = videos[key];

            if (video.sectionId === sectionId) {
              if (video.player) video.player.destroy();
              delete videos[key];
            }
          }
        }
      }

      return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
      };
    })();

    theme.ProductModel = (function() {
      var modelJsonSections = {};
      var models = {};
      var xrButtons = {};

      var selectors = {
        mediaGroup: '[data-product-single-media-group]',
        xrButton: '[data-shopify-xr]'
      };

      function init(modelViewerContainers, sectionId) {
        modelJsonSections[sectionId] = {
          loaded: false
        };

        modelViewerContainers.forEach(function(modelViewerContainer, index) {
          var mediaId = modelViewerContainer.getAttribute('data-media-id');
          var modelViewerElement = modelViewerContainer.querySelector(
            'model-viewer'
          );
          var modelId = modelViewerElement.getAttribute('data-model-id');

          if (index === 0) {
            var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
            var xrButton = mediaGroup.querySelector(selectors.xrButton);
            xrButtons[sectionId] = {
              element: xrButton,
              defaultId: modelId
            };
          }

          models[mediaId] = {
            modelId: modelId,
            sectionId: sectionId,
            container: modelViewerContainer,
            element: modelViewerElement
          };
        });

        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: setupShopifyXr
          },
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: setupModelViewerUi
          }
        ]);
        theme.LibraryLoader.load('modelViewerUiStyles');
      }

      function setupShopifyXr(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', function() {
            setupShopifyXr();
          });
          return;
        }

        for (var sectionId in modelJsonSections) {
          if (modelJsonSections.hasOwnProperty(sectionId)) {
            var modelSection = modelJsonSections[sectionId];

            if (modelSection.loaded) continue;
            var modelJson = document.querySelector('#ModelJson-' + sectionId);

            window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
            modelSection.loaded = true;
          }
        }
        window.ShopifyXR.setupXRElements();
      }

      function setupModelViewerUi(errors) {
        if (errors) return;

        for (var key in models) {
          if (models.hasOwnProperty(key)) {
            var model = models[key];
            if (!model.modelViewerUi) {
              model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
            }
            setupModelViewerListeners(model);
          }
        }
      }

      function setupModelViewerListeners(model) {
        var xrButton = xrButtons[model.sectionId];

        model.container.addEventListener('mediaVisible', function() {
          xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
          if (theme.Helpers.isTouch()) return;
          model.modelViewerUi.play();
        });

        model.container.addEventListener('mediaHidden', function() {
          xrButton.element.setAttribute(
            'data-shopify-model3d-id',
            xrButton.defaultId
          );
          model.modelViewerUi.pause();
        });

        model.container.addEventListener('xrLaunch', function() {
          model.modelViewerUi.pause();
        });
      }

      function removeSectionModels(sectionId) {
        for (var key in models) {
          if (models.hasOwnProperty(key)) {
            var model = models[key];
            if (model.sectionId === sectionId) {
              models[key].modelViewerUi.destroy();
              delete models[key];
            }
          }
        }
        delete modelJsonSections[sectionId];
      }

      return {
        init: init,
        removeSectionModels: removeSectionModels
      };
    })();

    window.theme = window.theme || {};

    theme.FormStatus = (function() {
      var selectors = {
        statusMessage: '[data-form-status]'
      };

      function init() {
        var statusMessages = document.querySelectorAll(selectors.statusMessage);

        statusMessages.forEach(function(statusMessage) {
          statusMessage.setAttribute('tabindex', -1);
          statusMessage.focus();

          statusMessage.addEventListener(
            'blur',
            function(evt) {
              evt.target.removeAttribute('tabindex');
            },
            { once: true }
          );
        });
      }

      return {
        init: init
      };
    })();

    theme.Hero = (function() {
      var classes = {
        indexSectionFlush: 'index-section--flush'
      };

      var selectors = {
        heroFixedWidthContent: '.hero-fixed-width__content',
        heroFixedWidthImage: '.hero-fixed-width__image'
      };

      function hero(el, sectionId) {
        var hero = document.querySelector(el);
        var layout = hero.getAttribute('data-layout');
        var parentSection = document.querySelector('#shopify-section-' + sectionId);
        var heroContent = parentSection.querySelector(
          selectors.heroFixedWidthContent
        );
        var heroImage = parentSection.querySelector(selectors.heroFixedWidthImage);

        if (layout !== 'fixed_width') {
          return;
        }

        parentSection.classList.remove(classes.indexSectionFlush);
        heroFixedHeight();

        window.addEventListener('resize', function() {
          theme.Helpers.debounce(function() {
            heroFixedHeight();
          }, 50);
        });

        function heroFixedHeight() {
          var contentHeight;
          var imageHeight;

          if (heroContent) {
            contentHeight = heroContent.offsetHeight + 50;
          }

          if (heroImage) {
            imageHeight = heroImage.offsetHeight;
          }

          if (contentHeight > imageHeight) {
            heroImage.style.minHeight = contentHeight + 'px';
          }
        }
      }

      return hero;
    })();

    // prettier-ignore
    window.theme = window.theme || {};

    theme.SearchResultsTemplate = (function() {
      function renderResults(products, isLoading, searchQuery) {
        return [
          '<div class="predictive-search">',
          renderHeader(products, isLoading),
          renderProducts(products, searchQuery),
          '</div>'
        ].join('');
      }

      function renderHeader(products, isLoading) {
        if (products.length === 0) {
          return '';
        }

        return [
          '<div class="predictive-search-title">',
          '<h3 id="predictive-search" class="predictive-search-title__content">' +
          theme.strings.products +
          '</h3>',
          '<span class="predictive-search-title__loading-spinner">' +
          (isLoading
           ? '<span class= "icon-predictive-search-spinner" ></span >'
           : '') +
          '</span>',
          '</div>'
        ].join('');
      }

      function loadingState() {
        return [
          '<div class="predictive-search">',
          '<div class="predictive-search-loading">',
          '<span class="visually-hidden">' + theme.strings.loading + '</span>',
          '<span class="predictive-search-loading__icon">',
          '<span class="icon-predictive-search-spinner"></span>',
          '</span>',
          '</div>',
          '</div>'
        ].join('');
      }

      function renderViewAll(searchQuery) {
        return [
          '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
          theme.strings.searchFor +
          '<span class="predictive-search-view-all__query"> &ldquo;' +
          _htmlEscape(searchQuery) +
          '&rdquo;</span>',
          '</button>'
        ].join('');
      }

      function renderProducts(products, searchQuery) {
        var resultsCount = products.length;

        return [
          '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
          products
          .map(function(product, index) {
            return renderProduct(normalizeProduct(product), index, resultsCount);
          })
          .join(''),
          '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
          renderViewAll(searchQuery) +
          '</li>',
          '</ul>'
        ].join('');
      }

      function renderProduct(product, index, resultsCount) {
        return [
          '<li id="search-result-' +
          index +
          '" class="predictive-search-item" role="option" data-search-result>',
          '<a class="predictive-search-item__link" href="' +
          product.url +
          '" tabindex="-1">',
          '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
          renderProductImage(product),
          '</div>',
          '<div class="predictive-search__column predictive-search__column--content ' +
          (getDetailsCount() ? '' : 'predictive-search__column--center') +
          '">',
          '<span class="predictive-search-item__title">',
          '<span class="predictive-search-item__title-text">' +
          product.title +
          '</span>',
          '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
          '<span class="visually-hidden">, </span>',
          '<span class="visually-hidden">' +
          getNumberOfResultsString(index + 1, resultsCount) +
          '</span>',
          '</div>',
          '</a>',
          '</li>'
        ].join('');
      }

      function renderProductImage(product) {
        if (product.image === null) {
          return '';
        }

        return (
          '<img class="predictive-search-item__image lazyload" src="' +
          product.image.url +
          '" data-src="' +
          product.image.url +
          '" data-image alt="' +
          product.image.alt +
          '" />'
        );
      }

      function renderProductDetails(product) {
        return [
          '<dl class="predictive-search-item__details price' +
          (product.isOnSale ? ' price--on-sale' : '') +
          (!product.available ? ' price--sold-out' : '') +
          (!product.isPriceVaries && product.isCompareVaries
           ? ' price--compare-price-hidden'
           : '') +
          '">',
          '<div class="predictive-search-item__detail">',
          renderVendor(product),
          '</div>',
          '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
          renderProductPrice(product),
          '</div>',
          '</dl>'
        ].join('');
      }
      function renderProductPrice(product) {
        if (!theme.settings.predictiveSearchShowPrice) {
          return '';
        }

        var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

        var priceMarkup =
            '<div class="price__regular">' + renderPrice(product) + '</div>';

        var salePriceMarkup =
            '<div class="price__sale">' + renderSalePrice(product) + '</div>';

        return (
          accessibilityAnnounceComma +
          '<div class="price__pricing-group">' +
          (product.isOnSale ? salePriceMarkup : priceMarkup) +
          '</div>'
        );
      }

      function renderSalePrice(product) {
        return [
          '<dt>',
          '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
          '</dt>',
          '<dd>',
          '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
          (product.isPriceVaries
           ? theme.strings.fromLowestPrice.replace('[price]', product.price)
           : product.price) +
          '</span>',
          '</dd>',
          '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
        ].join('');
      }

      function renderCompareAtPrice(product) {
        return [
          '<dt>',
          '<span class="visually-hidden">' +
          theme.strings.regularPrice +
          '</span> ',
          '</dt>',
          '<dd>',
          '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
          product.compareAtPrice +
          '</span>',
          '</dd>'
        ].join('');
      }

      function renderPrice(product) {
        return [
          '<dt>',
          '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
          '</dt>',
          '<dd>',
          '<span class="predictive-search-item__price">' +
          (product.isPriceVaries
           ? theme.strings.fromLowestPrice.replace('[price]', product.price)
           : product.price) +
          '</span>',
          '</dd>'
        ].join('');
      }

      function renderVendor(product) {
        if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
          return '';
        }

        return [
          '<dt>',
          '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
          '</dt>',
          '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
        ].join('');
      }

      function normalizeProduct(product) {
        var productOrVariant =
            product.variants.length > 0 ? product.variants[0] : product;

        return {
          url: productOrVariant.url,
          image: getProductImage(product),
          title: product.title,
          vendor: product.vendor || '',
          price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
          compareAtPrice: theme.Currency.formatMoney(
            product.compare_at_price_min,
            theme.moneyFormat
          ),
          available: product.available,
          isOnSale: isOnSale(product),
          isPriceVaries: isPriceVaries(product),
          isCompareVaries: isCompareVaries(product)
        };
      }

      function getProductImage(product) {
        var image;
        var featuredImage;

        if (product.variants.length > 0 && product.variants[0].image !== null) {
          featuredImage = product.variants[0].featured_image;
        } else if (product.image) {
          featuredImage = product.featured_image;
        } else {
          image = null;
        }

        if (image !== null) {
          image = {
            url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
            alt: featuredImage.alt
          };
        }

        return image;
      }

      function isOnSale(product) {
        return (
          product.compare_at_price_min !== null &&
          parseInt(product.compare_at_price_min, 10) >
          parseInt(product.price_min, 10)
        );
      }

      function isPriceVaries(product) {
        return product.price_max !== product.price_min;
      }

      function isCompareVaries(product) {
        return product.compare_at_price_max !== product.compare_at_price_min;
      }

      // Returns the number of optional product details to be shown,
      // values of the detailsList need to be boolean.
      function getDetailsCount() {
        var detailsList = [
          theme.settings.predictiveSearchShowPrice,
          theme.settings.predictiveSearchShowVendor
        ];

        var detailsCount = detailsList.reduce(function(acc, detail) {
          return acc + (detail ? 1 : 0);
        }, 0);

        return detailsCount;
      }

      function getNumberOfResultsString(resultNumber, resultsCount) {
        return theme.strings.number_of_results
        .replace('[result_number]', resultNumber)
        .replace('[results_count]', resultsCount);
      }

      function _htmlEscape(input) {
        return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      }

      return function(data) {
        var products = data.products || [];
        var isLoading = data.isLoading;
        var searchQuery = data.searchQuery || '';

        if (isLoading && products.length === 0) {
          return loadingState();
        }

        return renderResults(products, isLoading, searchQuery);
      };
    })();

    window.theme = window.theme || {};

    (function() {
      // (a11y) This function will be used by the Predictive Search Component
      // to announce the number of search results
      function numberOfResultsTemplateFct(data) {
        if (data.products.length === 1) {
          return theme.strings.one_result_found;
        } else {
          return theme.strings.number_of_results_found.replace(
            '[results_count]',
            data.products.length
          );
        }
      }

      // (a11y) This function will be used by the Predictive Search Component
      // to announce that it's loading results
      function loadingResultsMessageTemplateFct() {
        return theme.strings.loading;
      }

      function isPredictiveSearchSupported() {
        var shopifyFeatures = JSON.parse(
          document.getElementById('shopify-features').textContent
        );

        return shopifyFeatures.predictiveSearch;
      }

      function isPredictiveSearchEnabled() {
        return window.theme.settings.predictiveSearchEnabled;
      }

      function canInitializePredictiveSearch() {
        return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
      }

      // listen for search submits and validate query
      function validateSearchHandler(searchEl, submitEl) {
        submitEl.addEventListener(
          'click',
          validateSearchInput.bind(this, searchEl)
        );
      }

      // if there is nothing in the search field, prevent submit
      function validateSearchInput(searchEl, evt) {
        var isInputValueEmpty = searchEl.value.trim().length === 0;
        if (!isInputValueEmpty) {
          return;
        }

        if (typeof evt !== 'undefined') {
          evt.preventDefault();
        }

        searchEl.focus();
      }

      window.theme.SearchPage = (function() {
        var selectors = {
          searchReset: '[data-search-page-predictive-search-clear]',
          searchInput: '[data-search-page-predictive-search-input]',
          searchSubmit: '[data-search-page-predictive-search-submit]',
          searchResults: '[data-predictive-search-mount="default"]'
        };

        var componentInstance;

        function init(config) {
          var searchInput = document.querySelector(selectors.searchInput);
          var searchSubmit = document.querySelector(selectors.searchSubmit);
          var searchUrl = searchInput.dataset.baseUrl;

          componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
            selectors: {
              input: selectors.searchInput,
              reset: selectors.searchReset,
              result: selectors.searchResults
            },
            searchUrl: searchUrl,
            resultTemplateFct: window.theme.SearchResultsTemplate,
            numberOfResultsTemplateFct: numberOfResultsTemplateFct,
            loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
            onOpen: function(nodes) {
              if (config.isTabletAndUp) {
                return;
              }

              var searchInputBoundingRect = searchInput.getBoundingClientRect();
              var bodyHeight = document.body.offsetHeight;
              var offset = 50;
              var resultsMaxHeight =
                  bodyHeight - searchInputBoundingRect.bottom - offset;

              nodes.result.style.maxHeight = resultsMaxHeight + 'px';
            },
            onBeforeDestroy: function(nodes) {
              // If the viewport width changes from mobile to tablet
              // reset the top position of the results
              nodes.result.style.maxHeight = '';
            }
          });

          validateSearchHandler(searchInput, searchSubmit);
        }

        function unload() {
          if (!componentInstance) {
            return;
          }
          componentInstance.destroy();
          componentInstance = null;
        }

        return {
          init: init,
          unload: unload
        };
      })();

      window.theme.SearchHeader = (function() {
        var selectors = {
          searchInput: '[data-predictive-search-drawer-input]',
          searchResults: '[data-predictive-search-mount="drawer"]',
          searchFormContainer: '[data-search-form-container]',
          searchSubmit: '[data-search-form-submit]'
        };

        var componentInstance;

        function init(config) {
          var searchInput = document.querySelector(selectors.searchInput);
          var searchSubmit = document.querySelector(selectors.searchSubmit);
          var searchUrl = searchInput.dataset.baseUrl;

          componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
            selectors: {
              input: selectors.searchInput,
              result: selectors.searchResults
            },
            searchUrl: searchUrl,
            resultTemplateFct: window.theme.SearchResultsTemplate,
            numberOfResultsTemplateFct: numberOfResultsTemplateFct,
            numberOfResults: config.numberOfResults,
            loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
            onInputBlur: function() {
              return false;
            },
            onOpen: function(nodes) {
              var searchInputBoundingRect = searchInput.getBoundingClientRect();

              // For tablet screens and up, stop the scroll area from extending past
              // the bottom of the screen because we're locking the body scroll
              var maxHeight =
                  window.innerHeight -
                  searchInputBoundingRect.bottom -
                  (config.isTabletAndUp ? 20 : 0);

              nodes.result.style.top = config.isTabletAndUp
              ? ''
              : searchInputBoundingRect.bottom + 'px';
              nodes.result.style.maxHeight = maxHeight + 'px';
            },
            onClose: function(nodes) {
              nodes.result.style.maxHeight = '';
            },
            onBeforeDestroy: function(nodes) {
              // If the viewport width changes from mobile to tablet
              // reset the top position of the results
              nodes.result.style.top = '';
            }
          });

          validateSearchHandler(searchInput, searchSubmit);
        }

        function unload() {
          if (!componentInstance) {
            return;
          }

          componentInstance.destroy();
          componentInstance = null;
        }

        function clearAndClose() {
          if (!componentInstance) {
            return;
          }

          componentInstance.clearAndClose();
        }

        return {
          init: init,
          unload: unload,
          clearAndClose: clearAndClose
        };
      })();

      window.theme.Search = (function() {
        var classes = {
          searchTemplate: 'template-search'
        };
        var selectors = {
          siteHeader: '.site-header'
        };
        var mediaQueryList = {
          mobile: window.matchMedia('(max-width: 749px)'),
          tabletAndUp: window.matchMedia('(min-width: 750px)')
        };

        function init() {
          if (!document.querySelector(selectors.siteHeader)) {
            return;
          }

          if (!canInitializePredictiveSearch()) {
            return;
          }

          Object.keys(mediaQueryList).forEach(function(device) {
            mediaQueryList[device].addListener(initSearchAccordingToViewport);
          });

          initSearchAccordingToViewport();
        }

        function initSearchAccordingToViewport() {
          theme.SearchDrawer.close();
          theme.SearchHeader.unload();
          theme.SearchPage.unload();

          if (mediaQueryList.mobile.matches) {
            theme.SearchHeader.init({
              numberOfResults: 4,
              isTabletAndUp: false
            });

            if (isSearchPage()) {
              theme.SearchPage.init({ isTabletAndUp: false });
            }
          } else {
            // Tablet and up
            theme.SearchHeader.init({
              numberOfResults: 4,
              isTabletAndUp: true
            });

            if (isSearchPage()) {
              theme.SearchPage.init({ isTabletAndUp: true });
            }
          }
        }

        function isSearchPage() {
          return document.body.classList.contains(classes.searchTemplate);
        }

        function unload() {
          theme.SearchHeader.unload();
          theme.SearchPage.unload();
        }

        return {
          init: init,
          unload: unload
        };
      })();
    })();

    window.theme = window.theme || {};

    theme.SearchDrawer = (function() {
      var selectors = {
        headerSection: '[data-header-section]',
        drawer: '[data-predictive-search-drawer]',
        drawerOpenButton: '[data-predictive-search-open-drawer]',
        headerSearchInput: '[data-predictive-search-drawer-input]',
        predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
      };

      var drawerInstance;

      function init() {
        setAccessibilityProps();

        drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
          onDrawerOpen: function() {
            setHeight();
            theme.MobileNav.closeMobileNav();
            lockBodyScroll();
          },
          onDrawerClose: function() {
            theme.SearchHeader.clearAndClose();
            var drawerOpenButton = document.querySelector(
              selectors.drawerOpenButton
            );

            if (drawerOpenButton) drawerOpenButton.focus();

            unlockBodyScroll();
          },
          withPredictiveSearch: true,
          elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
        });
      }

      function setAccessibilityProps() {
        var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

        if (drawerOpenButton) {
          drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
          drawerOpenButton.setAttribute('aria-expanded', 'false');
          drawerOpenButton.setAttribute('aria-controls', 'dialog');
        }
      }

      function setHeight() {
        var searchDrawer = document.querySelector(selectors.drawer);
        var headerHeight = document.querySelector(selectors.headerSection)
        .offsetHeight;

        searchDrawer.style.height = headerHeight + 'px';
      }

      function close() {
        drawerInstance.close();
      }

      function lockBodyScroll() {
        theme.Helpers.enableScrollLock();
      }

      function unlockBodyScroll() {
        theme.Helpers.disableScrollLock();
      }

      return {
        init: init,
        close: close
      };
    })();

    theme.Disclosure = (function() {
      var selectors = {
        disclosureForm: '[data-disclosure-form]',
        disclosureList: '[data-disclosure-list]',
        disclosureToggle: '[data-disclosure-toggle]',
        disclosureInput: '[data-disclosure-input]',
        disclosureOptions: '[data-disclosure-option]'
      };

      var classes = {
        listVisible: 'disclosure-list--visible'
      };

      function Disclosure(disclosure) {
        this.container = disclosure;
        this._cacheSelectors();
        this._setupListeners();
      }

      Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
        _cacheSelectors: function() {
          this.cache = {
            disclosureForm: this.container.closest(selectors.disclosureForm),
            disclosureList: this.container.querySelector(selectors.disclosureList),
            disclosureToggle: this.container.querySelector(
              selectors.disclosureToggle
            ),
            disclosureInput: this.container.querySelector(
              selectors.disclosureInput
            ),
            disclosureOptions: this.container.querySelectorAll(
              selectors.disclosureOptions
            )
          };
        },

        _setupListeners: function() {
          this.eventHandlers = this._setupEventHandlers();

          this.cache.disclosureToggle.addEventListener(
            'click',
            this.eventHandlers.toggleList
          );

          this.cache.disclosureOptions.forEach(function(disclosureOption) {
            disclosureOption.addEventListener(
              'click',
              this.eventHandlers.connectOptions
            );
          }, this);

          this.container.addEventListener(
            'keyup',
            this.eventHandlers.onDisclosureKeyUp
          );

          this.cache.disclosureList.addEventListener(
            'focusout',
            this.eventHandlers.onDisclosureListFocusOut
          );

          this.cache.disclosureToggle.addEventListener(
            'focusout',
            this.eventHandlers.onDisclosureToggleFocusOut
          );

          document.body.addEventListener('click', this.eventHandlers.onBodyClick);
        },

        _setupEventHandlers: function() {
          return {
            connectOptions: this._connectOptions.bind(this),
            toggleList: this._toggleList.bind(this),
            onBodyClick: this._onBodyClick.bind(this),
            onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
            onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
            onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
          };
        },

        _connectOptions: function(event) {
          event.preventDefault();

          this._submitForm(event.currentTarget.dataset.value);
        },

        _onDisclosureToggleFocusOut: function(event) {
          var disclosureLostFocus =
              this.container.contains(event.relatedTarget) === false;

          if (disclosureLostFocus) {
            this._hideList();
          }
        },

        _onDisclosureListFocusOut: function(event) {
          var childInFocus = event.currentTarget.contains(event.relatedTarget);

          var isVisible = this.cache.disclosureList.classList.contains(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        },

        _onDisclosureKeyUp: function(event) {
          if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.disclosureToggle.focus();
        },

        _onBodyClick: function(event) {
          var isOption = this.container.contains(event.target);
          var isVisible = this.cache.disclosureList.classList.contains(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        },

        _submitForm: function(value) {
          this.cache.disclosureInput.value = value;
          this.cache.disclosureForm.submit();
        },

        _hideList: function() {
          this.cache.disclosureList.classList.remove(classes.listVisible);
          this.cache.disclosureToggle.setAttribute('aria-expanded', false);
        },

        _toggleList: function() {
          var ariaExpanded =
              this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
          this.cache.disclosureList.classList.toggle(classes.listVisible);
          this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
        },

        destroy: function() {
          this.cache.disclosureToggle.removeEventListener(
            'click',
            this.eventHandlers.toggleList
          );

          this.cache.disclosureOptions.forEach(function(disclosureOption) {
            disclosureOption.removeEventListener(
              'click',
              this.eventHandlers.connectOptions
            );
          }, this);

          this.container.removeEventListener(
            'keyup',
            this.eventHandlers.onDisclosureKeyUp
          );

          this.cache.disclosureList.removeEventListener(
            'focusout',
            this.eventHandlers.onDisclosureListFocusOut
          );

          this.cache.disclosureToggle.removeEventListener(
            'focusout',
            this.eventHandlers.onDisclosureToggleFocusOut
          );

          document.body.removeEventListener(
            'click',
            this.eventHandlers.onBodyClick
          );
        }
      });

      return Disclosure;
    })();

    theme.Zoom = (function() {
      var selectors = {
        imageZoom: '[data-image-zoom]'
      };

      var classes = {
        zoomImg: 'zoomImg'
      };

      var attributes = {
        imageZoomTarget: 'data-image-zoom-target'
      };

      function Zoom(container) {
        this.container = container;
        this.cache = {};
        this.url = container.dataset.zoom;

        this._cacheSelectors();

        if (!this.cache.sourceImage) return;

        this._duplicateImage();
      }

      Zoom.prototype = Object.assign({}, Zoom.prototype, {
        _cacheSelectors: function() {
          this.cache = {
            sourceImage: this.container.querySelector(selectors.imageZoom)
          };
        },

        _init: function() {
          var targetWidth = this.cache.targetImage.width;
          var targetHeight = this.cache.targetImage.height;

          if (this.cache.sourceImage === this.cache.targetImage) {
            this.sourceWidth = targetWidth;
            this.sourceHeight = targetHeight;
          } else {
            this.sourceWidth = this.cache.sourceImage.width;
            this.sourceHeight = this.cache.sourceImage.height;
          }

          this.xRatio =
            (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
          this.yRatio =
            (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
        },

        _start: function(e) {
          this._init();
          this._move(e);
        },

        _stop: function() {
          this.cache.targetImage.style.opacity = 0;
        },

        /**
     * Sets the correct coordinates top and left position in px
     * It sets a limit within between 0 and the max height of the image
     * So when the mouse leaves the target image, it could
     * never go above or beyond the target image zone
     */
        _setTopLeftMaxValues: function(top, left) {
          return {
            left: Math.max(Math.min(left, this.sourceWidth), 0),
            top: Math.max(Math.min(top, this.sourceHeight), 0)
          };
        },

        _move: function(e) {
          // get left and top position within the "source image" zone
          var left =
              e.pageX -
              (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
          var top =
              e.pageY -
              (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);
          // make sure the left and top position don't go
          // above or beyond the target image zone
          var position = this._setTopLeftMaxValues(top, left);

          top = position.top;
          left = position.left;

          this.cache.targetImage.style.left = -(left * -this.xRatio) + 'px';
          this.cache.targetImage.style.top = -(top * -this.yRatio) + 'px';
          this.cache.targetImage.style.opacity = 1;
        },

        /**
     * This loads a high resolution image
     * via the data attributes url
     * It adds all necessary CSS styles and adds to the container
     */
        _duplicateImage: function() {
          this._loadImage()
          .then(
            function(image) {
              this.cache.targetImage = image;
              image.style.width = image.width + 'px';
              image.style.height = image.height + 'px';
              image.style.position = 'absolute';
              image.style.maxWidth = 'none';
              image.style.maxHeight = 'none';
              image.style.opacity = 0;
              image.style.border = 'none';
              image.style.left = 0;
              image.style.top = 0;

              this.container.appendChild(image);

              this._init();

              this._start = this._start.bind(this);
              this._stop = this._stop.bind(this);
              this._move = this._move.bind(this);

              this.container.addEventListener('mouseenter', this._start);
              this.container.addEventListener('mouseleave', this._stop);
              this.container.addEventListener('mousemove', this._move);

              this.container.style.position = 'relative';
              this.container.style.overflow = 'hidden';
            }.bind(this)
          )
          .catch(function(error) {
            // eslint-disable-next-line no-console
            console.warn('Error fetching image', error);
          });
        },

        _loadImage: function() {
          // eslint-disable-next-line
          return new Promise(function(resolve, reject) {
            var image = new Image();
            image.setAttribute('role', 'presentation');
            image.setAttribute(attributes.imageZoomTarget, true);
            image.classList.add(classes.zoomImg);
            image.src = this.url;

            image.addEventListener('load', function() {
              resolve(image);
            });

            image.addEventListener('error', function(error) {
              reject(error);
            });
          }.bind(this)
                            );
        },

        unload: function() {
          var targetImage = this.container.querySelector(
            '[' + attributes.imageZoomTarget + ']'
          );
          if (targetImage) {
            targetImage.remove();
          }

          this.container.removeEventListener('mouseenter', this._start);
          this.container.removeEventListener('mouseleave', this._stop);
          this.container.removeEventListener('mousemove', this._move);
        }
      });

      return Zoom;
    })();


    /* ================ TEMPLATES ================ */
    (function() {
      var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

      if (!filterBys.length) return;

      slate.utils.resizeSelects(filterBys);

      filterBys.forEach(function(filterBy) {
        filterBy.addEventListener('change', function(evt) {
          location.href = evt.target.value;
        });
      });
    })();

    window.theme = theme || {};

    theme.customerTemplates = (function() {
      var selectors = {
        RecoverHeading: '#RecoverHeading',
        RecoverEmail: '#RecoverEmail',
        LoginHeading: '#LoginHeading'
      };

      function initEventListeners() {
        this.recoverHeading = document.querySelector(selectors.RecoverHeading);
        this.recoverEmail = document.querySelector(selectors.RecoverEmail);
        this.loginHeading = document.querySelector(selectors.LoginHeading);
        var recoverPassword = document.getElementById('RecoverPassword');
        var hideRecoverPasswordLink = document.getElementById(
          'HideRecoverPasswordLink'
        );

        // Show reset password form
        if (recoverPassword) {
          recoverPassword.addEventListener(
            'click',
            function(evt) {
              evt.preventDefault();
              showRecoverPasswordForm();
              this.recoverHeading.setAttribute('tabindex', '-1');
              this.recoverHeading.focus();
            }.bind(this)
          );
        }

        // Hide reset password form
        if (hideRecoverPasswordLink) {
          hideRecoverPasswordLink.addEventListener(
            'click',
            function(evt) {
              evt.preventDefault();
              hideRecoverPasswordForm();
              this.loginHeading.setAttribute('tabindex', '-1');
              this.loginHeading.focus();
            }.bind(this)
          );
        }

        if (this.recoverHeading) {
          this.recoverHeading.addEventListener('blur', function(evt) {
            evt.target.removeAttribute('tabindex');
          });
        }

        if (this.loginHeading) {
          this.loginHeading.addEventListener('blur', function(evt) {
            evt.target.removeAttribute('tabindex');
          });
        }
      }

      /**
   *
   *  Show/Hide recover password form
   *
   */

      function showRecoverPasswordForm() {
        document.getElementById('RecoverPasswordForm').classList.remove('hide');
        document.getElementById('CustomerLoginForm').classList.add('hide');

        if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
          this.recoverEmail.focus();
        }
      }

      function hideRecoverPasswordForm() {
        document.getElementById('RecoverPasswordForm').classList.add('hide');
        document.getElementById('CustomerLoginForm').classList.remove('hide');
      }

      /**
   *
   *  Show reset password success message
   *
   */
      function resetPasswordSuccess() {
        var formState = document.querySelector('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!formState) {
          return;
        }

        // show success message
        var resetSuccess = document.getElementById('ResetSuccess');
        resetSuccess.classList.remove('hide');
        resetSuccess.focus();
      }

      /**
   *
   *  Show/hide customer address forms
   *
   */
      function customerAddressForm() {
        var newAddressForm = document.getElementById('AddressNewForm');
        var newAddressFormButton = document.getElementById('AddressNewButton');

        if (!newAddressForm) {
          return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(
            'AddressCountryNew',
            'AddressProvinceNew',
            {
              hideElement: 'AddressProvinceContainerNew'
            }
          );
        }

        // Initialize each edit form's country/province selector
        document
        .querySelectorAll('.address-country-option')
        .forEach(function(option) {
          var formId = option.dataset.formId;
          var countrySelector = 'AddressCountry_' + formId;
          var provinceSelector = 'AddressProvince_' + formId;
          var containerSelector = 'AddressProvinceContainer_' + formId;

          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
          });
        });

        // Toggle new/edit address forms
        document.querySelectorAll('.address-new-toggle').forEach(function(button) {
          button.addEventListener('click', function() {
            var isExpanded =
                newAddressFormButton.getAttribute('aria-expanded') === 'true';

            newAddressForm.classList.toggle('hide');
            newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
            newAddressFormButton.focus();
          });
        });

        document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
          button.addEventListener('click', function(evt) {
            var formId = evt.target.dataset.formId;
            var editButton = document.getElementById('EditFormButton_' + formId);
            var editAddress = document.getElementById('EditAddress_' + formId);
            var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

            editAddress.classList.toggle('hide');
            editButton.setAttribute('aria-expanded', !isExpanded);
            editButton.focus();
          });
        });

        document.querySelectorAll('.address-delete').forEach(function(button) {
          button.addEventListener('click', function(evt) {
            var target = evt.target.dataset.target;
            var confirmMessage = evt.target.dataset.confirmMessage;

            // eslint-disable-next-line no-alert
            if (
              confirm(
                confirmMessage || 'Are you sure you wish to delete this address?'
              )
            ) {
              Shopify.postLink(target, {
                parameters: { _method: 'delete' }
              });
            }
          });
        });
      }

      /**
   *
   *  Check URL for reset password hash
   *
   */
      function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          showRecoverPasswordForm.bind(this)();
        }
      }

      return {
        init: function() {
          initEventListeners();
          checkUrlHash();
          resetPasswordSuccess();
          customerAddressForm();
        }
      };
    })();


    /*================ SECTIONS ================*/
    window.theme = window.theme || {};

    theme.Cart = (function() {
      var selectors = {
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartDiscount: '[data-cart-discount]',
        cartDiscountTitle: '[data-cart-discount-title]',
        cartDiscountAmount: '[data-cart-discount-amount]',
        cartDiscountWrapper: '[data-cart-discount-wrapper]',
        cartErrorMessage: '[data-cart-error-message]',
        cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
        cartItem: '[data-cart-item]',
        cartItemDetails: '[data-cart-item-details]',
        cartItemDiscount: '[data-cart-item-discount]',
        cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
        cartItemDiscountTitle: '[data-cart-item-discount-title]',
        cartItemDiscountAmount: '[data-cart-item-discount-amount]',
        cartItemDiscountList: '[data-cart-item-discount-list]',
        cartItemFinalPrice: '[data-cart-item-final-price]',
        cartItemImage: '[data-cart-item-image]',
        cartItemLinePrice: '[data-cart-item-line-price]',
        cartItemOriginalPrice: '[data-cart-item-original-price]',
        cartItemPrice: '[data-cart-item-price]',
        cartItemPriceList: '[data-cart-item-price-list]',
        cartItemProperty: '[data-cart-item-property]',
        cartItemPropertyName: '[data-cart-item-property-name]',
        cartItemPropertyValue: '[data-cart-item-property-value]',
        cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
        cartItemRegularPrice: '[data-cart-item-regular-price]',
        cartItemTitle: '[data-cart-item-title]',
        cartItemOption: '[data-cart-item-option]',
        cartItemSellingPlanName: '[data-cart-item-selling-plan-name]',
        cartLineItems: '[data-cart-line-items]',
        cartNote: '[data-cart-notes]',
        cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
        cartQuantityErrorMessageWrapper:
        '[data-cart-quantity-error-message-wrapper]',
        cartRemove: '[data-cart-remove]',
        cartStatus: '[data-cart-status]',
        cartSubtotal: '[data-cart-subtotal]',
        cartTableCell: '[data-cart-table-cell]',
        cartWrapper: '[data-cart-wrapper]',
        emptyPageContent: '[data-empty-page-content]',
        quantityInput: '[data-quantity-input]',
        quantityInputMobile: '[data-quantity-input-mobile]',
        quantityInputDesktop: '[data-quantity-input-desktop]',
        quantityLabelMobile: '[data-quantity-label-mobile]',
        quantityLabelDesktop: '[data-quantity-label-desktop]',
        inputQty: '[data-quantity-input]',
        thumbnails: '.cart__image',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        unitPriceGroup: '[data-unit-price-group]'
      };

      var classes = {
        cartNoCookies: 'cart--no-cookies',
        cartRemovedProduct: 'cart__removed-product',
        thumbnails: 'cart__image',
        hide: 'hide',
        inputError: 'input--error'
      };

      var attributes = {
        cartItemIndex: 'data-cart-item-index',
        cartItemKey: 'data-cart-item-key',
        cartItemQuantity: 'data-cart-item-quantity',
        cartItemTitle: 'data-cart-item-title',
        cartItemUrl: 'data-cart-item-url',
        quantityItem: 'data-quantity-item'
      };

      var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

      function Cart(container) {
        this.container = container;
        this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
        this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);
        this.ajaxEnabled =
          this.container.getAttribute('data-ajax-enabled') === 'true';

        this.cartRoutes = JSON.parse(
          document.querySelector('[data-cart-routes]').innerHTML
        );

        this._handleInputQty = theme.Helpers.debounce(
          this._handleInputQty.bind(this),
          500
        );
        this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
          this
        );
        this._onNoteChange = this._onNoteChange.bind(this);
        this._onRemoveItem = this._onRemoveItem.bind(this);

        if (!theme.Helpers.cookiesEnabled()) {
          this.container.classList.add(classes.cartNoCookies);
        }

        this.thumbnails.forEach(function(element) {
          element.style.cursor = 'pointer';
        });

        this.container.addEventListener('click', this._handleThumbnailClick);
        this.container.addEventListener('change', this._handleInputQty);

        this.mql = window.matchMedia(mediumUpQuery);
        this.mql.addListener(this.setQuantityFormControllers);

        this.setQuantityFormControllers();

        if (this.ajaxEnabled) {
          /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */
          this.container.addEventListener('click', this._onRemoveItem);
          this.container.addEventListener('change', this._onNoteChange);

          this._setupCartTemplates();
        }
      }

      Cart.prototype = Object.assign({}, Cart.prototype, {
        _setupCartTemplates: function() {
          var cartItem = this.container.querySelector(selectors.cartItem);
          if (!cartItem) return;

          this.itemTemplate = this.container
          .querySelector(selectors.cartItem)
          .cloneNode(true);

          this.itemDiscountTemplate = this.itemTemplate
          .querySelector(selectors.cartItemDiscount)
          .cloneNode(true);

          this.cartDiscountTemplate = this.container
          .querySelector(selectors.cartDiscount)
          .cloneNode(true);

          this.itemPriceListTemplate = this.itemTemplate
          .querySelector(selectors.cartItemPriceList)
          .cloneNode(true);

          this.itemOptionTemplate = this.itemTemplate
          .querySelector(selectors.cartItemOption)
          .cloneNode(true);

          this.itemPropertyTemplate = this.itemTemplate
          .querySelector(selectors.cartItemProperty)
          .cloneNode(true);

          this.itemSellingPlanNameTemplate = this.itemTemplate
          .querySelector(selectors.cartItemSellingPlanName)
          .cloneNode(true);
        },

        _handleInputQty: function(evt) {
          if (!evt.target.hasAttribute('data-quantity-input')) return;

          var input = evt.target;
          var itemElement = input.closest(selectors.cartItem);

          var itemIndex = Number(input.getAttribute('data-quantity-item'));

          var itemQtyInputs = this.container.querySelectorAll(
            "[data-quantity-item='" + itemIndex + "']"
          );

          var value = parseInt(input.value);

          var isValidValue = !(value < 0 || isNaN(value));

          itemQtyInputs.forEach(function(element) {
            element.value = value;
          });

          this._hideCartError();
          this._hideQuantityErrorMessage();

          if (!isValidValue) {
            this._showQuantityErrorMessages(itemElement);
            return;
          }

          if (isValidValue && this.ajaxEnabled) {
            this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);
          }
        },

        _updateItemQuantity: function(
        itemIndex,
         itemElement,
         itemQtyInputs,
         value
        ) {
          var key = itemElement.getAttribute(attributes.cartItemKey);
          var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

          var request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;'
            },
            body: JSON.stringify({
              line: index,
              quantity: value
            })
          };

          fetch(this.cartRoutes.cartChangeUrl + '.js', request)
          .then(function(response) {
            return response.json();
          })
          .then(
            function(state) {
              this._setCartCountBubble(state.item_count);

              if (!state.item_count) {
                this._emptyCart();
                return;
              }

              // Cache current in-focus element, used later to restore focus
              var inFocus = document.activeElement;

              this._createCart(state);

              if (!value) {
                this._showRemoveMessage(itemElement.cloneNode(true));
                return;
              }

              var item = this.getItem(key, state);

              this._updateLiveRegion(item);

              // Restore focus to the "equivalent" element after the DOM has been updated
              if (!inFocus) return;
              var row = inFocus.closest('[' + attributes.cartItemIndex + ']');
              if (!row) return;
              var target = this.container.querySelector(
                '[' +
                attributes.cartItemIndex +
                '="' +
                row.getAttribute(attributes.cartItemIndex) +
                '"] [data-role="' +
                inFocus.getAttribute('data-role') +
                '"]'
              );
              if (!target) return;
              target.focus();
            }.bind(this)
          )
          .catch(
            function() {
              this._showCartError(null);
            }.bind(this)
          );
        },

        getItem: function(key, state) {
          return state.items.find(function(item) {
            return item.key === key;
          });
        },

        _liveRegionText: function(item) {
          // Dummy content for live region
          var liveRegionText =
              theme.strings.update +
              ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

          // Update Quantity
          liveRegionText = liveRegionText
          .replace('[QuantityLabel]', theme.strings.quantity)
          .replace('[Quantity]', item.quantity);

          // Update pricing information
          var regularLabel = '';
          var regularPrice = theme.Currency.formatMoney(
            item.original_line_price,
            theme.moneyFormat
          );
          var discountLabel = '';
          var discountPrice = '';
          var discountInformation = '';

          if (item.original_line_price > item.final_line_price) {
            regularLabel = theme.strings.regularTotal;

            discountLabel = theme.strings.discountedTotal;
            discountPrice = theme.Currency.formatMoney(
              item.final_line_price,
              theme.moneyFormat
            );

            discountInformation = theme.strings.priceColumn;
          }

          liveRegionText = liveRegionText
          .replace('[Regular]', regularLabel)
          .replace('[$$]', regularPrice)
          .replace('[DiscountedPrice]', discountLabel)
          .replace('[$]', discountPrice)
          .replace('[PriceInformation]', discountInformation)
          .trim();

          return liveRegionText;
        },

        _updateLiveRegion: function(item) {
          if (!item) return;

          var liveRegion = this.container.querySelector(selectors.cartStatus);

          liveRegion.textContent = this._liveRegionText(item);
          liveRegion.setAttribute('aria-hidden', false);

          setTimeout(function() {
            liveRegion.setAttribute('aria-hidden', true);
          }, 1000);
        },

        _createCart: function(state) {
          var cartDiscountList = this._createCartDiscountList(state);

          var cartTable = this.container.querySelector(selectors.cartLineItems);
          cartTable.innerHTML = '';

          this._createLineItemList(state).forEach(function(lineItem) {
            cartTable.appendChild(lineItem);
          });

          this.setQuantityFormControllers();

          this.cartNotes =
            this.cartNotes || this.container.querySelector(selectors.cartNote);

          if (this.cartNotes) {
            this.cartNotes.value = state.note;
          }

          var discountWrapper = this.container.querySelector(
            selectors.cartDiscountWrapper
          );

          if (cartDiscountList.length === 0) {
            discountWrapper.innerHTML = '';
            discountWrapper.classList.add(classes.hide);
          } else {
            discountWrapper.innerHTML = '';

            cartDiscountList.forEach(function(discountItem) {
              discountWrapper.appendChild(discountItem);
            });

            discountWrapper.classList.remove(classes.hide);
          }

          this.container.querySelector(
            selectors.cartSubtotal
          ).innerHTML = theme.Currency.formatMoney(
            state.total_price,
            theme.moneyFormatWithCurrency
          );
        },

        _createCartDiscountList: function(cart) {
          return cart.cart_level_discount_applications.map(
            function(discount) {
              var discountNode = this.cartDiscountTemplate.cloneNode(true);

              discountNode.querySelector(selectors.cartDiscountTitle).textContent =
                discount.title;

              discountNode.querySelector(
                selectors.cartDiscountAmount
              ).innerHTML = theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat
              );

              return discountNode;
            }.bind(this)
          );
        },

        _createLineItemList: function(state) {
          return state.items.map(
            function(item, index) {
              var itemNode = this.itemTemplate.cloneNode(true);

              var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

              this._setLineItemAttributes(itemNode, item, index);
              this._setLineItemImage(itemNode, item.featured_image);

              var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
              cartItemTitle.textContent = item.product_title;
              cartItemTitle.setAttribute('href', item.url);

              var selling_plan_name = item.selling_plan_allocation
              ? item.selling_plan_allocation.selling_plan.name
              : null;

              var productDetailsList = this._createProductDetailsList(
                item.product_has_only_default_variant,
                item.options_with_values,
                item.properties,
                selling_plan_name
              );

              this._setProductDetailsList(itemNode, productDetailsList);

              this._setItemRemove(itemNode, item.title);

              itemPriceList.innerHTML = this._createItemPrice(
                item.original_price,
                item.final_price
              ).outerHTML;

              if (item.unit_price_measurement) {
                itemPriceList.appendChild(
                  this._createUnitPrice(
                    item.unit_price,
                    item.unit_price_measurement
                  )
                );
              }

              this._setItemPrice(itemNode, itemPriceList);

              var itemDiscountList = this._createItemDiscountList(item);
              this._setItemDiscountList(itemNode, itemDiscountList);
              this._setQuantityInputs(itemNode, item, index);

              var itemLinePrice = this._createItemPrice(
                item.original_line_price,
                item.final_line_price
              );

              this._setItemLinePrice(itemNode, itemLinePrice);

              return itemNode;
            }.bind(this)
          );
        },

        _setLineItemAttributes: function(itemNode, item, index) {
          itemNode.setAttribute(attributes.cartItemKey, item.key);
          itemNode.setAttribute(attributes.cartItemUrl, item.url);
          itemNode.setAttribute(attributes.cartItemTitle, item.title);
          itemNode.setAttribute(attributes.cartItemIndex, index + 1);
          itemNode.setAttribute(attributes.cartItemQuantity, item.quantity);
        },

        _setLineItemImage: function(itemNode, featuredImage) {
          var image = itemNode.querySelector(selectors.cartItemImage);

          var sizedImageUrl =
              featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

          if (sizedImageUrl) {
            image.setAttribute('alt', featuredImage.alt);
            image.setAttribute('src', sizedImageUrl);
            image.classList.remove(classes.hide);
          } else {
            image.parentNode.removeChild(image);
          }
        },

        _setProductDetailsList: function(item, productDetailsList) {
          var itemDetails = item.querySelector(selectors.cartItemDetails);

          if (productDetailsList.length) {
            itemDetails.classList.remove(classes.hide);
            itemDetails.innerHTML = productDetailsList.reduce(function(
                                                              result,
                                                               element
                                                              ) {
              return result + element.outerHTML;
            },
                                                              '');

            return;
          }

          itemDetails.classList.add(classes.hide);
          itemDetails.textContent = '';
        },

        _setItemPrice: function(item, price) {
          item.querySelector(selectors.cartItemPrice).innerHTML = price.outerHTML;
        },

        _setItemDiscountList: function(item, discountList) {
          var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

          if (discountList.length === 0) {
            itemDiscountList.innerHTML = '';
            itemDiscountList.classList.add(classes.hide);
          } else {
            itemDiscountList.innerHTML = discountList.reduce(function(
                                                             result,
                                                              element
                                                             ) {
              return result + element.outerHTML;
            },
                                                             '');

            itemDiscountList.classList.remove(classes.hide);
          }
        },

        _setItemRemove: function(item, title) {
          item
          .querySelector(selectors.cartRemove)
          .setAttribute(
            'aria-label',
            theme.strings.removeLabel.replace('[product]', title)
          );
        },

        _setQuantityInputs: function(itemNode, item, index) {
          var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
          var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

          mobileInput.setAttribute('id', 'updates_' + item.key);
          desktopInput.setAttribute('id', 'updates_large_' + item.key);

          [mobileInput, desktopInput].forEach(function(element) {
            element.setAttribute(attributes.quantityItem, index + 1);
            element.value = item.quantity;
          });

          itemNode
          .querySelector(selectors.quantityLabelMobile)
          .setAttribute('for', 'updates_' + item.key);

          itemNode
          .querySelector(selectors.quantityLabelDesktop)
          .setAttribute('for', 'updates_large_' + item.key);
        },

        setQuantityFormControllers: function() {
          var desktopQuantityInputs = document.querySelectorAll(
            selectors.quantityInputDesktop
          );

          var mobileQuantityInputs = document.querySelectorAll(
            selectors.quantityInputMobile
          );

          if (this.mql.matches) {
            addNameAttribute(desktopQuantityInputs);
            removeNameAttribute(mobileQuantityInputs);
          } else {
            addNameAttribute(mobileQuantityInputs);
            removeNameAttribute(desktopQuantityInputs);
          }

          function addNameAttribute(inputs) {
            inputs.forEach(function(element) {
              element.setAttribute('name', 'updates[]');
            });
          }

          function removeNameAttribute(inputs) {
            inputs.forEach(function(element) {
              element.removeAttribute('name');
            });
          }
        },

        _setItemLinePrice: function(item, price) {
          item.querySelector(selectors.cartItemLinePrice).innerHTML =
            price.outerHTML;
        },

        _createProductDetailsList: function(
        product_has_only_default_variant,
         options,
         properties,
         selling_plan_name
        ) {
          var optionsPropertiesHTML = [];

          if (!product_has_only_default_variant) {
            optionsPropertiesHTML = optionsPropertiesHTML.concat(
              this._getOptionList(options)
            );
          }

          if (selling_plan_name) {
            optionsPropertiesHTML = optionsPropertiesHTML.concat(
              this._getSellingPlanName(selling_plan_name)
            );
          }

          if (properties !== null && Object.keys(properties).length !== 0) {
            optionsPropertiesHTML = optionsPropertiesHTML.concat(
              this._getPropertyList(properties)
            );
          }

          return optionsPropertiesHTML;
        },

        _getOptionList: function(options) {
          return options.map(
            function(option) {
              var optionElement = this.itemOptionTemplate.cloneNode(true);

              optionElement.textContent = option.name + ': ' + option.value;
              optionElement.classList.remove(classes.hide);

              return optionElement;
            }.bind(this)
          );
        },

        _getPropertyList: function(properties) {
          var propertiesArray =
              properties !== null ? Object.entries(properties) : [];

          var filteredPropertiesArray = propertiesArray.filter(function(property) {
            // Line item properties prefixed with an underscore are not to be displayed
            // if the property value has a length of 0 (empty), don't display it
            if (property[0].charAt(0) === '_' || property[1].length === 0) {
              return false;
            } else {
              return true;
            }
          });

          return filteredPropertiesArray.map(
            function(property) {
              var propertyElement = this.itemPropertyTemplate.cloneNode(true);

              propertyElement.querySelector(
                selectors.cartItemPropertyName
              ).textContent = property[0] + ': ';

              if (property[0].indexOf('/uploads/') === -1) {
                propertyElement.querySelector(
                  selectors.cartItemPropertyValue
                ).textContent = property[1];
              } else {
                propertyElement.querySelector(
                  selectors.cartItemPropertyValue
                ).innerHTML =
                  '<a href="' +
                  property[1] +
                  '"> ' +
                  property[1].split('/').pop() +
                  '</a>';
              }

              propertyElement.classList.remove(classes.hide);

              return propertyElement;
            }.bind(this)
          );
        },

        _getSellingPlanName: function(selling_plan_name) {
          var sellingPlanNameElement = this.itemSellingPlanNameTemplate.cloneNode(
            true
          );

          sellingPlanNameElement.textContent = selling_plan_name;
          sellingPlanNameElement.classList.remove(classes.hide);

          return sellingPlanNameElement;
        },

        _createItemPrice: function(original_price, final_price) {
          var originalPriceHTML = theme.Currency.formatMoney(
            original_price,
            theme.moneyFormat
          );

          var resultHTML;

          if (original_price !== final_price) {
            resultHTML = this.itemPriceListTemplate
            .querySelector(selectors.cartItemDiscountedPriceGroup)
            .cloneNode(true);

            resultHTML.querySelector(
              selectors.cartItemOriginalPrice
            ).innerHTML = originalPriceHTML;

            resultHTML.querySelector(
              selectors.cartItemFinalPrice
            ).innerHTML = theme.Currency.formatMoney(
              final_price,
              theme.moneyFormat
            );
          } else {
            resultHTML = this.itemPriceListTemplate
            .querySelector(selectors.cartItemRegularPriceGroup)
            .cloneNode(true);

            resultHTML.querySelector(
              selectors.cartItemRegularPrice
            ).innerHTML = originalPriceHTML;
          }

          resultHTML.classList.remove(classes.hide);
          return resultHTML;
        },

        _createUnitPrice: function(unitPrice, unitPriceMeasurement) {
          var unitPriceGroup = this.itemPriceListTemplate
          .querySelector(selectors.unitPriceGroup)
          .cloneNode(true);

          var unitPriceBaseUnit =
              (unitPriceMeasurement.reference_value !== 1
               ? unitPriceMeasurement.reference_value
               : '') + unitPriceMeasurement.reference_unit;

          unitPriceGroup.querySelector(
            selectors.unitPriceBaseUnit
          ).textContent = unitPriceBaseUnit;

          unitPriceGroup.querySelector(
            selectors.unitPrice
          ).innerHTML = theme.Currency.formatMoney(unitPrice, theme.moneyFormat);

          unitPriceGroup.classList.remove(classes.hide);

          return unitPriceGroup;
        },

        _createItemDiscountList: function(item) {
          return item.line_level_discount_allocations.map(
            function(discount) {
              var discountNode = this.itemDiscountTemplate.cloneNode(true);

              discountNode.querySelector(
                selectors.cartItemDiscountTitle
              ).textContent = discount.discount_application.title;

              discountNode.querySelector(
                selectors.cartItemDiscountAmount
              ).innerHTML = theme.Currency.formatMoney(
                discount.amount,
                theme.moneyFormat
              );

              return discountNode;
            }.bind(this)
          );
        },

        _showQuantityErrorMessages: function(itemElement) {
          itemElement
          .querySelectorAll(selectors.cartQuantityErrorMessage)
          .forEach(function(element) {
            element.textContent = theme.strings.quantityMinimumMessage;
          });

          itemElement
          .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
          .forEach(function(element) {
            element.classList.remove(classes.hide);
          });

          itemElement
          .querySelectorAll(selectors.inputQty)
          .forEach(function(element) {
            element.classList.add(classes.inputError);
            element.focus();
          });
        },

        _hideQuantityErrorMessage: function() {
          var errorMessages = document.querySelectorAll(
            selectors.cartQuantityErrorMessageWrapper
          );

          errorMessages.forEach(function(element) {
            element.classList.add(classes.hide);

            element.querySelector(selectors.cartQuantityErrorMessage).textContent =
              '';
          });

          this.container
          .querySelectorAll(selectors.inputQty)
          .forEach(function(element) {
            element.classList.remove(classes.inputError);
          });
        },

        _handleThumbnailClick: function(evt) {
          if (!evt.target.classList.contains(classes.thumbnails)) return;

          window.location.href = evt.target
          .closest(selectors.cartItem)
          .getAttribute('data-cart-item-url');
        },

        _onNoteChange: function(evt) {
          if (!evt.target.hasAttribute('data-cart-notes')) return;

          var note = evt.target.value;
          this._hideCartError();
          this._hideQuantityErrorMessage();

          var headers = new Headers({ 'Content-Type': 'application/json' });

          var request = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ note: note })
          };

          fetch('/cart/update.js', request).catch(
            function() {
              this._showCartError(evt.target);
            }.bind(this)
          );
        },

        _showCartError: function(elementToFocus) {
          document.querySelector(selectors.cartErrorMessage).textContent =
            theme.strings.cartError;

          document
          .querySelector(selectors.cartErrorMessageWrapper)
          .classList.remove(classes.hide);

          if (!elementToFocus) return;
          elementToFocus.focus();
        },

        _hideCartError: function() {
          document
          .querySelector(selectors.cartErrorMessageWrapper)
          .classList.add(classes.hide);
          document.querySelector(selectors.cartErrorMessage).textContent = '';
        },

        _onRemoveItem: function(evt) {
          if (!evt.target.hasAttribute('data-cart-remove')) return;

          evt.preventDefault();
          var lineItem = evt.target.closest(selectors.cartItem);
          var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

          this._hideCartError();

          var request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;'
            },
            body: JSON.stringify({
              line: index,
              quantity: 0
            })
          };

          fetch(this.cartRoutes.cartChangeUrl + '.js', request)
          .then(function(response) {
            return response.json();
          })
          .then(
            function(state) {
              if (state.item_count === 0) {
                this._emptyCart();
              } else {
                this._createCart(state);
                this._showRemoveMessage(lineItem.cloneNode(true));
              }

              this._setCartCountBubble(state.item_count);
            }.bind(this)
          )
          .catch(
            function() {
              this._showCartError(null);
            }.bind(this)
          );
        },

        _showRemoveMessage: function(lineItem) {
          var index = lineItem.getAttribute('data-cart-item-index');
          var removeMessage = this._getRemoveMessage(lineItem);

          if (index - 1 === 0) {
            this.container
            .querySelector('[data-cart-item-index="1"]')
            .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
          } else {
            this.container
            .querySelector("[data-cart-item-index='" + (index - 1) + "']")
            .insertAdjacentHTML('afterend', removeMessage.outerHTML);
          }

          this.container.querySelector('[data-removed-item-row]').focus();
        },

        _getRemoveMessage: function(lineItem) {
          var formattedMessage = this._formatRemoveMessage(lineItem);

          var tableCell = lineItem
          .querySelector(selectors.cartTableCell)
          .cloneNode(true);

          tableCell.removeAttribute('class');
          tableCell.classList.add(classes.cartRemovedProduct);
          tableCell.setAttribute('colspan', '4');
          tableCell.innerHTML = formattedMessage;

          lineItem.setAttribute('role', 'alert');
          lineItem.setAttribute('tabindex', '-1');
          lineItem.setAttribute('data-removed-item-row', true);
          lineItem.innerHTML = tableCell.outerHTML;

          return lineItem;
        },

        _formatRemoveMessage: function(lineItem) {
          var quantity = lineItem.getAttribute('data-cart-item-quantity');
          var url = lineItem.getAttribute(attributes.cartItemUrl);
          var title = lineItem.getAttribute(attributes.cartItemTitle);

          return theme.strings.removedItemMessage
          .replace('[quantity]', quantity)
          .replace(
            '[link]',
            '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
          );
        },

        _setCartCountBubble: function(quantity) {
          this.cartCountBubble =
            this.cartCountBubble ||
            document.querySelector(selectors.cartCountBubble);

          this.cartCount =
            this.cartCount || document.querySelector(selectors.cartCount);

          if (quantity > 0) {
            this.cartCountBubble.classList.remove(classes.hide);
            this.cartCount.textContent = quantity;
          } else {
            this.cartCountBubble.classList.add(classes.hide);
            this.cartCount.textContent = '';
          }
        },

        _emptyCart: function() {
          this.emptyPageContent =
            this.emptyPageContent ||
            this.container.querySelector(selectors.emptyPageContent);

          this.cartWrapper =
            this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

          this.emptyPageContent.classList.remove(classes.hide);
          this.cartWrapper.classList.add(classes.hide);
        }
      });

      return Cart;
    })();

    window.theme = window.theme || {};

    theme.Filters = (function() {
      var settings = {
        mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
      };

      var selectors = {
        filterSelection: '#FilterTags',
        sortSelection: '#SortBy',
        selectInput: '[data-select-input]'
      };

      function Filters(container) {
        this.filterSelect = container.querySelector(selectors.filterSelection);
        this.sortSelect = container.querySelector(selectors.sortSelection);

        this.selects = document.querySelectorAll(selectors.selectInput);

        if (this.sortSelect) {
          this.defaultSort = this._getDefaultSortValue();
        }

        if (this.selects.length) {
          this.selects.forEach(function(select) {
            select.classList.remove('hidden');
          });
        }

        this.initBreakpoints = this._initBreakpoints.bind(this);

        this.mql = window.matchMedia(settings.mediaQueryMediumUp);
        this.mql.addListener(this.initBreakpoints);

        if (this.filterSelect) {
          this.filterSelect.addEventListener(
            'change',
            this._onFilterChange.bind(this)
          );
        }

        if (this.sortSelect) {
          this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
        }

        theme.Helpers.promiseStylesheet().then(
          function() {
            this._initBreakpoints();
          }.bind(this)
        );
        this._initParams();
      }

      Filters.prototype = Object.assign({}, Filters.prototype, {
        _initBreakpoints: function() {
          if (this.mql.matches) {
            slate.utils.resizeSelects(this.selects);
          }
        },

        _initParams: function() {
          this.queryParams = {};
          if (location.search.length) {
            var aKeyValue;
            var aCouples = location.search.substr(1).split('&');
            for (var i = 0; i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                this.queryParams[
                  decodeURIComponent(aKeyValue[0])
                ] = decodeURIComponent(aKeyValue[1]);
              }
            }
          }
        },

        _onSortChange: function() {
          this.queryParams.sort_by = this._getSortValue();

          if (this.queryParams.page) {
            delete this.queryParams.page;
          }

          window.location.search = decodeURIComponent(
            new URLSearchParams(Object.entries(this.queryParams)).toString()
          );
        },

        _onFilterChange: function() {
          document.location.href = this._getFilterValue();
        },

        _getFilterValue: function() {
          return this.filterSelect.value;
        },

        _getSortValue: function() {
          return this.sortSelect.value || this.defaultSort;
        },

        _getDefaultSortValue: function() {
          return this.sortSelect.dataset.defaultSortby;
        },

        onUnload: function() {
          if (this.filterSelect) {
            this.filterSelect.removeEventListener('change', this._onFilterChange);
          }

          if (this.sortSelect) {
            this.sortSelect.removeEventListener('change', this._onSortChange);
          }

          this.mql.removeListener(this.initBreakpoints);
        }
      });

      return Filters;
    })();

    window.theme = window.theme || {};

    theme.HeaderSection = (function() {
      function Header() {
        theme.Header.init();
        theme.MobileNav.init();
        theme.SearchDrawer.init();
        theme.Search.init();
      }

      Header.prototype = Object.assign({}, Header.prototype, {
        onUnload: function() {
          theme.Header.unload();
          theme.Search.unload();
          theme.MobileNav.unload();
        }
      });

      return Header;
    })();

    theme.Maps = (function() {
      var config = {
        zoom: 14
      };
      var apiStatus = null;
      var mapsToLoad = [];

      var errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };

      var selectors = {
        section: '[data-section-type="map"]',
        map: '[data-map]',
        mapOverlay: '[data-map-overlay]'
      };

      var classes = {
        mapError: 'map-section--load-error',
        errorMsg: 'map-section__error errors text-center'
      };

      // Global function called by Google on auth errors.
      // Show an auto error message on all map instances.
      // eslint-disable-next-line camelcase, no-unused-vars
      window.gm_authFailure = function() {
        if (!Shopify.designMode) {
          return;
        }

        document.querySelector(selectors.section).classList.add(classes.mapError);
        document.querySelector(selectors.map).remove();
        document
        .querySelector(selectors.mapOverlay)
        .insertAdjacentHTML(
          'afterend',
          '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
        );
      };

      function Map(container) {
        this.map = container.querySelector(selectors.map);
        if (!this.map) return;
        this.key = this.map.dataset.apiKey;

        if (typeof this.key === 'undefined') {
          return;
        }

        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined') {
              theme.Helpers.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      }

      function initAllMaps() {
        // API has loaded, load all Map instances in queue
        mapsToLoad.forEach(function(map) {
          map.createMap();
        });
      }

      function geolocate(map) {
        return new Promise(function(resolve, reject) {
          var geocoder = new google.maps.Geocoder();
          var address = map.dataset.addressSetting;

          geocoder.geocode({ address: address }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              reject(status);
            }

            resolve(results);
          });
        });
      }

      Map.prototype = Object.assign({}, Map.prototype, {
        createMap: function() {
          return geolocate(this.map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };

              var map = (this.map = new google.maps.Map(this.map, mapOptions));
              var center = (this.center = map.getCenter());

              //eslint-disable-next-line no-unused-vars
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });

              google.maps.event.addDomListener(
                window,
                'resize',
                theme.Helpers.debounce(
                  function() {
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                    this.map.removeAttribute('style');
                  }.bind(this),
                  250
                )
              );
            }.bind(this)
          )
          .catch(
            function() {
              var errorMessage;

              switch (status) {
                case 'ZERO_RESULTS':
                  errorMessage = errors.addressNoResults;
                  break;
                case 'OVER_QUERY_LIMIT':
                  errorMessage = errors.addressQueryLimit;
                  break;
                case 'REQUEST_DENIED':
                  errorMessage = errors.authError;
                  break;
                default:
                  errorMessage = errors.addressError;
                  break;
              }

              // Show errors only to merchant in the editor.
              if (Shopify.designMode) {
                this.map.parentNode.classList.add(classes.mapError);
                this.map.parentNode.innerHTML =
                  '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>';
              }
            }.bind(this)
          );
        },

        onUnload: function() {
          if (this.map) {
            google.maps.event.clearListeners(this.map, 'resize');
          }
        }
      });

      return Map;
    })();

    /* eslint-disable no-new */
    theme.Product = (function() {
      function Product(container) {
        this.container = container;
        var sectionId = container.getAttribute('data-section-id');
        this.zoomPictures = [];
        this.ajaxEnabled = container.getAttribute('data-ajax-enabled') === 'true';

        this.settings = {
          // Breakpoints from src/stylesheets/global/variables.scss.liquid
          mediaQueryMediumUp: 'screen and (min-width: 750px)',
          mediaQuerySmall: 'screen and (max-width: 749px)',
          bpSmall: false,
          enableHistoryState:
          container.getAttribute('data-enable-history-state') === 'true',
          namespace: '.slideshow-' + sectionId,
          sectionId: sectionId,
          sliderActive: false,
          zoomEnabled: false
        };

        this.selectors = {
          addToCart: '[data-add-to-cart]',
          addToCartText: '[data-add-to-cart-text]',
          cartCount: '[data-cart-count]',
          cartCountBubble: '[data-cart-count-bubble]',
          cartPopup: '[data-cart-popup]',
          cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
          cartPopupClose: '[data-cart-popup-close]',
          cartPopupDismiss: '[data-cart-popup-dismiss]',
          cartPopupImage: '[data-cart-popup-image]',
          cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
          cartPopupImagePlaceholder: '[data-image-loading-animation]',
          cartPopupProductDetails: '[data-cart-popup-product-details]',
          cartPopupQuantity: '[data-cart-popup-quantity]',
          cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
          cartPopupTitle: '[data-cart-popup-title]',
          cartPopupWrapper: '[data-cart-popup-wrapper]',
          loader: '[data-loader]',
          loaderStatus: '[data-loader-status]',
          quantity: '[data-quantity-input]',
          SKU: '.variant-sku',
          productStatus: '[data-product-status]',
          originalSelectorId: '#ProductSelect-' + sectionId,
          productForm: '[data-product-form]',
          errorMessage: '[data-error-message]',
          errorMessageWrapper: '[data-error-message-wrapper]',
          imageZoomWrapper: '[data-image-zoom-wrapper]',
          productMediaWrapper: '[data-product-single-media-wrapper]',
          productThumbImages: '.product-single__thumbnail--' + sectionId,
          productThumbs: '.product-single__thumbnails-' + sectionId,
          productThumbListItem: '.product-single__thumbnails-item',
          productThumbsWrapper: '.thumbnails-wrapper',
          saleLabel: '.product-price__sale-label-' + sectionId,
          singleOptionSelector: '.single-option-selector-' + sectionId,
          shopifyPaymentButton: '.shopify-payment-button',
          productMediaTypeVideo: '[data-product-media-type-video]',
          productMediaTypeModel: '[data-product-media-type-model]',
          priceContainer: '[data-price]',
          regularPrice: '[data-regular-price]',
          salePrice: '[data-sale-price]',
          unitPrice: '[data-unit-price]',
          unitPriceBaseUnit: '[data-unit-price-base-unit]',
          productPolicies: '[data-product-policies]',
          storeAvailabilityContainer: '[data-store-availability-container]'
        };

        this.classes = {
          cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
          hidden: 'hide',
          visibilityHidden: 'visibility-hidden',
          inputError: 'input--error',
          jsZoomEnabled: 'js-zoom-enabled',
          productOnSale: 'price--on-sale',
          productUnitAvailable: 'price--unit-available',
          productUnavailable: 'price--unavailable',
          productSoldOut: 'price--sold-out',
          cartImage: 'cart-popup-item__image',
          productFormErrorMessageWrapperHidden:
          'product-form__error-message-wrapper--hidden',
          activeClass: 'active-thumb',
          variantSoldOut: 'product-form--variant-sold-out'
        };

        this.eventHandlers = {};

        this.quantityInput = container.querySelector(this.selectors.quantity);
        this.errorMessageWrapper = container.querySelector(
          this.selectors.errorMessageWrapper
        );
        this.productForm = container.querySelector(this.selectors.productForm);
        this.addToCart = container.querySelector(this.selectors.addToCart);
        this.addToCartText = this.addToCart.querySelector(
          this.selectors.addToCartText
        );
        this.shopifyPaymentButton = container.querySelector(
          this.selectors.shopifyPaymentButton
        );
        this.priceContainer = container.querySelector(
          this.selectors.priceContainer
        );
        this.productPolicies = container.querySelector(
          this.selectors.productPolicies
        );
        this.storeAvailabilityContainer = container.querySelector(
          this.selectors.storeAvailabilityContainer
        );
        if (this.storeAvailabilityContainer) {
          this._initStoreAvailability();
        }

        this.loader = this.addToCart.querySelector(this.selectors.loader);
        this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

        this.imageZoomWrapper = container.querySelectorAll(
          this.selectors.imageZoomWrapper
        );

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        var productJson = document.getElementById('ProductJson-' + sectionId);
        if (!productJson || !productJson.innerHTML.length) {
          return;
        }

        this.productSingleObject = JSON.parse(productJson.innerHTML);

        // Initial state for global productState object
        this.productState = {
          available: true,
          soldOut: false,
          onSale: false,
          showUnitPrice: false
        };

        this.settings.zoomEnabled =
          this.imageZoomWrapper.length > 0
        ? this.imageZoomWrapper[0].classList.contains(
          this.classes.jsZoomEnabled
        )
        : false;

        this.cartRoutes = JSON.parse(
          document.querySelector('[data-cart-routes]').innerHTML
        );

        this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
        this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

        this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall);
        this.mqlSmall.addListener(this.initMobileBreakpoint);

        this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
        this.mqlMediumUp.addListener(this.initDesktopBreakpoint);

        this.initMobileBreakpoint();
        this.initDesktopBreakpoint();
        this._stringOverrides();
        this._initVariants();
        this._initMediaSwitch();
        this._initAddToCart();
        this._setActiveThumbnail();
        this._initProductVideo();
        this._initModelViewerLibraries();
        this._initShopifyXrLaunch();
      }

      Product.prototype = Object.assign({}, Product.prototype, {
        _stringOverrides: function() {
          theme.productStrings = theme.productStrings || {};
          theme.strings = Object.assign({}, theme.strings, theme.productStrings);
        },

        _initStoreAvailability: function() {
          this.storeAvailability = new theme.StoreAvailability(
            this.storeAvailabilityContainer
          );

          var storeAvailabilityModalOpenedCallback = function(event) {
            if (
              this.cartPopupWrapper &&
              !this.cartPopupWrapper.classList.contains(
                this.classes.cartPopupWrapperHidden
              )
            ) {
              this._hideCartPopup(event);
            }
          };

          // hide cart popup modal if the store availability modal is also opened
          this.storeAvailabilityContainer.addEventListener(
            'storeAvailabilityModalOpened',
            storeAvailabilityModalOpenedCallback.bind(this)
          );
        },

        _initMobileBreakpoint: function() {
          if (this.mqlSmall.matches) {
            // initialize thumbnail slider on mobile if more than four thumbnails
            if (
              this.container.querySelectorAll(this.selectors.productThumbImages)
              .length > 4
            ) {
              this._initThumbnailSlider();
            }

            // destroy image zooming if enabled
            if (this.settings.zoomEnabled) {
              this.imageZoomWrapper.forEach(
                function(element, index) {
                  this._destroyZoom(index);
                }.bind(this)
              );
            }

            this.settings.bpSmall = true;
          } else {
            if (this.settings.sliderActive) {
              this._destroyThumbnailSlider();
            }

            this.settings.bpSmall = false;
          }
        },

        _initDesktopBreakpoint: function() {
          if (this.mqlMediumUp.matches && this.settings.zoomEnabled) {
            this.imageZoomWrapper.forEach(
              function(element, index) {
                this._enableZoom(element, index);
              }.bind(this)
            );
          }
        },

        _initVariants: function() {
          var options = {
            container: this.container,
            enableHistoryState:
            this.container.getAttribute('data-enable-history-state') === 'true',
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject
          };

          this.variants = new slate.Variants(options);
          if (this.storeAvailability && this.variants.currentVariant.available) {
            this.storeAvailability.updateContent(this.variants.currentVariant.id);
          }

          this.eventHandlers.updateAvailability = this._updateAvailability.bind(
            this
          );
          this.eventHandlers.updateMedia = this._updateMedia.bind(this);
          this.eventHandlers.updatePrice = this._updatePrice.bind(this);
          this.eventHandlers.updateSKU = this._updateSKU.bind(this);

          this.container.addEventListener(
            'variantChange',
            this.eventHandlers.updateAvailability
          );
          this.container.addEventListener(
            'variantImageChange',
            this.eventHandlers.updateMedia
          );
          this.container.addEventListener(
            'variantPriceChange',
            this.eventHandlers.updatePrice
          );
          this.container.addEventListener(
            'variantSKUChange',
            this.eventHandlers.updateSKU
          );
        },

        _initMediaSwitch: function() {
          if (!document.querySelector(this.selectors.productThumbImages)) {
            return;
          }

          var self = this;

          var productThumbImages = document.querySelectorAll(
            this.selectors.productThumbImages
          );

          this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

          productThumbImages.forEach(function(el) {
            el.addEventListener('click', function(evt) {
              evt.preventDefault();
              var mediaId = el.getAttribute('data-thumbnail-id');

              self._switchMedia(mediaId);
              self._setActiveThumbnail(mediaId);
            });
            el.addEventListener('keyup', self.eventHandlers.handleMediaFocus);
          });
        },

        _initAddToCart: function() {
          this.productForm.addEventListener(
            'submit',
            function(evt) {
              if (this.addToCart.getAttribute('aria-disabled') === 'true') {
                evt.preventDefault();
                return;
              }

              if (!this.ajaxEnabled) return;

              evt.preventDefault();

              this.previouslyFocusedElement = document.activeElement;

              var isInvalidQuantity =
                  !!this.quantityInput && this.quantityInput.value <= 0;

              if (isInvalidQuantity) {
                this._showErrorMessage(theme.strings.quantityMinimumMessage);
                return;
              }

              if (!isInvalidQuantity && this.ajaxEnabled) {
                // disable the addToCart and dynamic checkout button while
                // request/cart popup is loading and handle loading state
                this._handleButtonLoadingState(true);
                this._addItemToCart(this.productForm);
                return;
              }
            }.bind(this)
          );
        },

        _initProductVideo: function() {
          var sectionId = this.settings.sectionId;

          var productMediaTypeVideo = this.container.querySelectorAll(
            this.selectors.productMediaTypeVideo
          );
          productMediaTypeVideo.forEach(function(el) {
            theme.ProductVideo.init(el, sectionId);
          });
        },

        _initModelViewerLibraries: function() {
          var modelViewerElements = this.container.querySelectorAll(
            this.selectors.productMediaTypeModel
          );
          if (modelViewerElements.length < 1) return;
          theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
        },

        _initShopifyXrLaunch: function() {
          this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
            this
          );
          document.addEventListener(
            'shopify_xr_launch',
            this.eventHandlers.initShopifyXrLaunchHandler
          );
        },

        _initShopifyXrLaunchHandler: function() {
          var currentMedia = this.container.querySelector(
            this.selectors.productMediaWrapper +
            ':not(.' +
            self.classes.hidden +
            ')'
          );
          currentMedia.dispatchEvent(
            new CustomEvent('xrLaunch', {
              bubbles: true,
              cancelable: true
            })
          );
        },

        _addItemToCart: function(form) {
          var self = this;

          fetch(this.cartRoutes.cartAddUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: theme.Helpers.serialize(form)
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(json) {
            if (json.status && json.status !== 200) {
              var error = new Error(json.description);
              error.isFromServer = true;
              throw error;
            }
            self._hideErrorMessage();
            self._setupCartPopup(json);
          })
          .catch(function(error) {
            self.previouslyFocusedElement.focus();
            self._showErrorMessage(
              error.isFromServer && error.message.length
              ? error.message
              : theme.strings.cartError
            );
            self._handleButtonLoadingState(false);
            // eslint-disable-next-line no-console
            console.log(error);
          });
        },

        _handleButtonLoadingState: function(isLoading) {
          if (isLoading) {
            this.addToCart.setAttribute('aria-disabled', true);
            this.addToCartText.classList.add(this.classes.hidden);
            this.loader.classList.remove(this.classes.hidden);

            if (this.shopifyPaymentButton) {
              this.shopifyPaymentButton.setAttribute('disabled', true);
            }

            this.loaderStatus.setAttribute('aria-hidden', false);
          } else {
            this.addToCart.removeAttribute('aria-disabled');
            this.addToCartText.classList.remove(this.classes.hidden);
            this.loader.classList.add(this.classes.hidden);

            if (this.shopifyPaymentButton) {
              this.shopifyPaymentButton.removeAttribute('disabled');
            }

            this.loaderStatus.setAttribute('aria-hidden', true);
          }
        },

        _showErrorMessage: function(errorMessage) {
          var errorMessageContainer = this.container.querySelector(
            this.selectors.errorMessage
          );
          errorMessageContainer.innerHTML = errorMessage;

          if (this.quantityInput) {
            this.quantityInput.classList.add(this.classes.inputError);
          }

          this.errorMessageWrapper.classList.remove(
            this.classes.productFormErrorMessageWrapperHidden
          );
          this.errorMessageWrapper.setAttribute('aria-hidden', true);
          this.errorMessageWrapper.removeAttribute('aria-hidden');
        },

        _hideErrorMessage: function() {
          this.errorMessageWrapper.classList.add(
            this.classes.productFormErrorMessageWrapperHidden
          );

          if (this.quantityInput) {
            this.quantityInput.classList.remove(this.classes.inputError);
          }
        },

        _setupCartPopup: function(item) {
          this.cartPopup =
            this.cartPopup || document.querySelector(this.selectors.cartPopup);
          this.cartPopupWrapper =
            this.cartPopupWrapper ||
            document.querySelector(this.selectors.cartPopupWrapper);
          this.cartPopupTitle =
            this.cartPopupTitle ||
            document.querySelector(this.selectors.cartPopupTitle);
          this.cartPopupQuantity =
            this.cartPopupQuantity ||
            document.querySelector(this.selectors.cartPopupQuantity);
          this.cartPopupQuantityLabel =
            this.cartPopupQuantityLabel ||
            document.querySelector(this.selectors.cartPopupQuantityLabel);
          this.cartPopupClose =
            this.cartPopupClose ||
            document.querySelector(this.selectors.cartPopupClose);
          this.cartPopupDismiss =
            this.cartPopupDismiss ||
            document.querySelector(this.selectors.cartPopupDismiss);
          this.cartPopupImagePlaceholder =
            this.cartPopupImagePlaceholder ||
            document.querySelector(this.selectors.cartPopupImagePlaceholder);

          this._setupCartPopupEventListeners();

          this._updateCartPopupContent(item);
        },

        _updateCartPopupContent: function(item) {
          var self = this;

          var quantity = this.quantityInput ? this.quantityInput.value : 1;

          var selling_plan_name = item.selling_plan_allocation
          ? item.selling_plan_allocation.selling_plan.name
          : null;

          this.cartPopupTitle.textContent = item.product_title;
          this.cartPopupQuantity.textContent = quantity;
          this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
            '[count]',
            quantity
          );

          this._setCartPopupPlaceholder(item.featured_image.url);
          this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
          this._setCartPopupProductDetails(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties,
            selling_plan_name
          );

          fetch(this.cartRoutes.cartUrl + '.js', { credentials: 'same-origin' })
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            self._setCartQuantity(cart.item_count);
            self._setCartCountBubble(cart.item_count);
            self._showCartPopup();
          })
          .catch(function(error) {
            // eslint-disable-next-line no-console
            console.log(error);
          });
        },

        _setupCartPopupEventListeners: function() {
          this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
            this
          );
          this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
          this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

          this.cartPopupWrapper.addEventListener(
            'keyup',
            this.eventHandlers.cartPopupWrapperKeyupHandler
          );
          this.cartPopupClose.addEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          this.cartPopupDismiss.addEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          document.body.addEventListener('click', this.eventHandlers.onBodyClick);
        },

        _cartPopupWrapperKeyupHandler: function(event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        },

        _setCartPopupPlaceholder: function(imageUrl) {
          this.cartPopupImageWrapper =
            this.cartPopupImageWrapper ||
            document.querySelector(this.selectors.cartPopupImageWrapper);

          if (imageUrl === null) {
            this.cartPopupImageWrapper.classList.add(this.classes.hidden);
            return;
          }
        },

        _setCartPopupImage: function(imageUrl, imageAlt) {
          if (imageUrl === null) return;

          this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
          var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
          var image = document.createElement('img');
          image.src = sizedImageUrl;
          image.alt = imageAlt;
          image.classList.add(this.classes.cartImage);
          image.setAttribute('data-cart-popup-image', '');

          image.onload = function() {
            this.cartPopupImagePlaceholder.removeAttribute(
              'data-image-loading-animation'
            );
            this.cartPopupImageWrapper.append(image);
          }.bind(this);
        },

        _setCartPopupProductDetails: function(
        product_has_only_default_variant,
         options,
         properties,
         selling_plan_name
        ) {
          this.cartPopupProductDetails =
            this.cartPopupProductDetails ||
            document.querySelector(this.selectors.cartPopupProductDetails);
          var variantPropertiesHTML = '';

          if (!product_has_only_default_variant) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getVariantOptionList(options);
          }

          if (selling_plan_name) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getSellingPlanHTML(selling_plan_name);
          }

          if (properties !== null && Object.keys(properties).length !== 0) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getPropertyList(properties);
          }

          if (variantPropertiesHTML.length === 0) {
            this.cartPopupProductDetails.innerHTML = '';
            this.cartPopupProductDetails.setAttribute('hidden', '');
          } else {
            this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
            this.cartPopupProductDetails.removeAttribute('hidden');
          }
        },

        _getVariantOptionList: function(variantOptions) {
          var variantOptionListHTML = '';

          variantOptions.forEach(function(variantOption) {
            variantOptionListHTML =
              variantOptionListHTML +
              '<li class="product-details__item product-details__item--variant-option">' +
              variantOption.name +
              ': ' +
              variantOption.value +
              '</li>';
          });

          return variantOptionListHTML;
        },

        _getPropertyList: function(properties) {
          var propertyListHTML = '';
          var propertiesArray = Object.entries(properties);

          propertiesArray.forEach(function(property) {
            // Line item properties prefixed with an underscore are not to be displayed
            if (property[0].charAt(0) === '_') return;

            // if the property value has a length of 0 (empty), don't display it
            if (property[1].length === 0) return;

            propertyListHTML =
              propertyListHTML +
              '<li class="product-details__item product-details__item--property">' +
              '<span class="product-details__property-label">' +
              property[0] +
              ': </span>' +
              property[1];
            ': ' + '</li>';
          });

          return propertyListHTML;
        },

        _getSellingPlanHTML: function(selling_plan_name) {
          var sellingPlanHTML =
              '<li class="product-details__item product-details__item--property">' +
              selling_plan_name +
              '</li>';

          return sellingPlanHTML;
        },

        _setCartQuantity: function(quantity) {
          this.cartPopupCartQuantity =
            this.cartPopupCartQuantity ||
            document.querySelector(this.selectors.cartPopupCartQuantity);
          var ariaLabel;

          if (quantity === 1) {
            ariaLabel = theme.strings.oneCartCount;
          } else if (quantity > 1) {
            ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
          }

          this.cartPopupCartQuantity.textContent = quantity;
          this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
        },

        _setCartCountBubble: function(quantity) {
          this.cartCountBubble =
            this.cartCountBubble ||
            document.querySelector(this.selectors.cartCountBubble);
          this.cartCount =
            this.cartCount || document.querySelector(this.selectors.cartCount);

          this.cartCountBubble.classList.remove(this.classes.hidden);
          this.cartCount.textContent = quantity;
        },

        _showCartPopup: function() {
          theme.Helpers.prepareTransition(this.cartPopupWrapper);

          this.cartPopupWrapper.classList.remove(
            this.classes.cartPopupWrapperHidden
          );
          this._handleButtonLoadingState(false);

          slate.a11y.trapFocus({
            container: this.cartPopupWrapper,
            elementToFocus: this.cartPopup,
            namespace: 'cartPopupFocus'
          });
        },

        _hideCartPopup: function(event) {
          var setFocus = event.detail === 0 ? true : false;
          theme.Helpers.prepareTransition(this.cartPopupWrapper);
          this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

          var cartPopupImage = document.querySelector(
            this.selectors.cartPopupImage
          );
          if (cartPopupImage) {
            cartPopupImage.remove();
          }
          this.cartPopupImagePlaceholder.setAttribute(
            'data-image-loading-animation',
            ''
          );

          slate.a11y.removeTrapFocus({
            container: this.cartPopupWrapper,
            namespace: 'cartPopupFocus'
          });

          if (setFocus) this.previouslyFocusedElement.focus();

          this.cartPopupWrapper.removeEventListener(
            'keyup',
            this.eventHandlers.cartPopupWrapperKeyupHandler
          );
          this.cartPopupClose.removeEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          this.cartPopupDismiss.removeEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          document.body.removeEventListener(
            'click',
            this.eventHandlers.onBodyClick
          );
        },

        _onBodyClick: function(event) {
          var target = event.target;

          if (
            target !== this.cartPopupWrapper &&
            !target.closest(this.selectors.cartPopup)
          ) {
            this._hideCartPopup(event);
          }
        },

        _setActiveThumbnail: function(mediaId) {
          // If there is no element passed, find it by the current product image
          if (typeof mediaId === 'undefined') {
            var productMediaWrapper = this.container.querySelector(
              this.selectors.productMediaWrapper + ':not(.hide)'
            );

            if (!productMediaWrapper) return;
            mediaId = productMediaWrapper.getAttribute('data-media-id');
          }

          var thumbnailWrappers = this.container.querySelectorAll(
            this.selectors.productThumbListItem + ':not(.slick-cloned)'
          );

          var activeThumbnail;
          thumbnailWrappers.forEach(
            function(el) {
              var current = el.querySelector(
                this.selectors.productThumbImages +
                "[data-thumbnail-id='" +
                mediaId +
                "']"
              );
              if (current) {
                activeThumbnail = current;
              }
            }.bind(this)
          );

          var productThumbImages = document.querySelectorAll(
            this.selectors.productThumbImages
          );
          productThumbImages.forEach(
            function(el) {
              el.classList.remove(this.classes.activeClass);
              el.removeAttribute('aria-current');
            }.bind(this)
          );
			console.log(this);
          console.log('_setActiveThumbnail')
          if (activeThumbnail) {
            activeThumbnail.classList.add(this.classes.activeClass);
            activeThumbnail.setAttribute('aria-current', true);
            (typeof via_product_handle != 'string') && this._adjustThumbnailSlider(activeThumbnail);
          }
        },

        _adjustThumbnailSlider: function(activeThumbnail) {
          console.log(this,'_adjustThumbnailSlider');
          let self = this;
          var sliderItem = activeThumbnail.closest('[data-slider-item]');
          if (!sliderItem) return;

          var slideGroupLeaderIndex =
              Math.floor(
                Number(sliderItem.getAttribute('data-slider-slide-index')) / 3
              ) * 3;

          window.setTimeout(
            function() {
              if (!self.slideshow) return;
              self.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
            }.bind(self),
            251
          );
        },

        _switchMedia: function(mediaId) {
          var currentMedia = this.container.querySelector(
            this.selectors.productMediaWrapper +
            ':not(.' +
            this.classes.hidden +
            ')'
          );

          var newMedia = this.container.querySelector(
            this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
          );

          var otherMedia = this.container.querySelectorAll(
            this.selectors.productMediaWrapper +
            ":not([data-media-id='" +
            mediaId +
            "'])"
          );

          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
          newMedia.classList.remove(this.classes.hidden);
          newMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          otherMedia.forEach(
            function(el) {
              el.classList.add(this.classes.hidden);
            }.bind(this)
          );
        },

        _handleMediaFocus: function(evt) {
          if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

          var mediaId = evt.currentTarget.getAttribute('data-thumbnail-id');

          var productMediaWrapper = this.container.querySelector(
            this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
          );
          productMediaWrapper.focus();
        },

        _initThumbnailSlider: function() {
          setTimeout(
            function() {
              if($(window).width() > 750){
                console.log('desktop');
              	this.slideshow = new theme.Slideshow(
                this.container.querySelector('.thumb_slider_desktop[data-thumbnail-slider]'),
                {
                  canUseTouchEvents: true,
                  type: 'slide',
                  slideActiveClass: 'slick-active',
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  arrows:true
                });
              }else{
               	console.log('mobile');
                console.log(this.container.querySelector('.mobile_thumbslider[data-thumbnail-slider]'))
                this.slideshow = new theme.Slideshow(
                  this.container.querySelector('.mobile_thumbslider[data-thumbnail-slider]'),
                  {
                    canUseTouchEvents: true,
                    type: 'slide',
                    slideActiveClass: 'slick-active',
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows:true
                  });
              }
             

              this.settings.sliderActive = true;
            }.bind(this),
            250
          );
        },

        _destroyThumbnailSlider: function() {
          var sliderButtons = this.container.querySelectorAll(
            '[data-slider-button]'
          );
          var sliderTrack = this.container.querySelector('[data-slider-track]');
          var sliderItems = sliderTrack.querySelectorAll('[data-slider-item');
          this.settings.sliderActive = false;

          if (sliderTrack) {
            sliderTrack.removeAttribute('style');
            sliderItems.forEach(function(sliderItem) {
              var sliderItemLink = sliderItem.querySelector(
                '[data-slider-item-link]'
              );
              sliderItem.classList.remove('slick-active');
              sliderItem.removeAttribute('style');
              sliderItem.removeAttribute('tabindex');
              sliderItem.removeAttribute('aria-hidden');
              sliderItemLink.removeAttribute('tabindex');
            });
          }

          sliderButtons.forEach(function(sliderButton) {
            sliderButton.removeAttribute('aria-disabled');
          });

          this.slideshow.destroy();
          this.slideshow = null;
        },

        _liveRegionText: function(variant) {
          // Dummy content for live region
          var liveRegionText =
              '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

          if (!this.productState.available) {
            liveRegionText = theme.strings.unavailable;
            return liveRegionText;
          }

          // Update availability
          var availability = this.productState.soldOut
          ? theme.strings.soldOut + ','
          : '';
          liveRegionText = liveRegionText.replace('[Availability]', availability);

          // Update pricing information
          var regularLabel = '';
          var regularPrice = theme.Currency.formatMoney(
            variant.price,
            theme.moneyFormat
          );
          var saleLabel = '';
          var salePrice = '';
          var unitLabel = '';
          var unitPrice = '';

          if (this.productState.onSale) {
            regularLabel = theme.strings.regularPrice;
            regularPrice =
              theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            ) + ',';
            saleLabel = theme.strings.sale;
            salePrice = theme.Currency.formatMoney(
              variant.price,
              theme.moneyFormat
            );
          }

          if (this.productState.showUnitPrice) {
            unitLabel = theme.strings.unitPrice;
            unitPrice =
              theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
              ' ' +
              theme.strings.unitPriceSeparator +
              ' ' +
              this._getBaseUnit(variant);
          }

          liveRegionText = liveRegionText
          .replace('[Regular]', regularLabel)
          .replace('[$$]', regularPrice)
          .replace('[Sale]', saleLabel)
          .replace('[$]', salePrice)
          .replace('[UnitPrice]', unitLabel)
          .replace('[$$$]', unitPrice)
          .trim();

          return liveRegionText;
        },

        _updateLiveRegion: function(evt) {
          var variant = evt.detail.variant;
          var liveRegion = this.container.querySelector(
            this.selectors.productStatus
          );
          liveRegion.innerHTML = this._liveRegionText(variant);
          liveRegion.setAttribute('aria-hidden', false);
          // hide content from accessibility tree after announcement
          setTimeout(function() {
            liveRegion.setAttribute('aria-hidden', true);
          }, 1000);
        },

        _enableAddToCart: function(message) {
          this.addToCart.removeAttribute('aria-disabled');
          this.addToCart.setAttribute('aria-label', message);
          this.addToCartText.innerHTML = message;
          this.productForm.classList.remove(this.classes.variantSoldOut);
        },

        _disableAddToCart: function(message) {
          message = message || theme.strings.unavailable;
          this.addToCart.setAttribute('aria-disabled', true);
          this.addToCart.setAttribute('aria-label', message);
          this.addToCartText.innerHTML = message;
          this.productForm.classList.add(this.classes.variantSoldOut);
        },

        _updateAddToCart: function() {
          if (!this.productState.available) {
            this._disableAddToCart(theme.strings.unavailable);
            return;
          }
          if (this.productState.soldOut) {
            this._disableAddToCart(theme.strings.soldOut);
            return;
          }

          this._enableAddToCart(theme.strings.addToCart);
        },

        /**
     * The returned productState object keeps track of a number of properties about the current variant and product
     * Multiple functions within product.js leverage the productState object to determine how to update the page's UI
     * @param {object} evt - object returned from variant change event
     * @return {object} productState - current product variant's state
     *                  productState.available - true if current product options result in valid variant
     *                  productState.soldOut - true if variant is sold out
     *                  productState.onSale - true if variant is on sale
     *                  productState.showUnitPrice - true if variant has unit price value
     */
        _setProductState: function(evt) {
          var variant = evt.detail.variant;

          if (!variant) {
            this.productState.available = false;
            return;
          }

          this.productState.available = true;
          this.productState.soldOut = !variant.available;
          this.productState.onSale = variant.compare_at_price > variant.price;
          this.productState.showUnitPrice = !!variant.unit_price;
        },

        _updateAvailability: function(evt) {
          // remove error message if one is showing
          this._hideErrorMessage();

          // set product state
          this._setProductState(evt);

          // update store availabilities info
          this._updateStoreAvailabilityContent(evt);
          // update form submit
          this._updateAddToCart();
          // update live region
          this._updateLiveRegion(evt);

          this._updatePriceComponentStyles(evt);
        },

        _updateStoreAvailabilityContent: function(evt) {
          if (!this.storeAvailability) {
            return;
          }

          if (this.productState.available && !this.productState.soldOut) {
            this.storeAvailability.updateContent(evt.detail.variant.id);
          } else {
            this.storeAvailability.clearContent();
          }
        },

        _updateMedia: function(evt) {
          var variant = evt.detail.variant;
          var mediaId = variant.featured_media.id;
          var sectionMediaId = this.settings.sectionId + '-' + mediaId;

          this._switchMedia(sectionMediaId);
          this._setActiveThumbnail(sectionMediaId);
        },

        _hidePriceComponent: function() {
          this.priceContainer.classList.add(this.classes.productUnavailable);
          this.priceContainer.setAttribute('aria-hidden', true);
          if (this.productPolicies) {
            this.productPolicies.classList.add(this.classes.visibilityHidden);
          }
        },

        _updatePriceComponentStyles: function(evt) {
          var variant = evt.detail.variant;

          var unitPriceBaseUnit = this.priceContainer.querySelector(
            this.selectors.unitPriceBaseUnit
          );

          if (!this.productState.available) {
            this._hidePriceComponent();
            return;
          }

          if (this.productState.soldOut) {
            this.priceContainer.classList.add(this.classes.productSoldOut);
          } else {
            this.priceContainer.classList.remove(this.classes.productSoldOut);
          }

          if (this.productState.showUnitPrice) {
            unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
            this.priceContainer.classList.add(this.classes.productUnitAvailable);
          } else {
            this.priceContainer.classList.remove(this.classes.productUnitAvailable);
          }

          if (this.productState.onSale) {
            this.priceContainer.classList.add(this.classes.productOnSale);
          } else {
            this.priceContainer.classList.remove(this.classes.productOnSale);
          }

          this.priceContainer.classList.remove(this.classes.productUnavailable);
          this.priceContainer.removeAttribute('aria-hidden');
          if (this.productPolicies) {
            this.productPolicies.classList.remove(this.classes.visibilityHidden);
          }
        },

        _updatePrice: function(evt) {
          var variant = evt.detail.variant;

          var regularPrices = this.priceContainer.querySelectorAll(
            this.selectors.regularPrice
          );
          var salePrice = this.priceContainer.querySelector(
            this.selectors.salePrice
          );
          var unitPrice = this.priceContainer.querySelector(
            this.selectors.unitPrice
          );

          var formatRegularPrice = function(regularPriceElement, price) {
            regularPriceElement.innerHTML = theme.Currency.formatMoney(
              price,
              theme.moneyFormat
            );
          };

          // On sale
          if (this.productState.onSale) {
            regularPrices.forEach(function(regularPrice) {
              formatRegularPrice(regularPrice, variant.compare_at_price);
            });
            salePrice.innerHTML = theme.Currency.formatMoney(
              variant.price,
              theme.moneyFormat
            );
          } else {
            // Regular price
            regularPrices.forEach(function(regularPrice) {
              formatRegularPrice(regularPrice, variant.price);
            });
          }

          // Unit price
          if (this.productState.showUnitPrice) {
            unitPrice.innerHTML = theme.Currency.formatMoney(
              variant.unit_price,
              theme.moneyFormat
            );
          }
        },

        _getBaseUnit: function(variant) {
          return variant.unit_price_measurement.reference_value === 1
          ? variant.unit_price_measurement.reference_unit
          : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
        },

        _updateSKU: function(evt) {
          var variant = evt.detail.variant;

          // Update the sku
          var sku = document.querySelector(this.selectors.SKU);
          if (!sku) return;
          sku.innerHTML = variant.sku;
        },

        _enableZoom: function(el, index) {
          this.zoomPictures[index] = new theme.Zoom(el);
        },

        _destroyZoom: function(index) {
          if (this.zoomPictures.length === 0) return;
          this.zoomPictures[index].unload();
        },

        onUnload: function() {
          this.container.removeEventListener(
            'variantChange',
            this.eventHandlers.updateAvailability
          );
          this.container.removeEventListener(
            'variantImageChange',
            this.eventHandlers.updateMedia
          );
          this.container.removeEventListener(
            'variantPriceChange',
            this.eventHandlers.updatePrice
          );
          this.container.removeEventListener(
            'variantSKUChange',
            this.eventHandlers.updateSKU
          );
          theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
          theme.ProductModel.removeSectionModels(this.settings.sectionId);

          if (this.mqlSmall) {
            this.mqlSmall.removeListener(this.initMobileBreakpoint);
          }

          if (this.mqlMediumUp) {
            this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
          }
        }
      });

      return Product;
    })();

    theme.ProductRecommendations = (function() {
      function ProductRecommendations(container) {
        var baseUrl = container.dataset.baseUrl;
        var productId = container.dataset.productId;
        var recommendationsSectionUrl =
            baseUrl +
            '?section_id=product-recommendations&product_id=' +
            productId +
            '&limit=4';

        window.performance.mark(
          'debut:product:fetch_product_recommendations.start'
        );

        fetch(recommendationsSectionUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(productHtml) {
          if (productHtml.trim() === '') return;

          container.innerHTML = productHtml;
          container.innerHTML = container.firstElementChild.innerHTML;

          window.performance.mark(
            'debut:product:fetch_product_recommendations.end'
          );

          performance.measure(
            'debut:product:fetch_product_recommendations',
            'debut:product:fetch_product_recommendations.start',
            'debut:product:fetch_product_recommendations.end'
          );
        });
      }

      return ProductRecommendations;
    })();

    theme.Quotes = (function() {
      var config = {
        mediaQuerySmall: 'screen and (max-width: 749px)',
        mediaQueryMediumUp: 'screen and (min-width: 750px)',
        slideCount: 0
      };

      var defaults = {
        canUseKeyboardArrows: false,
        type: 'slide',
        slidesToShow: 3
      };

      function Quotes(container) {
        this.container = container;
        var sectionId = container.getAttribute('data-section-id');
        this.slider = document.getElementById('Quotes-' + sectionId);

        this.sliderActive = false;

        this.mobileOptions = Object.assign({}, defaults, {
          canUseTouchEvents: true,
          slidesToShow: 1
        });

        this.desktopOptions = Object.assign({}, defaults, {
          slidesToShow: Math.min(
            defaults.slidesToShow,
            this.slider.getAttribute('data-count')
          )
        });

        this.initMobileSlider = this._initMobileSlider.bind(this);
        this.initDesktopSlider = this._initDesktopSlider.bind(this);

        this.mqlSmall = window.matchMedia(config.mediaQuerySmall);
        this.mqlSmall.addListener(this.initMobileSlider);

        this.mqlMediumUp = window.matchMedia(config.mediaQueryMediumUp);
        this.mqlMediumUp.addListener(this.initDesktopSlider);

        this.initMobileSlider();
        this.initDesktopSlider();
      }

      Quotes.prototype = Object.assign({}, Quotes.prototype, {
        onUnload: function() {
          this.mqlSmall.removeListener(this.initMobileSlider);
          this.mqlMediumUp.removeListener(this.initDesktopSlider);
          this.slideshow.destroy();
        },

        // eslint-disable-next-line no-unused-vars
        onBlockSelect: function(evt) {
          var slide = document.querySelector(
            '.quotes-slide--' + evt.detail.blockId
          );
          var slideIndex = Number(slide.getAttribute('data-slider-slide-index'));

          if (this.mqlMediumUp.matches) {
            slideIndex = Math.max(
              0,
              Math.min(slideIndex, this.slideshow.slides.length - 3)
            );
          }
          this.slideshow.goToSlideByIndex(slideIndex);
        },

        _initMobileSlider: function() {
          if (this.mqlSmall.matches) {
            this._initSlider(this.mobileOptions);
          }
        },

        _initDesktopSlider: function() {
          if (this.mqlMediumUp.matches) {
            this._initSlider(this.desktopOptions);
          }
        },

        // eslint-disable-next-line no-unused-vars
        _initSlider: function(args) {
          if (this.sliderActive) {
            this.slideshow.destroy();
            this.sliderActive = false;
          }

          this.slideshow = new theme.Slideshow(this.container, args);
          this.sliderActive = true;
        }
      });

      return Quotes;
    })();

    theme.SlideshowSection = (function() {
      var selectors = {
        sliderMobileContentIndex: '[data-slider-mobile-content-index]'
      };

      function SlideshowSection(container) {
        var sectionId = container.dataset.sectionId;

        this.container = container;
        this.eventHandlers = {};
        this.slideshowDom = container.querySelector('#Slideshow-' + sectionId);
        this.sliderMobileContentIndex = container.querySelectorAll(
          selectors.sliderMobileContentIndex
        );

        this.slideshow = new theme.Slideshow(container, {
          autoplay: this.slideshowDom.getAttribute('data-autorotate') === 'true',
          slideInterval: this.slideshowDom.getAttribute('data-speed')
        });
        this._setupEventListeners();
      }

      return SlideshowSection;
    })();

    theme.SlideshowSection.prototype = Object.assign(
      {},
      theme.SlideshowSection.prototype,
      {
        _setupEventListeners: function() {
          this.eventHandlers.onSliderSlideChanged = function(event) {
            this._onSliderSlideChanged(event.detail);
          }.bind(this);

          this.container.addEventListener(
            'slider_slide_changed',
            this.eventHandlers.onSliderSlideChanged
          );
        },

        _onSliderSlideChanged: function(slideIndex) {
          var activeClass = 'slideshow__text-content--mobile-active';

          this.sliderMobileContentIndex.forEach(function(element) {
            if (
              Number(element.getAttribute('data-slider-mobile-content-index')) ===
              slideIndex
            ) {
              element.classList.add(activeClass);
            } else {
              element.classList.remove(activeClass);
            }
          });
        },

        onUnload: function() {
          this.slideshow.destroy();
        },

        onBlockSelect: function(evt) {
          if (this.slideshow.adaptHeight) {
            this.slideshow.setSlideshowHeight();
          }

          // Get slide's index using theme editor's id
          var slide = this.container.querySelector(
            '.slideshow__slide--' + evt.detail.blockId
          );
          var slideIndex = slide.getAttribute('data-slider-slide-index');

          // Go to selected slide, pause auto-rotate
          this.slideshow.setSlide(slideIndex);
          this.slideshow.stopAutoplay();
        },

        onBlockDeselect: function() {
          // Resume auto-rotate
          this.slideshow.startAutoplay();
        }
      }
    );

    window.theme = window.theme || {};

    theme.StoreAvailability = (function() {
      var selectors = {
        storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
        storeAvailabilityModalProductTitle:
        '[data-store-availability-modal-product-title]',
        storeAvailabilityModalVariantTitle:
        '[data-store-availability-modal-variant-title]'
      };

      var classes = {
        hidden: 'hide'
      };

      function StoreAvailability(container) {
        this.container = container;
        this.productTitle = this.container.dataset.productTitle;
        this.hasOnlyDefaultVariant =
          this.container.dataset.hasOnlyDefaultVariant === 'true';
      }

      StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
        updateContent: function(variantId) {
          var variantSectionUrl =
              this.container.dataset.baseUrl +
              '/variants/' +
              variantId +
              '/?section_id=store-availability';
          var self = this;

          var storeAvailabilityModalOpen = self.container.querySelector(
            selectors.storeAvailabilityModalOpen
          );

          this.container.style.opacity = 0.5;
          if (storeAvailabilityModalOpen) {
            storeAvailabilityModalOpen.disabled = true;
            storeAvailabilityModalOpen.setAttribute('aria-busy', true);
          }

          fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(storeAvailabilityHTML) {
            if (storeAvailabilityHTML.trim() === '') {
              return;
            }
            self.container.innerHTML = storeAvailabilityHTML;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
            self.container.style.opacity = 1;

            // Need to query this again because we updated the DOM
            storeAvailabilityModalOpen = self.container.querySelector(
              selectors.storeAvailabilityModalOpen
            );

            if (!storeAvailabilityModalOpen) {
              return;
            }

            storeAvailabilityModalOpen.addEventListener(
              'click',
              self._onClickModalOpen.bind(self)
            );

            self.modal = self._initModal();
            self._updateProductTitle();
            if (self.hasOnlyDefaultVariant) {
              self._hideVariantTitle();
            }
          });
        },

        clearContent: function() {
          this.container.innerHTML = '';
        },

        _onClickModalOpen: function() {
          this.container.dispatchEvent(
            new CustomEvent('storeAvailabilityModalOpened', {
              bubbles: true,
              cancelable: true
            })
          );
        },

        _initModal: function() {
          return new window.Modals(
            'StoreAvailabilityModal',
            'store-availability-modal',
            {
              close: '.js-modal-close-store-availability-modal',
              closeModalOnClick: true,
              openClass: 'store-availabilities-modal--active'
            }
          );
        },

        _updateProductTitle: function() {
          var storeAvailabilityModalProductTitle = this.container.querySelector(
            selectors.storeAvailabilityModalProductTitle
          );
          storeAvailabilityModalProductTitle.textContent = this.productTitle;
        },

        _hideVariantTitle: function() {
          var storeAvailabilityModalVariantTitle = this.container.querySelector(
            selectors.storeAvailabilityModalVariantTitle
          );
          storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
        }
      });

      return StoreAvailability;
    })();

    theme.VideoSection = (function() {
      function VideoSection(container) {
        container.querySelectorAll('.video').forEach(function(el) {
          theme.Video.init(el);
          theme.Video.editorLoadVideo(el.id);
        });
      }

      return VideoSection;
    })();

    theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
      onUnload: function() {
        theme.Video.removeEvents();
      }
    });

    theme.heros = {};

    theme.HeroSection = (function() {
      function HeroSection(container) {
        var sectionId = container.getAttribute('data-section-id');
        var hero = '#Hero-' + sectionId;
        theme.heros[hero] = new theme.Hero(hero, sectionId);
      }

      return HeroSection;
    })();

    window.theme = window.theme || {};

    var selectors = {
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };

    theme.FooterSection = (function() {
      function Footer(container) {
        this.container = container;
        this.cache = {};
        this.cacheSelectors();

        if (this.cache.localeDisclosure) {
          this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
        }

        if (this.cache.currencyDisclosure) {
          this.currencyDisclosure = new theme.Disclosure(
            this.cache.currencyDisclosure
          );
        }
      }

      Footer.prototype = Object.assign({}, Footer.prototype, {
        cacheSelectors: function() {
          this.cache = {
            localeDisclosure: this.container.querySelector(
              selectors.disclosureLocale
            ),
            currencyDisclosure: this.container.querySelector(
              selectors.disclosureCurrency
            )
          };
        },

        onUnload: function() {
          if (this.cache.localeDisclosure) {
            this.localeDisclosure.destroy();
          }

          if (this.cache.currencyDisclosure) {
            this.currencyDisclosure.destroy();
          }
        }
      });

      return Footer;
    })();


    document.addEventListener('DOMContentLoaded', function() {
      var sections = new theme.Sections();

      sections.register('cart-template', theme.Cart);
      sections.register('product', theme.Product);
      sections.register('collection-template', theme.Filters);
      sections.register('product-template', theme.Product);
      sections.register('header-section', theme.HeaderSection);
      sections.register('map', theme.Maps);
      sections.register('slideshow-section', theme.SlideshowSection);
      sections.register('store-availability', theme.StoreAvailability);
      sections.register('video-section', theme.VideoSection);
      sections.register('quotes', theme.Quotes);
      sections.register('hero-section', theme.HeroSection);
      sections.register('product-recommendations', theme.ProductRecommendations);
      sections.register('footer-section', theme.FooterSection);

      theme.customerTemplates.init();

      // Theme-specific selectors to make tables scrollable
      var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

      slate.rte.wrapTable({
        tables: document.querySelectorAll(tableSelectors),
        tableWrapperClass: 'scrollable-wrapper'
      });

      // Theme-specific selectors to make iframes responsive
      var iframeSelectors =
          '.rte iframe[src*="youtube.com/embed"],' +
          '.rte iframe[src*="player.vimeo"],' +
          '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
          '.custom__item-inner--html iframe[src*="player.vimeo"]';

      slate.rte.wrapIframe({
        iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'video-wrapper'
      });

      // Common a11y fixes
      slate.a11y.pageLinkFocus(
        document.getElementById(window.location.hash.substr(1))
      );

      var inPageLink = document.querySelector('.in-page-link');
      if (inPageLink) {
        inPageLink.addEventListener('click', function(evt) {
          slate.a11y.pageLinkFocus(
            document.getElementById(evt.currentTarget.hash.substr(1))
          );
        });
      }

      document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(evt) {
          evt.preventDefault();
        });
      });

      slate.a11y.accessibleLinks({
        messages: {
          newWindow: theme.strings.newWindow,
          external: theme.strings.external,
          newWindowExternal: theme.strings.newWindowExternal
        },
        links: document.querySelectorAll(
          'a[href]:not([aria-describedby]), .product-single__thumbnail'
        )
      });

      theme.FormStatus.init();

      var selectors = {
        image: '[data-image]',
        lazyloaded: '.lazyloaded'
      };

      document.addEventListener('lazyloaded', function(evt) {
        var image = evt.target;

        removeImageLoadingAnimation(image);

        if (document.body.classList.contains('template-index')) {
          var mainContent = document.getElementById('MainContent');

          if (mainContent && mainContent.children && mainContent.children.length) {
            var firstSection = document.getElementsByClassName('index-section')[0];

            if (!firstSection.contains(image)) return;

            window.performance.mark('debut:index:first_image_visible');
          }
        }

        if (image.hasAttribute('data-bgset')) {
          var innerImage = image.querySelector(selectors.lazyloaded);

          if (innerImage) {
            var alt = image.getAttribute('data-alt');
            var src = innerImage.hasAttribute('data-src')
            ? innerImage.getAttribute('data-src')
            : image.getAttribute('data-bg');

            image.setAttribute('alt', alt ? alt : '');
            image.setAttribute('src', src ? src : '');
          }
        }

        if (!image.hasAttribute('data-image')) {
          return;
        }
      });

      // When the theme loads, lazysizes might load images before the "lazyloaded"
      // event listener has been attached. When this happens, the following function
      // hides the loading placeholders.
      function onLoadHideLazysizesAnimation() {
        var alreadyLazyloaded = document.querySelectorAll('.lazyloaded');
        alreadyLazyloaded.forEach(function(image) {
          removeImageLoadingAnimation(image);
        });
      }

      onLoadHideLazysizesAnimation();

      document.addEventListener(
        'touchstart',
        function() {
          theme.Helpers.setTouch();
        },
        { once: true }
      );

      if (document.fonts) {
        document.fonts.ready.then(function() {
          window.performance.mark('debut:fonts_loaded');
        });
      }
    });

    // Youtube API callback
    // eslint-disable-next-line no-unused-vars
    function onYouTubeIframeAPIReady() {
      theme.Video.loadVideos();
    }

    function removeImageLoadingAnimation(image) {
      // Remove loading animation
      var imageWrapper = image.hasAttribute('data-image-loading-animation')
      ? image
      : image.closest('[data-image-loading-animation]');

      if (imageWrapper) {
        imageWrapper.removeAttribute('data-image-loading-animation');
      }
    }




    $(document).ready(function(){
      $(".product-form").appendTo('.form-position');
    });

    function submitCart(){
      	$("button.btn.product-form__cart-submit").trigger('click');
    	console.log('here..');
    }


      $('.thumb_slider_desktop').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        vertical:true,
        arrows:true,
        verticalSwiping: true,
        prevArrow: '<div class="slider-arrow slider-prev fa fa-angle-left"></div>',
        nextArrow: '<div class="slider-arrow slider-next fa fa-angle-right"></div>'
      });

//     if($('.mobile_thumbslider > ul > li').length > 4){

//       $('.mobile_thumbslider > ul').slick({
//           dots: false,
//           infinite: true,
//           speed: 300,
//           slidesToShow: 4,
//           arrows:true,
//           verticalSwiping: true,
//           prevArrow: '<div class="slider-arrow slider-prev fa fa-angle-left"></div>',
//           nextArrow: '<div class="slider-arrow slider-next fa fa-angle-right"></div>'
//       });
    
//     }

    $('.thumb_slider_desktop li').click(function(){
      var thumb_img = $(this).attr("data-media-id");
      var main_image ="";
      $( ".product-single__media-wrapper").each(function() {
        var main_image = $(this).attr("data-media-id");
         console.log(main_image);
        if(thumb_img == main_image)
        {
          $(this).removeClass("hide").siblings().addClass("hide");
        }
       
      });
     
    });

    if(window.innerWidth <= 750){
      $('.thumb_slider_desktop ').remove()
    }